<template>
    <div id="app" class="w-full relative flex max-h-screen flex-growth-0">

        <div v-if="image_info" class="fixed px-4 py-4 flex items-center justify-center w-full h-screen overflow-hidden"
             style="z-index:140;background-color:rgba(0,0,0,0.7)">

            <div @click="image_info = null" class="opc fixed top-0 right-0 bg-white border border-black px-2 py-2"
                 style="z-index:145">
                <img src="@/assets/icons/times.svg" class="w-10 h-10 text-white" alt="">
            </div>

            <img style="width:100%;height:auto;max-width:730px" :src="image_info" alt="">

        </div>


        <div v-if="!menu_collapsed" @click="menu_collapsed = true"
             class="z-50 nopc bg-white px-2 py-2 fixed top-0 left-0 mt-16">
            <img src="@/assets/icons/bars.svg" class="w-5 h-5 text-black" alt="">
        </div>

        <div v-if="menu_collapsed" @click="menu_collapsed = false"
             class="nopc fixed top-0 right-0 bg-white border border-black px-2 py-2 z-130">
            <img src="@/assets/icons/times.svg" class="w-10 h-10 text-black" alt="">
        </div>

        <div class="side-menu flex-grow-0" :class="[menu_collapsed ? 'collapsed':'']">

            <div class="flex-1 items-center flex flex-grow-0">
                <!--            <div class="border-b-2  pb-1 ">-->

                <img @click="rp()" style="height:60px;width:auto" :src="'./assets/mocenok.jpeg'"
                     class="logo">


                <div class="flex-auto ml-2">


                    <input class="bg-white focus:outline-none focus:outline-none border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                           v-model="search" type="text" placeholder="Hľadať">

                    <!--                    <div class="flex mt-2">-->

                    <!--                        <div class="w-1/2 mr-3 flex py-2 items-center border justify-center filter-item"-->
                    <!--                             :class="[filter.road === false ? 'inactive' : '']"-->
                    <!--                             style="border-left:4px solid #e67e22" @click="collapseFilterItem('road')">-->
                    <!--                            <div>-->
                    <!--                                <svg aria-hidden="true" style="width:20px;height:20px;color:#e67e22" focusable="false"-->
                    <!--                                     data-prefix="fal" data-icon="biking" class="svg-inline&#45;&#45;fa fa-biking fa-w-20"-->
                    <!--                                     role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">-->
                    <!--                                    <path fill="currentColor"-->
                    <!--                                          d="M120 272a120 120 0 1 0 120 120 120 120 0 0 0-120-120zm0 208a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88zm400-208a120 120 0 1 0 120 120 120 120 0 0 0-120-120zm0 208a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88zM374.31 245.79a48.19 48.19 0 0 0 29.89 10.43H464a48 48 0 0 0 0-96h-42.95l-21.32-17.05a70.18 70.18 0 0 0 8.27.83 72.07 72.07 0 1 0-66.4-44.22 46.67 46.67 0 0 0-48.69 8l-99.25 79c-12.35 10.51-18.45 24.81-17.57 39.94a47.64 47.64 0 0 0 21.24 37.14L272 313.69V400a48 48 0 0 0 96 0V288a47.91 47.91 0 0 0-21.33-39.91l-13.33-9 16.5-12.72zM408 32a40 40 0 1 1-40 40 40 40 0 0 1 40-40zm-79.12 242.69A16 16 0 0 1 336 288v112a16 16 0 0 1-32 0V296.56l-88.88-59.25a16 16 0 0 1-1.53-25.45l100.2-79.78a16 16 0 0 1 20.41-.36l75.62 60.5H464a16 16 0 0 1 0 32h-59.8a16 16 0 0 1-10-3.5l-44.09-35-71.43 55.11z"></path>-->
                    <!--                                </svg>-->
                    <!--                            </div>-->
                    <!--                            <span class="ml-2 text-sm">Cyklotrasy</span>-->
                    <!--                        </div>-->

                    <!--                        <div class="w-1/2 ml-3 flex py-2 items-center border justify-center filter-item"-->
                    <!--                             :class="[filter.point === false ? 'inactive' : '']"-->
                    <!--                             style="border-left:4px solid brown" @click="collapseFilterItem('point')">-->
                    <!--                            <div>-->
                    <!--                                <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="monument"-->
                    <!--                                     style="width:20px;height:20px;color:brown"-->
                    <!--                                     class="svg-inline&#45;&#45;fa fa-monument fa-w-12" role="img"-->
                    <!--                                     xmlns="http://www.w3.org/2000/svg"-->
                    <!--                                     viewBox="0 0 384 512">-->
                    <!--                                    <path fill="currentColor"-->
                    <!--                                          d="M368 416h-48l-30.86-315.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69C200.19 1.56 196.09 0 192 0s-8.19 1.56-11.31 4.69L104.08 81.3a31.97 31.97 0 0 0-9.21 19.44L64 416H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM126.71 103.92l65.3-65.3 65.29 65.23L287.85 416H96.15l30.56-312.08zM352 480H32v-32h320v32zM232 256h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"></path>-->
                    <!--                                </svg>-->
                    <!--                            </div>-->
                    <!--                            <span class="ml-2 text-sm">Pamiatky</span>-->
                    <!--                        </div>-->


                    <!--                    </div>-->

                </div>

            </div>

            <div class=" pb-2 px-2 pt-2 flex-auto  overflow-y-auto midc">


                <div v-for="(item,itemindex) in showFilteredItems" :key="'map-list-item-'+itemindex"
                     class="list-item mb-4 w-full rounded overflow-hidden border shadow-lg"
                     :class="[selected_map === item.id ? 'bg-gray-200 border border-black':'']"
                     @mouseover="animateMarkerId = item.id"
                     @mouseleave="animateMarkerId = null"
                     @click="selectMap(item.id)"
                >


                    <div class="flex itmes-center">

                        <!--                        <img v-if="item.type !== 'road'" class="self-center" style="height:100px;width:100px"-->
                        <!--                             src="@/assets/card.jpg" alt="mocenok">-->

                        <div v-if="item.type !== 'road' && item.photo_mini"
                             class="flex flex-shrink-0 flex-grow-0 items-center justify-center"
                             style="width:100px!important;max-width:100px!important;">
                            <img style="width:100px!important;height:100px"
                                 class="self-center"
                                 :src="item.photo_mini">
                        </div>

                        <div v-else-if="item.type !== 'road'"
                             class="flex flex-shrink-0 flex-grow-0 items-center justify-center"
                             style="width:100px!important;max-width:100px!important;">
                            <img style="width:100px!important;height:100px"
                                 class="self-center"
                                 :src="item.photo_1">
                        </div>


                        <!--                        <div v-if="item.type !== 'road'"-->
                        <!--                             class="flex flex-shrink-0 flex-grow-0 items-center justify-center"-->
                        <!--                             style="width:100px!important;max-width:100px!important;">-->
                        <!--                            <img style="width:32px!important;height:32px"-->
                        <!--                                 class="self-center"-->
                        <!--                                 :src="item.icon">-->
                        <!--                        </div>-->


                        <div v-else class="flex flex-shrink-0 flex-grow-0 justify-center items-center"
                             style="width:100px">
                            <svg aria-hidden="true" style="width:32px;height:32px;"
                                 focusable="false"
                                 :style="[item.color ?{color:item.color}:{}]"
                                 data-prefix="fal" data-icon="biking" class="svg-inline--fa fa-biking fa-w-20"
                                 role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                <path fill="currentColor"
                                      d="M120 272a120 120 0 1 0 120 120 120 120 0 0 0-120-120zm0 208a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88zm400-208a120 120 0 1 0 120 120 120 120 0 0 0-120-120zm0 208a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88zM374.31 245.79a48.19 48.19 0 0 0 29.89 10.43H464a48 48 0 0 0 0-96h-42.95l-21.32-17.05a70.18 70.18 0 0 0 8.27.83 72.07 72.07 0 1 0-66.4-44.22 46.67 46.67 0 0 0-48.69 8l-99.25 79c-12.35 10.51-18.45 24.81-17.57 39.94a47.64 47.64 0 0 0 21.24 37.14L272 313.69V400a48 48 0 0 0 96 0V288a47.91 47.91 0 0 0-21.33-39.91l-13.33-9 16.5-12.72zM408 32a40 40 0 1 1-40 40 40 40 0 0 1 40-40zm-79.12 242.69A16 16 0 0 1 336 288v112a16 16 0 0 1-32 0V296.56l-88.88-59.25a16 16 0 0 1-1.53-25.45l100.2-79.78a16 16 0 0 1 20.41-.36l75.62 60.5H464a16 16 0 0 1 0 32h-59.8a16 16 0 0 1-10-3.5l-44.09-35-71.43 55.11z"></path>
                            </svg>
                        </div>

                        <div class="flex items-center">
                            <div class="px-2   py-2">
                                <div class="font-bold text-base mb-1">
                                    {{item.title}}
                                </div>
                                <!--                                <p class="text-gray-700 text-sm">-->
                                <!--                                    {{item.description}}-->
                                <!--                                </p>-->
                            </div>

                        </div>

                    </div>


                </div>


            </div>

            <div style="margin:0 -.5rem"
                 class="flex-grow-0 text-xs border-t-2 border-black flex-1 flex text-black opacity-75 items-center text-center py-2 px-12">

                <img style="height:60px;width:auto" :src="'./assets/nrspr.png'" class="">

                <div class="flex items-center justify-center px-4">
                    <span class="text-xs">
                          Tento projekt je spolufinancovaný z rozpočtu Nitrianskeho samosprávneho kraja
                    </span>
                </div>


            </div>

            <div class="flex-grow-0 text-center text-white bg-black py-1 text-sm" style="margin:0 -.5rem">
                &#169; <a target="_blank" href="www.standberg.sk">standberg</a>
            </div>

        </div>

        <cyklotrasy-map @show-full-image="fullScreenImage" :items="displayFilteredItems"
                        :animateMarkerId="animateMarkerId"/>


    </div>
</template>

<script>

    // @ is an alias to /src
    import MyMap from '@/components/map'

    import SVG_bike from '@/assets/icons/c_bike.svg'
    import SVG_monument from '@/assets/icons/c_monument.svg'
    // import SVG_times from '@/assets/icons/times.svg'
    // import SVG_bars from '@/assets/icons/bars.svg'

    export default {
        name: 'Home',
        components: {
            'cyklotrasy-map': MyMap,
            SVG_bike,
            SVG_monument,
            // SVG_times,
            // SVG_bars
        },
        data() {
            return {
                menu_collapsed: false,
                image_info: null,
                search: '',
                filter: {
                    road: true,
                    point: true
                },
                items: [
                    {
                        id: 1,
                        type: 'point',
                        title: 'Socha sv. Floriána',
                        description: 'Neďaleko vchodu do areálu kaštieľa na Ulici sv. Gorazda stojí Socha sv. Floriána vyhotovená z tufového kameňa.\n' +
                            '\n' +
                            'Postavu sv. Floriána, patróna hasičov a ochrancu pred ohňom a inými živelnými pohromami, dal vyhotoviť Jozef Kluch v roku 1816. Svätý je zachytený vo zvyčajnom rímskom vojenskom odeve. S džberom v pravej ruke hasí dom, ľavou rukou pridržiava zástavu. Skulptúra sa napriek „neskorému“ datovaniu verne pridržiava barokových vzorov.\n' +
                            '\n' +
                            'Tufový kameň patrí medzi nestále horniny a nie je vhodný do exteriéru. Vplyvom počasia nastala výrazná  deštrukcia povrchu kamennej hmoty. V roku 2016 dala obec sochu zrekonštruovať. Reštaurátor (Martin Mikuláš) z diela odstránil všetky cementové tmely a mikroflóru. Vzhľadom k tomu, že socha bola značne poškodená a niektoré časti chýbali, vytvoril faksimile sochy a podstavca s doplnením chýbajúcich častí modelácie. Odliatok vyhotovený z umelého kameňa formou výdusku je charakterom a farebnosťou povrchovej úpravy identický s materiálom originálu diela.\n',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.230764,
                            lng: 17.927070
                        },
                        photo_1: './assets/images/1/1.jpg',
                        photo_2: './assets/images/1/1.jpg',
                        photo_mini: './assets/images/1/1_mini.jpg',
                        icon: './assets/icons/monument.svg',
                    },

                    {
                        id: 2,
                        type: 'point',
                        title: 'Kaštieľ',
                        description: 'Areál okolo niekdajšieho letného sídla nitrianskych biskupov v historickom jadre obce bol vytvorený v duchu barokových princípov komponovania priestoru. Hlavnou kompozičnou osou je pomyselná spojnica medzi Kostolom sv. Klimenta a kaštieľom.\n' +
                            '\n' +
                            'Neskoroklasicistický kaštieľ sa nachádza v západnej časti lichobežníkového priestoru ohradeného pôvodným liatinovým a murovaným oplotením.\n' +
                            '\n' +
                            'Kaštieľ v Močenku je jedným z mála autenticky zachovaných vidieckych aristokratických sídel na Slovensku. Po dvoch svetových vojnách sa nestal terčom rabovania, neboli doň vnesené nevhodné funkcie, zostal živým a udržiavaným objektom. V rokoch 1910 - 1911, v čase veľkej renovácie hradného paláca v Nitre, sa stal kaštieľ prechodným sídlom hlavy Nitrianskej diecézy. Biskup Karol Kmeťko dal kaštieľ do užívania Spoločnosti Božieho Slova, od roku 1928 boli priestory na prízemí a park prenajaté noviciátu Kongregácie bratov kresťanských škôl.\n' +
                            'V rámci akcie „K“ (3. - 4. 5. 1950) zameranej na likvidáciu kláštorov sa kaštieľ zmenil na internačné stredisko rehoľníkov, neskôr aj rádových sestier. Desaťročia v ňom fungoval charitný dom slúžiaci opatere starších rehoľníčok. V roku 2003 areál prevzala Komunita Kráľovej pokoja.\n',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.231566,
                            lng: 17.926898
                        },
                        photo_1: './assets/images/2/2.jpg',
                        photo_2: './assets/images/2/2.jpg',
                        photo_mini: './assets/images/2/2_mini.jpg',
                        icon: './assets/icons/church.svg',
                    },

                    {
                        id: 7,
                        type: 'point',
                        title: 'Farský Kostol sv. Klimenta',
                        description: 'Základný kameň Kostola sv. Klimenta posvätil biskup Imrich Esterházi 30. marca 1761, krátko po tom, čo požiar zničil starší farský kostol, ktorý stál v priestore dnešnej Kalvárie. Hrubá stavba bola do Esterháziho smrti (1763) takmer hotová, jej dokončenie sa viaže k Jánovi Gustínimu, ktorý ju požehnal v roku 1765. Úpravy a zariaďovanie interiéru trvali až do začiatku 80. rokov 18. storočia. Kostol 1. novembra 1782 posvätil nitriansky biskup, gróf Anton Révai.\n' +
                            '\n' +
                            'Architektúra teda vznikala v dvoch fázach, pričom skoršia jej dala podobu, zachovanú do roku 1926. Práce v druhej, mladšej fáze sa koncentrovali na interiér a okolie. V čase Gustíniho vizitácie (1767) bol kostol vybavený oltármi pochádzajúcimi zo staršieho objektu. Hlavný oltár zdobil obraz svätého patróna s postavami detí nesúcimi jeho atribút (kotvu) a symbol mučeníctva (palmovú ratolesť).\n' +
                            '\n' +
                            'Zvony sv. Jána Evanjelistu, sv. Klimenta a Panny Márie odlial Matej Orfandl v Trnave. Vo veži sa okrem nich nachádzal aj starší zvon z bratislavskej dielne Jána Ernesta Cristalliho. Ohradový múr so šindľovou strieškou postavili pred rokom 1778. Nad vstupom v západnej časti interiéru sa dvíha dvojpodlažná empora. Vyššie podlažie bolo vyhradené školskej mládeži, na dolnom v roku 1792 inštalovali organ zo známej dielne Pažických v Revúcej.\n' +
                            '\n' +
                            'Projekt výstavby dvoch bočných lodí pripravil v roku 1926 architekt Michal Milan Harminc.\n' +
                            '\n' +
                            'V júli 1983 boli inštalované nové zvony na počesť sv. Klimenta, sv. Cyrila a Metoda a sv. Gorazda.\n',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.232648,
                            lng: 17.9313027
                        },
                        photo_1: './assets/images/7/7.jpg',
                        photo_2: './assets/images/7/7.jpg',
                        photo_mini: './assets/images/7/7_mini.jpg',
                        icon: './assets/icons/church.svg',
                    },
                    {
                        id: 8,
                        type: 'point',
                        title: 'Kláštor',
                        description: 'Na južnej strane parku pred Kostolom sv. Klimenta stojí historizujúca budova kláštora a školy Spoločnosti dcér kresťanskej lásky sv. Vincenta de Paul. Jednoposchodový objekt s trojtraktovou dispozíciou má klasicizujúco striedmy, symetricky členený vonkajší plášť. Stredné časti dlhších fasád sú zvýraznené rizalitmi, plytkým, trojosovým v priečelí orientovanom do parku a päťbokým na južnej fasáde súbežnej so Školskou ulicou. Tvar tohto rizalitu sa prispôsobuje záveru Kaplnky sv. Gorazda (pôvodne sv. Imricha) umiestnenej na poschodí.\n' +
                            '\n' +
                            'Základný kameň kláštora a školy položili 13. júla 1897. Stavba vznikala v rokoch 1897 – 1899 pod vedením staviteľa  K. Mayera z Nitry.  \n' +
                            'Vincentky pôsobili v Močenku do augusta 1950, keď ich v rámci akcie „R“ sledujúcej likvidáciu ženských reholí odsunuli do Belušských Slatín. Budovu prevzal štát, v jej areáli sa v roku 1960 začalo s výstavbou novej školy. Niekdajší kláštor od roku 1987 slúži kultúre.\n' +
                            '\n' +
                            'Po novembri 1989 sa budova opäť stala majetkom farského úradu, ale v bezplatnom prenájme ju naďalej využívala obec. Kláštor prešiel v rokoch 2010 – 2013 kompletnou rekonštrukciou, ktorú finančne zabezpečila obec Močenok.\n',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.2319444,
                            lng: 17.93166666666667
                        },
                        photo_1: './assets/images/8/8.jpg',
                        photo_2: './assets/images/8/8.jpg',
                        photo_mini: './assets/images/8/8_mini.jpg',
                        // icon: './assets/icons/archway.svg',
                        icon: './assets/icons/church.svg',
                    },
                    {
                        id: 9,
                        type: 'point',
                        title: 'Súsošie Najsvätejšej Trojice',
                        description: 'Súsošie Najsvätejšej Trojice v parku pri rozvetvení Ulice sv. Gorazda a Hájskej ulice dal vztýčiť Ondrej Straňák v roku 1851 z vďaky za prekonanie morovej epidémie (1849).\n' +
                            '\n' +
                            'Štvorhranný, hore sa zužujúci pilier spočíva na hranolovej podnoži s akrotériami a v jeho čelnej stene je zapustená nápisová tabuľa s chronostikonom. Hlavica – podstavec pre súsošie – má kvádrovú formu s rohmi ovinutými štylizovaným akantom.\n' +
                            '\n' +
                            'Celok predstavujúci osobitné spojenie oneskorených barokových a klasicistických detailov korunuje súsošie tróniaceho Boha Otca a Krista, nad ktorými sa vznáša holubica Ducha Svätého.\n' +
                            '\n' +
                            'Kompozíciu dotvárajú lúče z medeného plechu. Dnešný vzhľad trojičného stĺpu je výsledkom obnovy v roku 2001. Objekt vtedy umiestnili na zvýšené kruhové plató s balustrovou ohradou realizovanou Jánom Stachom.\n',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.225,
                            lng: 17.930833333333336
                        },
                        photo_1: './assets/images/9/9.jpg',
                        photo_2: './assets/images/9/9.jpg',
                        photo_mini: './assets/images/9/9_mini.jpg',
                        icon: './assets/icons/monument.svg',
                    },
                    {
                        id: 10,
                        type: 'point',
                        title: 'Kalvária',
                        description: 'Návršie nad Dlhým kanálom severozápadne od areálu kaštieľa sa tradične spája s existenciou staršieho Kostola sv. Klimenta. V roku 1852 vznikla na tomto priestranstve Kalvária, ktorej vznik podnietil farár Jozef Ščasný, spoluzakladateľ Matice slovenskej a Spolku sv. Vojtecha. Pamiatku tvorí štrnásť murovaných zastavení krížovej cesty rozmiestnených do dvoch súbežných radov, Kaplnka Božieho hrobu a súsošie Golgoty. Kalvária v Močenku prezentuje neskorý príklad súborov tohto typu situovaných do krajiny, ktoré sa na našom území rozšírili v 17.-18. storočí pod vplyvom protireformácie.\n' +
                            '\n' +
                            'V západnom ukončení areálu postavili Kaplnku Božieho hrobu, stavbu na štvorcovom pôdoryse, vo vnútri zaklenutú krížovou klenbou. Jej vonkajšie nárožia zvýrazňujú ploché lizénové pásy, na ktoré sa napája omietkový oblúčkový vlys pod korunnou rímsou. Na tunajšom oltári sa nachádza obraz Ukladanie do hrobu od nitrianskeho maliara – samouka Ľudovíta Nyulassyho  z roku 1858.\n' +
                            '\n' +
                            'Iniciátorom generálnej obnovy Kalvárie v roku 1974 bol vtedajší farár Alojz Dubravický. Došlo k výmene krovu Kaplnky Božieho hrobu, k položeniu novej pálenej krytiny a staré omietky odstránili až po tehlu.\n' +
                            '\n' +
                            'V zastaveniach inštalovali maľby Jána Stacha. V spolupráci obce a farského úradu v roku 2007 vymenili šindeľ na helmici za plech, obnovili omietky a nátery.\n',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.232855,
                            lng: 17.925225
                        },
                        photo_1: './assets/images/10/10.jpg',
                        photo_2: './assets/images/10/10.jpg',
                        photo_mini: './assets/images/10/10_mini.jpg',
                        icon: './assets/icons/map-marker.svg',
                    },
                    {
                        id: 123,
                        type: 'point',
                        title: 'Kríž v Chotári',
                        description: '',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.2030556,
                            lng: 17.891944444444444
                        },
                        photo_1: './assets/images/123/123.jpg',
                        photo_2: './assets/images/123/123.jpg',
                        photo_mini: './assets/images/123/123_mini.jpg',
                        icon: './assets/icons/map-marker.svg',
                    },
                    {
                        id: 11,
                        type: 'point',
                        title: 'Socha sv. Vendelína',
                        description: 'Sv. Vendelín je patrón životného prostredia, ochrancov prírody, pastierov, roľníkov. Prihovára sa za priaznivé počasie, dobrú úrodu a chráni zvieratá pred chorobami.\n' +
                            '\n' +
                            'Rustikálna (ľudová) socha tohto svätca stojí pri ceste do Šale. Na celú sochu bol v minulosti nanesený cementovo-vápenný tmel, ktorý nevhodne prekrýval poškodenia kamennej hmoty a spolu so zvetrávaním zapríčinil rozrušenie jej povrchu. Na diele sa nachádzala rozsiahlo rozrastená vrstva machu a lišajníkov. Pôvodný kamenný povrch bol už značne degradovaný.\n' +
                            '\n' +
                            'V roku 2018 zabezpečila obec reštaurovanie sochy. Reštaurátor (Martin Mikuláš) odstránil všetky sekundárne doplnky, farebné vrstvy, tmely a nevhodne domodelované chýbajúce časti. Po očistení a tmelení spevnil kamennú hmotu pomocou vákuovej petrifikácie. Nasledovalo retušovanie tmelených miest a farebné scelenie kamenného povrchu.\n',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.2216667,
                            lng: 17.93138888888889
                        },
                        photo_1: './assets/images/11/11.jpg',
                        photo_2: './assets/images/11/11.jpg',
                        photo_mini: './assets/images/11/11_mini.jpg',
                        icon: './assets/icons/monument.svg',
                    },

                    {
                        id: 12,
                        type: 'point',
                        title: 'Kaplnka sv. Gorazda v Gorazdove',
                        description: 'V najpravdepodobnejšom rodisku sv. Gorazda, v Gorazdove, obec Močenok postavila v roku 1994 Kaplnku sv. Gorazda.\n' +
                            '\n' +
                            'Základný kameň posvätil Mons. František Rábek, pomocný biskup Nitrianskej diecézy, v júli 1993, a to počas prvého ročníka festivalu kresťanského divadla Gorazdov Močenok. Na jeseň začala stavbu realizovať obec Močenok s pomocou Štátneho majetku Trnovec nad Váhom a pracovníkov stavebnej skupiny obce Močenok.\n' +
                            '\n' +
                            'V roku 1994 Kaplnku sv. Gorazda posvätil J. Em. Ján Chryzostom kardinál Korec, nitriansky sídelný biskup.\n' +
                            '\n' +
                            'Projekt zdarma pripravili architekt Ing. arch. Stanislav Babčan a statik Ing. Milan Vaňuš. Podľa  Ing. arch. Stanislava Babčana ho pri navrhovaní projektu kaplnky inšpirovalo niekoľko podnetov naraz: „V roku 1993 ma oslovil vtedajší starosta Močenka Ing. Jozef Šuvada s úmyslom realizácie kaplnky, ktorá má pripomínať začiatky kresťanstva na našom území a prvého svätca zo slovenského územia, žiaka sv. Cyrila a Metoda.\n' +
                            ' \n' +
                            'Tvorí ju vertikála veže s krížovým pôdorysom v hornej časti s výrezom pre zvon a dolu sa nachádzajú ,mini románske, kaplnky pre sošku sv. Gorazda. Tento priestor je upravený na meditáciu. Predpolie kaplnky vytvára priestor na slúženie sv. omše. Pozadie tvorí zemný val symbolizujúci otvorenú náruč objímajúcu kaplnku a vítajúcu pútnikov.“\n',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.1922222,
                            lng: 17.955555555555556
                        },
                        photo_1: './assets/images/12/12.jpg',
                        photo_2: './assets/images/12/12.jpg',
                        photo_mini: './assets/images/12/12_mini.jpg',
                        icon: './assets/icons/church.svg',
                    },

                    {
                        id: 13,
                        type: 'point',
                        title: 'Kostol sv. Kríža',
                        description: 'Kostol sa nachádza v susedstve  tzv. horného cintorína. Predstavuje barokové jednolodie s polygonálne ukončenou svätyňou na západe a zvonovou vežičkou nad štítom východného priečelia.\n' +
                            '\n' +
                            'Vnútorný priestor vrátane sakristie pri južnej stene presbytéria je zaklenutý pruskými klenbami. Vo východnej časti stojí murovaná organová empora, otvárajúca sa do lode troma arkádami.\n' +
                            '\n' +
                            'Pod loďou je krypta so symbolickým náhrobkom nitrianskeho biskupa Jozefa Klucha, ktorý zomrel  26. 12. 1826 v Močenku. Bočné fasády člení pravidelný sled širokých lizénových pásov vybiehajúcich zo sokla obloženého kameňom. Hlavná fasáda zavŕšená vykrajovaným štítom je symetrická, so stredným poľom vystupujúcim z roviny steny ako plytký rizalit.\n' +
                            '\n' +
                            'Založenie Kostola sv. Kríža, rspektíve jeho predchodcu, v roku 1792 možno uviesť do súvisu s otvorením horného cintorína. Kostol slúžil veriacim z Hornej Kráľovej, počas budovania nového Kostola sv. Klimenta však plnil i funkciu farského chrámu.\n' +
                            '\n' +
                            'Dnešná podoba stavby pochádza z roku 1747. Z obdobia pred polovicou 18. storočia pochádzajú niektoré remeselné detaily, medzi nimi dverové krídlo vo vstupe zo svätyne do sakristie či prevliekané mreže v oknách tohto priestoru.\n',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.2330556,
                            lng: 17.92138888888889
                        },
                        photo_1: './assets/images/13/13.jpg',
                        photo_2: './assets/images/13/13.jpg',
                        photo_mini: './assets/images/13/13_mini.jpg',
                        icon: './assets/icons/church.svg',
                    },

                    {
                        id: 14,
                        type: 'point',
                        title: 'Penzión Anup s možnosťou opravy bicyklov',
                        description: '',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.229708,
                            lng: 17.927615
                        },
                        photo_1: './assets/images/14/14.jpg',
                        photo_2: './assets/images/14/14.jpg',
                        photo_mini: './assets/images/14/14_mini.jpg',
                        icon: './assets/icons/map-marker.svg',
                    },
                    {
                        id: 15,
                        type: 'point',
                        title: 'Kaplnka sv. Urbana',
                        description: 'Murovanú kaplnku zasvätenú patrónovi vinohradníkov dal postaviť miestny gazda Ján Bleho v roku 1748. Pozostáva zo štvorcovej lode s pruskou klenbou, trojbokej svätyne na východe a trojpodlažnej zvonice na západe. Jediný vstup do interiéru vedie cez podvežie. V nike v priečelí osadili sochu sv. Urbana.\n' +
                            '     Základný kameň stavby 8. mája 1748 požehnal nitriansky kanonik Ignác Holzpeck, 25. mája 1750 ju benedikoval Andrej Tóth, farár z Jarku, za asistencie farára Juraja Lackoviča z Močenka a Jozefa Jelenčiča z Veľkého Zálužia. Zakladateľ v roku 1758 daroval kaplnke Zvon sv. Urbana.\n' +
                            '     Nad murovanou oltárnou menzou vo svätyni visel obraz sv. Urbana namaľovaný na plátne. Podľa Gustíniho sa tu v minulosti nachádzali aj dve staré drevené sochy a kríž.\n' +
                            '     Prvá veľká obnova (podľa Wuruma prestavba — reaedificatio) kaplnky sa uskutočnila v roku 1796 vďaka príspevkom veriacich z Močenka a Hornej Kráľovej. Zrenovovaný objekt posvätil nitriansky kanonik Anton Šafarovič. Inšpektor Karol Szászy z Močenka dal v roku 1822 vyhotoviť maľbu svätého patróna v zlátenom ráme. Kaplnka dostala v roku 1870 novú krytinu, o 12 rokov neskôr Ferdinand Salzmann z Paty namaľoval nový obraz sv. Urbana. A. Bartošík v roku 1898 volal po obnove objektu poškodeného „vodou, zrážkami a zimou“.\n' +
                            '     V roku 1974 boli odstránené staré omietky, opravila sa strecha, rímsy oplechovali. Do výklenku nad oltárnym stolom umiestnili sochu Sedembolestnej Panny Márie. Renovácie kaplnky na prelome 20.— 21. storočia sa realizovali v spolupráci miestneho poľovníckeho združenia a obce.\n' +
                            '     Stavbu odvodnili (1999), nasledovalo obitie zavlhnutej omietky a nanesenie novej (2001). V roku 2011 sa prikročilo k výmene strešnej krytiny, obnove fasády, úpravám odvodňovacích žľabov a najbližšieho okolia.',
                        photo: '',
                        label: '',
                        path: [],
                        position: {
                            lat: 48.235664,
                            lng: 17.951660
                        },
                        photo_1: './assets/images/15/15.jpg',
                        photo_2: './assets/images/15/15.jpg',
                        photo_mini: './assets/images/15/15_mini.jpg',
                        icon: './assets/icons/church.svg',
                    },

                    {
                        color: '#fffa65',
                        id: 3,
                        type: 'road', // road
                        title: 'Močenok - priehrada',
                        description: '',
                        photo: '',
                        label: '',
                        tags: ['cc1', 'cc2', 'cc3'],
                        path: [
                            {
                                "lat": 48.2319096476,
                                "lng": 17.9320679605
                            },
                            {
                                "lat": 48.2317775488,
                                "lng": 17.9323120415
                            },
                            {
                                "lat": 48.2316441089,
                                "lng": 17.9321859777
                            },
                            {
                                "lat": 48.2314972579,
                                "lng": 17.9320035875
                            },
                            {
                                "lat": 48.2313906401,
                                "lng": 17.931869477
                            },
                            {
                                "lat": 48.2312900573,
                                "lng": 17.9317300022
                            },
                            {
                                "lat": 48.2311934978,
                                "lng": 17.9316549003
                            },
                            {
                                "lat": 48.231061399,
                                "lng": 17.9315368831
                            },
                            {
                                "lat": 48.2309795916,
                                "lng": 17.9315315187
                            },
                            {
                                "lat": 48.2309111953,
                                "lng": 17.9315315187
                            },
                            {
                                "lat": 48.2308468223,
                                "lng": 17.9314523935
                            },
                            {
                                "lat": 48.2307388633,
                                "lng": 17.9312056303
                            },
                            {
                                "lat": 48.2306557149,
                                "lng": 17.9309856892
                            },
                            {
                                "lat": 48.2305397093,
                                "lng": 17.9306356609
                            },
                            {
                                "lat": 48.2304257154,
                                "lng": 17.9303513467
                            },
                            {
                                "lat": 48.2302895933,
                                "lng": 17.9300294816
                            },
                            {
                                "lat": 48.2302540541,
                                "lng": 17.9299168289
                            },
                            {
                                "lat": 48.230215162,
                                "lng": 17.9296955466
                            },
                            {
                                "lat": 48.2301749289,
                                "lng": 17.9294393957
                            },
                            {
                                "lat": 48.2301360369,
                                "lng": 17.9291792214
                            },
                            {
                                "lat": 48.2301072031,
                                "lng": 17.9289351404
                            },
                            {
                                "lat": 48.2300736755,
                                "lng": 17.9287219048
                            },
                            {
                                "lat": 48.2300321013,
                                "lng": 17.9285703599
                            },
                            {
                                "lat": 48.229965046,
                                "lng": 17.9283718765
                            },
                            {
                                "lat": 48.2298745215,
                                "lng": 17.9281465709
                            },
                            {
                                "lat": 48.2298181951,
                                "lng": 17.9279480875
                            },
                            {
                                "lat": 48.2297645509,
                                "lng": 17.927749604
                            },
                            {
                                "lat": 48.2297323644,
                                "lng": 17.9277335107
                            },
                            {
                                "lat": 48.229643181,
                                "lng": 17.9278086126
                            },
                            {
                                "lat": 48.2295358926,
                                "lng": 17.9278622568
                            },
                            {
                                "lat": 48.2294446975,
                                "lng": 17.9278206825
                            },
                            {
                                "lat": 48.2294104993,
                                "lng": 17.9276959598
                            },
                            {
                                "lat": 48.2293548435,
                                "lng": 17.9275940359
                            },
                            {
                                "lat": 48.2292884588,
                                "lng": 17.9274089634
                            },
                            {
                                "lat": 48.2291905582,
                                "lng": 17.927172929
                            },
                            {
                                "lat": 48.2291033864,
                                "lng": 17.9269127548
                            },
                            {
                                "lat": 48.2289712876,
                                "lng": 17.926633805
                            },
                            {
                                "lat": 48.2288747281,
                                "lng": 17.9265157878
                            },
                            {
                                "lat": 48.2287748158,
                                "lng": 17.9263602197
                            },
                            {
                                "lat": 48.2286675274,
                                "lng": 17.9262314737
                            },
                            {
                                "lat": 48.228513971,
                                "lng": 17.9260544479
                            },
                            {
                                "lat": 48.2283812016,
                                "lng": 17.9258935153
                            },
                            {
                                "lat": 48.2282564789,
                                "lng": 17.9257164896
                            },
                            {
                                "lat": 48.2281632721,
                                "lng": 17.9256038368
                            },
                            {
                                "lat": 48.2281136513,
                                "lng": 17.9254965484
                            },
                            {
                                "lat": 48.2280774415,
                                "lng": 17.9253892601
                            },
                            {
                                "lat": 48.228052631,
                                "lng": 17.9252672195
                            },
                            {
                                "lat": 48.2280237973,
                                "lng": 17.925029844
                            },
                            {
                                "lat": 48.2280311733,
                                "lng": 17.9248152673
                            },
                            {
                                "lat": 48.2280204445,
                                "lng": 17.9246543348
                            },
                            {
                                "lat": 48.2280385494,
                                "lng": 17.9245041311
                            },
                            {
                                "lat": 48.2281243801,
                                "lng": 17.9242841899
                            },
                            {
                                "lat": 48.2282209396,
                                "lng": 17.9240642488
                            },
                            {
                                "lat": 48.2282853127,
                                "lng": 17.9239247739
                            },
                            {
                                "lat": 48.2284636796,
                                "lng": 17.9237262905
                            },
                            {
                                "lat": 48.2287137955,
                                "lng": 17.9234795272
                            },
                            {
                                "lat": 48.228867352,
                                "lng": 17.9233293235
                            },
                            {
                                "lat": 48.229142949,
                                "lng": 17.9230450094
                            },
                            {
                                "lat": 48.2294748724,
                                "lng": 17.922707051
                            },
                            {
                                "lat": 48.2297927141,
                                "lng": 17.9223637283
                            },
                            {
                                "lat": 48.2299288362,
                                "lng": 17.922218889
                            },
                            {
                                "lat": 48.2302647829,
                                "lng": 17.9219184816
                            },
                            {
                                "lat": 48.2304646075,
                                "lng": 17.9217414558
                            },
                            {
                                "lat": 48.2306469977,
                                "lng": 17.9215429723
                            },
                            {
                                "lat": 48.2308045775,
                                "lng": 17.9214088619
                            },
                            {
                                "lat": 48.2311009616,
                                "lng": 17.9212425649
                            },
                            {
                                "lat": 48.2313403487,
                                "lng": 17.9210977256
                            },
                            {
                                "lat": 48.2316997647,
                                "lng": 17.9209032655
                            },
                            {
                                "lat": 48.2319679856,
                                "lng": 17.9207544029
                            },
                            {
                                "lat": 48.231934458,
                                "lng": 17.9206551611
                            },
                            {
                                "lat": 48.2318513095,
                                "lng": 17.9204593599
                            },
                            {
                                "lat": 48.2317902893,
                                "lng": 17.9202608764
                            },
                            {
                                "lat": 48.2316944003,
                                "lng": 17.9200355709
                            },
                            {
                                "lat": 48.2315656543,
                                "lng": 17.91976735
                            },
                            {
                                "lat": 48.2314583659,
                                "lng": 17.9194830358
                            },
                            {
                                "lat": 48.2313980162,
                                "lng": 17.9193851352
                            },
                            {
                                "lat": 48.2313437015,
                                "lng": 17.919241637
                            },
                            {
                                "lat": 48.2313403487,
                                "lng": 17.9191611707
                            },
                            {
                                "lat": 48.2314047217,
                                "lng": 17.9190485179
                            },
                            {
                                "lat": 48.2315830886,
                                "lng": 17.9190056026
                            },
                            {
                                "lat": 48.2316119224,
                                "lng": 17.918882221
                            },
                            {
                                "lat": 48.2314711064,
                                "lng": 17.918612659
                            },
                            {
                                "lat": 48.2312303782,
                                "lng": 17.918125838
                            },
                            {
                                "lat": 48.2310131192,
                                "lng": 17.9176685214
                            },
                            {
                                "lat": 48.2307435572,
                                "lng": 17.9170811176
                            },
                            {
                                "lat": 48.2304833829,
                                "lng": 17.9165366292
                            },
                            {
                                "lat": 48.2303211093,
                                "lng": 17.9161946476
                            },
                            {
                                "lat": 48.2300917804,
                                "lng": 17.9156850278
                            },
                            {
                                "lat": 48.2299301773,
                                "lng": 17.9153309762
                            },
                            {
                                "lat": 48.2297732681,
                                "lng": 17.9149930179
                            },
                            {
                                "lat": 48.2296418399,
                                "lng": 17.9147610068
                            },
                            {
                                "lat": 48.2294782251,
                                "lng": 17.9144673049
                            },
                            {
                                "lat": 48.2292609662,
                                "lng": 17.9140864313
                            },
                            {
                                "lat": 48.2290691882,
                                "lng": 17.9137484729
                            },
                            {
                                "lat": 48.2289860398,
                                "lng": 17.9136304557
                            },
                            {
                                "lat": 48.2288693637,
                                "lng": 17.9134266078
                            },
                            {
                                "lat": 48.2286205888,
                                "lng": 17.913056463
                            },
                            {
                                "lat": 48.228431493,
                                "lng": 17.9127399623
                            },
                            {
                                "lat": 48.2282169163,
                                "lng": 17.9124127328
                            },
                            {
                                "lat": 48.2280419022,
                                "lng": 17.9121284187
                            },
                            {
                                "lat": 48.227872923,
                                "lng": 17.911876291
                            },
                            {
                                "lat": 48.2277562469,
                                "lng": 17.911683172
                            },
                            {
                                "lat": 48.2276241481,
                                "lng": 17.911452502
                            },
                            {
                                "lat": 48.2274699211,
                                "lng": 17.9112111032
                            },
                            {
                                "lat": 48.2273270935,
                                "lng": 17.9109536111
                            },
                            {
                                "lat": 48.2272090763,
                                "lng": 17.9107014835
                            },
                            {
                                "lat": 48.2270555198,
                                "lng": 17.9104010761
                            },
                            {
                                "lat": 48.226916045,
                                "lng": 17.9100845754
                            },
                            {
                                "lat": 48.2267732173,
                                "lng": 17.909848541
                            },
                            {
                                "lat": 48.2265948504,
                                "lng": 17.9096125066
                            },
                            {
                                "lat": 48.2263621688,
                                "lng": 17.9093067348
                            },
                            {
                                "lat": 48.2260657847,
                                "lng": 17.9088896513
                            },
                            {
                                "lat": 48.2258612663,
                                "lng": 17.9085771739
                            },
                            {
                                "lat": 48.225589022,
                                "lng": 17.9082177579
                            },
                            {
                                "lat": 48.2253368944,
                                "lng": 17.9078529775
                            },
                            {
                                "lat": 48.2250183821,
                                "lng": 17.9074881971
                            },
                            {
                                "lat": 48.2246864587,
                                "lng": 17.9071448743
                            },
                            {
                                "lat": 48.2241252065,
                                "lng": 17.9065226018
                            },
                            {
                                "lat": 48.2237926126,
                                "lng": 17.9061417282
                            },
                            {
                                "lat": 48.2235458493,
                                "lng": 17.9059030116
                            },
                            {
                                "lat": 48.2232695818,
                                "lng": 17.9056052864
                            },
                            {
                                "lat": 48.2230073959,
                                "lng": 17.9053464532
                            },
                            {
                                "lat": 48.2226707786,
                                "lng": 17.9050514102
                            },
                            {
                                "lat": 48.2230167836,
                                "lng": 17.9044103622
                            },
                            {
                                "lat": 48.2234251499,
                                "lng": 17.9036526382
                            },
                            {
                                "lat": 48.2238348573,
                                "lng": 17.9028962553
                            },
                            {
                                "lat": 48.2240547985,
                                "lng": 17.902481854
                            },
                            {
                                "lat": 48.2241922617,
                                "lng": 17.9021814466
                            },
                            {
                                "lat": 48.2238764316,
                                "lng": 17.9017080367
                            },
                            {
                                "lat": 48.2233614475,
                                "lng": 17.9010482132
                            },
                            {
                                "lat": 48.2230576873,
                                "lng": 17.9005908966
                            },
                            {
                                "lat": 48.2229242474,
                                "lng": 17.9003454745
                            },
                            {
                                "lat": 48.2227029651,
                                "lng": 17.8996990621
                            },
                            {
                                "lat": 48.2224360853,
                                "lng": 17.8989051282
                            },
                            {
                                "lat": 48.2221806049,
                                "lng": 17.8981138766
                            },
                            {
                                "lat": 48.2218983024,
                                "lng": 17.8971992433
                            },
                            {
                                "lat": 48.2215824723,
                                "lng": 17.8962805867
                            },
                            {
                                "lat": 48.221244514,
                                "lng": 17.8958152235
                            },
                            {
                                "lat": 48.2207154483,
                                "lng": 17.8952036798
                            },
                            {
                                "lat": 48.2202581316,
                                "lng": 17.8946243227
                            },
                            {
                                "lat": 48.2197431475,
                                "lng": 17.894012779
                            },
                            {
                                "lat": 48.2192730904,
                                "lng": 17.8934361041
                            },
                            {
                                "lat": 48.2187909633,
                                "lng": 17.8928795457
                            },
                            {
                                "lat": 48.2182639092,
                                "lng": 17.8922317922
                            },
                            {
                                "lat": 48.2176215202,
                                "lng": 17.8914754093
                            },
                            {
                                "lat": 48.2171628624,
                                "lng": 17.8909228742
                            },
                            {
                                "lat": 48.216547966,
                                "lng": 17.8901718557
                            },
                            {
                                "lat": 48.2159967721,
                                "lng": 17.8895120323
                            },
                            {
                                "lat": 48.2154616714,
                                "lng": 17.8889916837
                            },
                            {
                                "lat": 48.2145503908,
                                "lng": 17.8881119192
                            },
                            {
                                "lat": 48.2136961073,
                                "lng": 17.8873072565
                            },
                            {
                                "lat": 48.2125970721,
                                "lng": 17.8863416612
                            },
                            {
                                "lat": 48.2119164616,
                                "lng": 17.8857059777
                            },
                            {
                                "lat": 48.2114584744,
                                "lng": 17.8852915764
                            },
                            {
                                "lat": 48.2105599344,
                                "lng": 17.884426564
                            },
                            {
                                "lat": 48.2100389153,
                                "lng": 17.8839384019
                            },
                            {
                                "lat": 48.209323436,
                                "lng": 17.8832946718
                            },
                            {
                                "lat": 48.2087232918,
                                "lng": 17.8826080263
                            },
                            {
                                "lat": 48.2086072862,
                                "lng": 17.8823719919
                            },
                            {
                                "lat": 48.2084778696,
                                "lng": 17.8821547329
                            },
                            {
                                "lat": 48.2083223015,
                                "lng": 17.8820072114
                            },
                            {
                                "lat": 48.2083497941,
                                "lng": 17.8815539181
                            },
                            {
                                "lat": 48.2084771991,
                                "lng": 17.8809383512
                            },
                            {
                                "lat": 48.2085241377,
                                "lng": 17.8805051744
                            },
                            {
                                "lat": 48.2086180151,
                                "lng": 17.8799083829
                            },
                            {
                                "lat": 48.2087702304,
                                "lng": 17.8792753816
                            },
                            {
                                "lat": 48.2099316269,
                                "lng": 17.87802279
                            },
                            {
                                "lat": 48.2107208669,
                                "lng": 17.8772650659
                            },
                            {
                                "lat": 48.2119359076,
                                "lng": 17.8759923577
                            },
                            {
                                "lat": 48.2139314711,
                                "lng": 17.8739364445
                            },
                            {
                                "lat": 48.2154214382,
                                "lng": 17.8722399473
                            },
                            {
                                "lat": 48.2169476151,
                                "lng": 17.8705072403
                            },
                            {
                                "lat": 48.218202889,
                                "lng": 17.8695483506
                            },
                            {
                                "lat": 48.218831867,
                                "lng": 17.8690333664
                            },
                            {
                                "lat": 48.2195185125,
                                "lng": 17.8685183823
                            },
                            {
                                "lat": 48.2203620672,
                                "lng": 17.8677459061
                            },
                            {
                                "lat": 48.2208951563,
                                "lng": 17.8672872484
                            },
                            {
                                "lat": 48.2211405784,
                                "lng": 17.8668540716
                            },
                            {
                                "lat": 48.2214342803,
                                "lng": 17.8660936654
                            },
                            {
                                "lat": 48.2216629386,
                                "lng": 17.8652997315
                            },
                            {
                                "lat": 48.2217816263,
                                "lng": 17.8646761179
                            },
                            {
                                "lat": 48.2219392061,
                                "lng": 17.8640954196
                            },
                            {
                                "lat": 48.2222201675,
                                "lng": 17.8635831177
                            },
                            {
                                "lat": 48.2226634026,
                                "lng": 17.8628750145
                            },
                            {
                                "lat": 48.2231207192,
                                "lng": 17.8622312844
                            },
                            {
                                "lat": 48.223592788,
                                "lng": 17.8616733849
                            },
                            {
                                "lat": 48.2240286469,
                                "lng": 17.8610725701
                            },
                            {
                                "lat": 48.2244564593,
                                "lng": 17.8604798019
                            },
                            {
                                "lat": 48.224972114,
                                "lng": 17.8597421944
                            },
                            {
                                "lat": 48.2254441828,
                                "lng": 17.8590340912
                            },
                            {
                                "lat": 48.2260168344,
                                "lng": 17.8583876789
                            },
                            {
                                "lat": 48.2265686989,
                                "lng": 17.8576406837
                            },
                            {
                                "lat": 48.2269448787,
                                "lng": 17.8572316468
                            },
                            {
                                "lat": 48.2277307659,
                                "lng": 17.8565020859
                            },
                            {
                                "lat": 48.2285039127,
                                "lng": 17.8557470441
                            },
                            {
                                "lat": 48.2290450484,
                                "lng": 17.8552092612
                            },
                            {
                                "lat": 48.2297323644,
                                "lng": 17.8544636071
                            },
                            {
                                "lat": 48.2303465903,
                                "lng": 17.854077369
                            },
                            {
                                "lat": 48.2310473174,
                                "lng": 17.8536267579
                            },
                            {
                                "lat": 48.2315549254,
                                "lng": 17.8533907235
                            },
                            {
                                "lat": 48.2317762077,
                                "lng": 17.8531761467
                            },
                            {
                                "lat": 48.2321476936,
                                "lng": 17.852897197
                            },
                            {
                                "lat": 48.2323052734,
                                "lng": 17.8526504338
                            },
                            {
                                "lat": 48.232633844,
                                "lng": 17.8523285687
                            },
                            {
                                "lat": 48.2328913361,
                                "lng": 17.852113992
                            },
                            {
                                "lat": 48.2333627343,
                                "lng": 17.8518457711
                            },
                            {
                                "lat": 48.233698681,
                                "lng": 17.8515668213
                            },
                            {
                                "lat": 48.2340943068,
                                "lng": 17.8513106704
                            },
                            {
                                "lat": 48.234481886,
                                "lng": 17.8510156274
                            },
                            {
                                "lat": 48.2348198444,
                                "lng": 17.8507259488
                            },
                            {
                                "lat": 48.235226199,
                                "lng": 17.8504215181
                            },
                            {
                                "lat": 48.2355346531,
                                "lng": 17.8501693904
                            },
                            {
                                "lat": 48.2358565181,
                                "lng": 17.8498716652
                            },
                            {
                                "lat": 48.2361783832,
                                "lng": 17.849624902
                            },
                            {
                                "lat": 48.2365089655,
                                "lng": 17.8493660688
                            },
                            {
                                "lat": 48.2368549705,
                                "lng": 17.8490535915
                            },
                            {
                                "lat": 48.2367999852,
                                "lng": 17.84890607
                            },
                            {
                                "lat": 48.236586079,
                                "lng": 17.8487236798
                            },
                            {
                                "lat": 48.2364499569,
                                "lng": 17.8486378491
                            },
                            {
                                "lat": 48.2362782955,
                                "lng": 17.8484661877
                            },
                            {
                                "lat": 48.2361857593,
                                "lng": 17.848380357
                            },
                            {
                                "lat": 48.2360429317,
                                "lng": 17.8481657803
                            },
                            {
                                "lat": 48.2359141856,
                                "lng": 17.8479833901
                            },
                            {
                                "lat": 48.2357995212,
                                "lng": 17.8477366269
                            },
                            {
                                "lat": 48.235642612,
                                "lng": 17.8473611176
                            },
                            {
                                "lat": 48.2355426997,
                                "lng": 17.8470821679
                            },
                            {
                                "lat": 48.2353696972,
                                "lng": 17.8465859592
                            },
                            {
                                "lat": 48.2352677733,
                                "lng": 17.8462828696
                            },
                            {
                                "lat": 48.235128969,
                                "lng": 17.8458590806
                            },
                            {
                                "lat": 48.2349418849,
                                "lng": 17.8452689946
                            },
                            {
                                "lat": 48.2347641885,
                                "lng": 17.8447419405
                            },
                            {
                                "lat": 48.2346636057,
                                "lng": 17.8444214165
                            },
                            {
                                "lat": 48.2344919443,
                                "lng": 17.8438957036
                            },
                            {
                                "lat": 48.234327659,
                                "lng": 17.8434129059
                            },
                            {
                                "lat": 48.2342022657,
                                "lng": 17.8431031108
                            },
                            {
                                "lat": 48.2340829074,
                                "lng": 17.8427825868
                            },
                            {
                                "lat": 48.2339454442,
                                "lng": 17.8425465524
                            },
                            {
                                "lat": 48.2338462025,
                                "lng": 17.8422769904
                            },
                            {
                                "lat": 48.2337429374,
                                "lng": 17.8419739008
                            },
                            {
                                "lat": 48.2336162031,
                                "lng": 17.8415568173
                            },
                            {
                                "lat": 48.233480081,
                                "lng": 17.8411518037
                            },
                            {
                                "lat": 48.2332916558,
                                "lng": 17.8406180441
                            },
                            {
                                "lat": 48.233179003,
                                "lng": 17.8402599692
                            },
                            {
                                "lat": 48.2330422103,
                                "lng": 17.8398630023
                            },
                            {
                                "lat": 48.2329295576,
                                "lng": 17.8394941986
                            },
                            {
                                "lat": 48.2328336686,
                                "lng": 17.8392072022
                            },
                            {
                                "lat": 48.2326841354,
                                "lng": 17.8387995064
                            },
                            {
                                "lat": 48.2325332612,
                                "lng": 17.8384079039
                            },
                            {
                                "lat": 48.2323857397,
                                "lng": 17.8379492462
                            },
                            {
                                "lat": 48.2322844863,
                                "lng": 17.837651521
                            },
                            {
                                "lat": 48.2321543992,
                                "lng": 17.8372518718
                            },
                            {
                                "lat": 48.2320196182,
                                "lng": 17.8368978202
                            },
                            {
                                "lat": 48.2319317758,
                                "lng": 17.8366148472
                            },
                            {
                                "lat": 48.2318365574,
                                "lng": 17.8363198042
                            },
                            {
                                "lat": 48.2317554206,
                                "lng": 17.8360502422
                            },
                            {
                                "lat": 48.23187612,
                                "lng": 17.83581689
                            },
                            {
                                "lat": 48.2320484519,
                                "lng": 17.8356720507
                            },
                            {
                                "lat": 48.2320457697,
                                "lng": 17.835496366
                            },
                            {
                                "lat": 48.231965974,
                                "lng": 17.8353662789
                            },
                            {
                                "lat": 48.2318305224,
                                "lng": 17.8350014985
                            },
                            {
                                "lat": 48.2316548377,
                                "lng": 17.8344650567
                            },
                            {
                                "lat": 48.2315120101,
                                "lng": 17.8340573609
                            },
                            {
                                "lat": 48.2314369082,
                                "lng": 17.8338213265
                            },
                            {
                                "lat": 48.2313437015,
                                "lng": 17.8336282074
                            },
                            {
                                "lat": 48.2311297953,
                                "lng": 17.8332848847
                            },
                            {
                                "lat": 48.2309795916,
                                "lng": 17.8331561387
                            },
                            {
                                "lat": 48.2307509333,
                                "lng": 17.8329308331
                            },
                            {
                                "lat": 48.2305718958,
                                "lng": 17.8327913582
                            },
                            {
                                "lat": 48.2303646952,
                                "lng": 17.832673341
                            },
                            {
                                "lat": 48.2301789522,
                                "lng": 17.8325767815
                            },
                            {
                                "lat": 48.2299791276,
                                "lng": 17.8325338662
                            },
                            {
                                "lat": 48.2297927141,
                                "lng": 17.8325016797
                            },
                            {
                                "lat": 48.2296284288,
                                "lng": 17.8325016797
                            },
                            {
                                "lat": 48.2294145226,
                                "lng": 17.832480222
                            },
                            {
                                "lat": 48.2296646386,
                                "lng": 17.8321905434
                            },
                            {
                                "lat": 48.2298644632,
                                "lng": 17.8319330513
                            },
                            {
                                "lat": 48.230022043,
                                "lng": 17.8316326439
                            },
                            {
                                "lat": 48.2301789522,
                                "lng": 17.831235677
                            },
                            {
                                "lat": 48.2303646952,
                                "lng": 17.8308387101
                            },
                            {
                                "lat": 48.2305363566,
                                "lng": 17.8303559124
                            },
                            {
                                "lat": 48.2307147235,
                                "lng": 17.8298945725
                            },
                            {
                                "lat": 48.2309038192,
                                "lng": 17.8293447196
                            },
                            {
                                "lat": 48.2310768217,
                                "lng": 17.8288941085
                            },
                            {
                                "lat": 48.2311277837,
                                "lng": 17.8285937011
                            },
                            {
                                "lat": 48.2311083376,
                                "lng": 17.8282530606
                            },
                            {
                                "lat": 48.2310795039,
                                "lng": 17.8279097378
                            },
                            {
                                "lat": 48.2310077548,
                                "lng": 17.8275342286
                            },
                            {
                                "lat": 48.2311056554,
                                "lng": 17.8273183107
                            },
                            {
                                "lat": 48.2313510776,
                                "lng": 17.8271265328
                            },
                            {
                                "lat": 48.2316011935,
                                "lng": 17.8268583119
                            },
                            {
                                "lat": 48.2317151874,
                                "lng": 17.8266330063
                            },
                            {
                                "lat": 48.2318868488,
                                "lng": 17.8263647854
                            },
                            {
                                "lat": 48.2320102304,
                                "lng": 17.8261636198
                            },
                            {
                                "lat": 48.2321684808,
                                "lng": 17.8259168565
                            },
                            {
                                "lat": 48.2323046029,
                                "lng": 17.825654
                            },
                            {
                                "lat": 48.2324373722,
                                "lng": 17.8254514933
                            },
                            {
                                "lat": 48.2326445729,
                                "lng": 17.8252637386
                            },
                            {
                                "lat": 48.2328591496,
                                "lng": 17.8251470625
                            },
                            {
                                "lat": 48.2330495864,
                                "lng": 17.8250290453
                            },
                            {
                                "lat": 48.2333010435,
                                "lng": 17.8249244392
                            },
                            {
                                "lat": 48.2334928215,
                                "lng": 17.8248359263
                            },
                            {
                                "lat": 48.2338515669,
                                "lng": 17.8246200085
                            },
                            {
                                "lat": 48.2342277467,
                                "lng": 17.8243933618
                            },
                            {
                                "lat": 48.23458381,
                                "lng": 17.8241841495
                            },
                            {
                                "lat": 48.2351544499,
                                "lng": 17.8238810599
                            },
                            {
                                "lat": 48.2356338948,
                                "lng": 17.8236208856
                            },
                            {
                                "lat": 48.2361569256,
                                "lng": 17.8233191371
                            },
                            {
                                "lat": 48.2361140102,
                                "lng": 17.8230683506
                            },
                            {
                                "lat": 48.2360891998,
                                "lng": 17.8228376806
                            },
                            {
                                "lat": 48.2360127568,
                                "lng": 17.8225158155
                            },
                            {
                                "lat": 48.2359443605,
                                "lng": 17.822317332
                            },
                            {
                                "lat": 48.2358216494,
                                "lng": 17.8221175075
                            },
                            {
                                "lat": 48.2356714457,
                                "lng": 17.8220075369
                            },
                            {
                                "lat": 48.2355453819,
                                "lng": 17.8218613565
                            },
                            {
                                "lat": 48.2353696972,
                                "lng": 17.8217540681
                            },
                            {
                                "lat": 48.2351893187,
                                "lng": 17.8216132522
                            },
                            {
                                "lat": 48.2350920886,
                                "lng": 17.8214912117
                            },
                            {
                                "lat": 48.2349257916,
                                "lng": 17.8213946521
                            },
                            {
                                "lat": 48.2347715646,
                                "lng": 17.8211988509
                            },
                            {
                                "lat": 48.2346501946,
                                "lng": 17.8211036325
                            },
                            {
                                "lat": 48.2345087081,
                                "lng": 17.82093063
                            },
                            {
                                "lat": 48.2343363762,
                                "lng": 17.8207294643
                            },
                            {
                                "lat": 48.2342512161,
                                "lng": 17.8206369281
                            },
                            {
                                "lat": 48.2341271639,
                                "lng": 17.8204853833
                            },
                            {
                                "lat": 48.2340078056,
                                "lng": 17.8203365207
                            },
                            {
                                "lat": 48.233948797,
                                "lng": 17.8201621771
                            },
                            {
                                "lat": 48.2338576019,
                                "lng": 17.8199422359
                            },
                            {
                                "lat": 48.2338099927,
                                "lng": 17.8197611868
                            },
                            {
                                "lat": 48.2337771356,
                                "lng": 17.8195559978
                            },
                            {
                                "lat": 48.2337107509,
                                "lng": 17.8192864358
                            },
                            {
                                "lat": 48.233667165,
                                "lng": 17.8189592063
                            },
                            {
                                "lat": 48.2336061448,
                                "lng": 17.8186775744
                            },
                            {
                                "lat": 48.2335887104,
                                "lng": 17.818390578
                            },
                            {
                                "lat": 48.2335732877,
                                "lng": 17.818197459
                            },
                            {
                                "lat": 48.2335431129,
                                "lng": 17.8180097044
                            },
                            {
                                "lat": 48.2335142791,
                                "lng": 17.817825973
                            },
                            {
                                "lat": 48.233493492,
                                "lng": 17.8176382184
                            },
                            {
                                "lat": 48.2335015386,
                                "lng": 17.8174652159
                            },
                            {
                                "lat": 48.2334881276,
                                "lng": 17.8172425926
                            },
                            {
                                "lat": 48.2334820926,
                                "lng": 17.8170534968
                            },
                            {
                                "lat": 48.2334733754,
                                "lng": 17.8168871999
                            },
                            {
                                "lat": 48.2334606349,
                                "lng": 17.8166618943
                            },
                            {
                                "lat": 48.2334371656,
                                "lng": 17.8164835274
                            },
                            {
                                "lat": 48.2334713638,
                                "lng": 17.8161911666
                            },
                            {
                                "lat": 48.2334968448,
                                "lng": 17.8159296513
                            },
                            {
                                "lat": 48.233512938,
                                "lng": 17.8156560659
                            },
                            {
                                "lat": 48.2334552705,
                                "lng": 17.8154066205
                            },
                            {
                                "lat": 48.2334170491,
                                "lng": 17.8153114021
                            },
                            {
                                "lat": 48.2333439589,
                                "lng": 17.8152014315
                            },
                            {
                                "lat": 48.2332735509,
                                "lng": 17.8151035309
                            },
                            {
                                "lat": 48.2331796736,
                                "lng": 17.8149090707
                            },
                            {
                                "lat": 48.2328745723,
                                "lng": 17.8147119284
                            },
                            {
                                "lat": 48.2325674593,
                                "lng": 17.8148299456
                            },
                            {
                                "lat": 48.2321798801,
                                "lng": 17.8150525689
                            }
                        ],
                        position: {lat: 48.2356191427, lng: 17.9536664486},
                    },

                    {
                        color: '#f3a683',
                        id: 4,
                        type: 'road', // road
                        title: 'Močenok - Gorazdov',
                        description: '',
                        photo: '',
                        label: '',
                        tags: ['cc1', 'cc2', 'cc3'],
                        path: [
                            {lat: 48.1922853738, lng: 17.9558363557},
                            {lat: 48.1919816136, lng: 17.9552690685},
                            {lat: 48.1936767697, lng: 17.9534773529},
                            {lat: 48.1971884519, lng: 17.9494433105},
                            {lat: 48.2010494918, lng: 17.9451732337},
                            {lat: 48.2041890174, lng: 17.9412357509},
                            {lat: 48.2037766278, lng: 17.939873188},
                            {lat: 48.2066056877, lng: 17.938349694},
                            {lat: 48.2098732889, lng: 17.9367832839},
                            {lat: 48.2126614451, lng: 17.9345194995},
                            {lat: 48.2177589834, lng: 17.9312257469},
                            {lat: 48.2223053277, lng: 17.9313008487},
                            {lat: 48.22454229, lng: 17.9309253395},
                            {lat: 48.2279587537, lng: 17.929187268},
                            {lat: 48.2295875251, lng: 17.9277777672},

                            {lat: 48.229797408, lng: 17.9278743267},
                            {lat: 48.2302621007, lng: 17.9298698902},

                            {lat: 48.2309554517, lng: 17.931522131},
                            {lat: 48.2317842543, lng: 17.9322731495},
                        ],
                        position: {lat: 0, lng: 0},
                    },
                    {
                        color: '#778beb',
                        id: 5,
                        type: 'road', // road
                        title: 'Močenok - Sýpka Báb',
                        description: '',
                        photo: '',
                        label: '',
                        tags: ['cc1', 'cc2', 'cc3'],
                        path: [
                            {lat: 48.2317829132, lng: 17.9322825372},
                            {lat: 48.2309554517, lng: 17.931522131},
                            {lat: 48.2327659428, lng: 17.9299758375},
                            {lat: 48.2332514226, lng: 17.9272614419},
                            {lat: 48.2335947454, lng: 17.926735729},
                            {lat: 48.233737573, lng: 17.9263280332},
                            {lat: 48.2358739525, lng: 17.9257701337},
                            {lat: 48.2380324602, lng: 17.9243539274},
                            {lat: 48.2408118993, lng: 17.9217790067},
                            {lat: 48.2429415733, lng: 17.9201696813},
                            {lat: 48.2437703758, lng: 17.9224978387},
                            {lat: 48.2451061159, lng: 17.9216717184},
                            {lat: 48.2457780093, lng: 17.9213176668},
                            {lat: 48.2464492321, lng: 17.919010967},
                            {lat: 48.2462923229, lng: 17.918227762},
                            {lat: 48.2464780658, lng: 17.9178844392},
                            {lat: 48.2484213263, lng: 17.9190967977},
                            {lat: 48.2500789315, lng: 17.9202340543},
                            {lat: 48.2529435307, lng: 17.9220686853},
                            {lat: 48.2567294687, lng: 17.9243861139},
                            {lat: 48.2595511526, lng: 17.9189787805},
                            {lat: 48.2632653415, lng: 17.9115436971},
                            {lat: 48.269207105, lng: 17.899312824},
                            {lat: 48.2728347927, lng: 17.9069946706},
                            {lat: 48.2738915831, lng: 17.9131315649},
                            {lat: 48.2778330892, lng: 17.9091404378},
                            {lat: 48.2964918762, lng: 17.8964656591},
                            {lat: 48.2972227782, lng: 17.8989695013},
                            {lat: 48.2983318716, lng: 17.8965528309},
                            {lat: 48.2976103574, lng: 17.8953807056},
                            {lat: 48.298214525, lng: 17.894141525},
                            {lat: 48.2984572649, lng: 17.8934334219},
                            {lat: 48.2988287508, lng: 17.8934012353},
                            {lat: 48.2993497699, lng: 17.8925965726},
                            {lat: 48.2996535301, lng: 17.893153131}

                        ],
                        position: {lat: 0, lng: 0},
                    },

                    {
                        color: '#596275',
                        id: 16,
                        type: 'road', // road
                        title: 'Pripojenie na jestvujúcu cyklocestu 5110',
                        description: '',
                        photo: '',
                        label: '',
                        tags: ['cc1', 'cc2', 'cc3'],
                        path: [
                            {
                                "lat": 48.2657584548,
                                "lng": 18.0002591014
                            },
                            {
                                "lat": 48.2661158592,
                                "lng": 17.9997655749
                            },
                            {
                                "lat": 48.2663874328,
                                "lng": 17.9992720485
                            },
                            {
                                "lat": 48.267101571,
                                "lng": 17.998842895
                            },
                            {
                                "lat": 48.2677868754,
                                "lng": 17.9983493686
                            },
                            {
                                "lat": 48.2682582736,
                                "lng": 17.9979202151
                            },
                            {
                                "lat": 48.2686867565,
                                "lng": 17.9975125194
                            }
                        ],
                        position: {lat: 0, lng: 0},
                    },

                    {
                        color: '#e66767',
                        id: 17,
                        type: 'road', // road
                        title: 'Okruh okolo obce',
                        description: '',
                        photo: '',
                        label: '',
                        tags: ['cc1', 'cc2', 'cc3'],
                        path: [
                            {
                                "lat": 48.1972132623,
                                "lng": 17.9023866355
                            },
                            {
                                "lat": 48.1981547177,
                                "lng": 17.9008121789
                            },
                            {
                                "lat": 48.1989701092,
                                "lng": 17.8994563222
                            },
                            {
                                "lat": 48.1997855008,
                                "lng": 17.8981688619
                            },
                            {
                                "lat": 48.2002864033,
                                "lng": 17.8970745206
                            },
                            {
                                "lat": 48.2009153813,
                                "lng": 17.8962376714
                            },
                            {
                                "lat": 48.2014303654,
                                "lng": 17.8953364491
                            },
                            {
                                "lat": 48.2019882649,
                                "lng": 17.8943923116
                            },
                            {
                                "lat": 48.2025454938,
                                "lng": 17.893383801
                            },
                            {
                                "lat": 48.203060478,
                                "lng": 17.8924611211
                            },
                            {
                                "lat": 48.20331797,
                                "lng": 17.892074883
                            },
                            {
                                "lat": 48.2037974149,
                                "lng": 17.8911414742
                            },
                            {
                                "lat": 48.2043264806,
                                "lng": 17.8900900483
                            },
                            {
                                "lat": 48.2046979666,
                                "lng": 17.8893604875
                            },
                            {
                                "lat": 48.2050412893,
                                "lng": 17.8886952996
                            },
                            {
                                "lat": 48.2053168863,
                                "lng": 17.8882554173
                            },
                            {
                                "lat": 48.2055421919,
                                "lng": 17.887788713
                            },
                            {
                                "lat": 48.2057312876,
                                "lng": 17.8873810172
                            },
                            {
                                "lat": 48.2058781385,
                                "lng": 17.8870806098
                            },
                            {
                                "lat": 48.2060283422,
                                "lng": 17.8867426515
                            },
                            {
                                "lat": 48.2061818987,
                                "lng": 17.8865280747
                            },
                            {
                                "lat": 48.2063139975,
                                "lng": 17.886184752
                            },
                            {
                                "lat": 48.2064997405,
                                "lng": 17.8858575225
                            },
                            {
                                "lat": 48.2066392154,
                                "lng": 17.8856000304
                            },
                            {
                                "lat": 48.206762597,
                                "lng": 17.8853291273
                            },
                            {
                                "lat": 48.206891343,
                                "lng": 17.8851521015
                            },
                            {
                                "lat": 48.2069597393,
                                "lng": 17.884953618
                            },
                            {
                                "lat": 48.2070737332,
                                "lng": 17.8847336769
                            },
                            {
                                "lat": 48.2071951032,
                                "lng": 17.8844922781
                            },
                            {
                                "lat": 48.2072990388,
                                "lng": 17.8842830658
                            },
                            {
                                "lat": 48.207424432,
                                "lng": 17.8840523958
                            },
                            {
                                "lat": 48.2075350732,
                                "lng": 17.8838485479
                            },
                            {
                                "lat": 48.2076276094,
                                "lng": 17.8836071491
                            },
                            {
                                "lat": 48.2077456266,
                                "lng": 17.8833442926
                            },
                            {
                                "lat": 48.2078743726,
                                "lng": 17.8831082582
                            },
                            {
                                "lat": 48.2079709321,
                                "lng": 17.8828990459
                            },
                            {
                                "lat": 48.2080674917,
                                "lng": 17.8827059269
                            },
                            {
                                "lat": 48.2081285119,
                                "lng": 17.8824967146
                            },
                            {
                                "lat": 48.2081855088,
                                "lng": 17.8823679686
                            },
                            {
                                "lat": 48.2082143426,
                                "lng": 17.8822231293
                            },
                            {
                                "lat": 48.2082820684,
                                "lng": 17.8820085526
                            },
                            {
                                "lat": 48.2084537297,
                                "lng": 17.8821051121
                            },
                            {
                                "lat": 48.2085362077,
                                "lng": 17.882271409
                            },
                            {
                                "lat": 48.2086542249,
                                "lng": 17.8825074434
                            },
                            {
                                "lat": 48.2088004053,
                                "lng": 17.8827756643
                            },
                            {
                                "lat": 48.2089110464,
                                "lng": 17.8829365969
                            },
                            {
                                "lat": 48.2090827078,
                                "lng": 17.8830814362
                            },
                            {
                                "lat": 48.2092510164,
                                "lng": 17.8832638264
                            },
                            {
                                "lat": 48.2094226778,
                                "lng": 17.8834354877
                            },
                            {
                                "lat": 48.2096298784,
                                "lng": 17.8835749626
                            },
                            {
                                "lat": 48.2098263502,
                                "lng": 17.8837734461
                            },
                            {
                                "lat": 48.2100516558,
                                "lng": 17.8839719296
                            },
                            {
                                "lat": 48.210234046,
                                "lng": 17.8841543198
                            },
                            {
                                "lat": 48.2104345411,
                                "lng": 17.8843098879
                            },
                            {
                                "lat": 48.2106699049,
                                "lng": 17.8845244646
                            },
                            {
                                "lat": 48.21099177,
                                "lng": 17.8848302364
                            },
                            {
                                "lat": 48.2113169879,
                                "lng": 17.8851038218
                            },
                            {
                                "lat": 48.2115463167,
                                "lng": 17.8853130341
                            },
                            {
                                "lat": 48.2117535174,
                                "lng": 17.885479331
                            },
                            {
                                "lat": 48.2120861113,
                                "lng": 17.8857851028
                            },
                            {
                                "lat": 48.2124113292,
                                "lng": 17.8861230612
                            },
                            {
                                "lat": 48.212839812,
                                "lng": 17.886493206
                            },
                            {
                                "lat": 48.213172406,
                                "lng": 17.8868365288
                            },
                            {
                                "lat": 48.2135425508,
                                "lng": 17.8871154785
                            },
                            {
                                "lat": 48.2139180601,
                                "lng": 17.8874695301
                            },
                            {
                                "lat": 48.2142070681,
                                "lng": 17.887737751
                            },
                            {
                                "lat": 48.2145148516,
                                "lng": 17.8880220652
                            },
                            {
                                "lat": 48.2150043547,
                                "lng": 17.8884726763
                            },
                            {
                                "lat": 48.2152940333,
                                "lng": 17.8887569904
                            },
                            {
                                "lat": 48.2156085223,
                                "lng": 17.8890359402
                            },
                            {
                                "lat": 48.2158841193,
                                "lng": 17.8893202543
                            },
                            {
                                "lat": 48.216137588,
                                "lng": 17.8896260262
                            },
                            {
                                "lat": 48.2164198905,
                                "lng": 17.8899854422
                            },
                            {
                                "lat": 48.2167417556,
                                "lng": 17.8903287649
                            },
                            {
                                "lat": 48.2170099765,
                                "lng": 17.8906774521
                            },
                            {
                                "lat": 48.2173170894,
                                "lng": 17.8910529613
                            },
                            {
                                "lat": 48.2180888951,
                                "lng": 17.8919863701
                            },
                            {
                                "lat": 48.2184462994,
                                "lng": 17.8924262524
                            },
                            {
                                "lat": 48.2187936455,
                                "lng": 17.8928393126
                            },
                            {
                                "lat": 48.2194078714,
                                "lng": 17.8935527802
                            },
                            {
                                "lat": 48.2198873162,
                                "lng": 17.8941428661
                            },
                            {
                                "lat": 48.220390901,
                                "lng": 17.8947758675
                            },
                            {
                                "lat": 48.2209769636,
                                "lng": 17.8954893351
                            },
                            {
                                "lat": 48.2213953882,
                                "lng": 17.8959828615
                            },
                            {
                                "lat": 48.2216776907,
                                "lng": 17.8964924812
                            },
                            {
                                "lat": 48.2218956202,
                                "lng": 17.8972756863
                            },
                            {
                                "lat": 48.222213462,
                                "lng": 17.8981554508
                            },
                            {
                                "lat": 48.222424686,
                                "lng": 17.8988313675
                            },
                            {
                                "lat": 48.2226781547,
                                "lng": 17.8996360302
                            },
                            {
                                "lat": 48.222906813,
                                "lng": 17.900301218
                            },
                            {
                                "lat": 48.2233500481,
                                "lng": 17.9010683298
                            },
                            {
                                "lat": 48.2239220291,
                                "lng": 17.9017710686
                            },
                            {
                                "lat": 48.224247247,
                                "lng": 17.902200222
                            },
                            {
                                "lat": 48.2248547673,
                                "lng": 17.9030156136
                            },
                            {
                                "lat": 48.2256124914,
                                "lng": 17.9040455818
                            },
                            {
                                "lat": 48.2265988737,
                                "lng": 17.904946804
                            },
                            {
                                "lat": 48.2274853438,
                                "lng": 17.9061055183
                            },
                            {
                                "lat": 48.2281284034,
                                "lng": 17.9068779945
                            },
                            {
                                "lat": 48.2288002968,
                                "lng": 17.9075860977
                            },
                            {
                                "lat": 48.2297866791,
                                "lng": 17.9087018967
                            },
                            {
                                "lat": 48.2308729738,
                                "lng": 17.9098391533
                            },
                            {
                                "lat": 48.2316876948,
                                "lng": 17.9107618332
                            },
                            {
                                "lat": 48.2322878391,
                                "lng": 17.9115128517
                            },
                            {
                                "lat": 48.2333600521,
                                "lng": 17.9126286507
                            },
                            {
                                "lat": 48.2338602841,
                                "lng": 17.913197279
                            },
                            {
                                "lat": 48.2334867865,
                                "lng": 17.9134507477
                            },
                            {
                                "lat": 48.2331059128,
                                "lng": 17.9137551785
                            },
                            {
                                "lat": 48.2328544557,
                                "lng": 17.913967073
                            },
                            {
                                "lat": 48.2325835526,
                                "lng": 17.9141977429
                            },
                            {
                                "lat": 48.2322261482,
                                "lng": 17.9145048559
                            },
                            {
                                "lat": 48.231786266,
                                "lng": 17.9149501026
                            },
                            {
                                "lat": 48.2315589488,
                                "lng": 17.9152035713
                            },
                            {
                                "lat": 48.2314161211,
                                "lng": 17.9153645039
                            },
                            {
                                "lat": 48.2311660051,
                                "lng": 17.9156219959
                            },
                            {
                                "lat": 48.2309440523,
                                "lng": 17.9158473015
                            },
                            {
                                "lat": 48.2307301462,
                                "lng": 17.9160404205
                            },
                            {
                                "lat": 48.2304297388,
                                "lng": 17.9162228107
                            },
                            {
                                "lat": 48.2305584848,
                                "lng": 17.9166412354
                            },
                            {
                                "lat": 48.2308729738,
                                "lng": 17.9173278809
                            },
                            {
                                "lat": 48.2311371714,
                                "lng": 17.917907238
                            },
                            {
                                "lat": 48.2314161211,
                                "lng": 17.9184544086
                            },
                            {
                                "lat": 48.2315140218,
                                "lng": 17.9186636209
                            },
                            {
                                "lat": 48.2315676659,
                                "lng": 17.9187440872
                            },
                            {
                                "lat": 48.2316125929,
                                "lng": 17.9188299179
                            },
                            {
                                "lat": 48.2316340506,
                                "lng": 17.9189318419
                            },
                            {
                                "lat": 48.231632039,
                                "lng": 17.918972075
                            },
                            {
                                "lat": 48.2315837592,
                                "lng": 17.9189828038
                            },
                            {
                                "lat": 48.2315374911,
                                "lng": 17.9190176725
                            },
                            {
                                "lat": 48.2315073162,
                                "lng": 17.919036448
                            },
                            {
                                "lat": 48.2314731181,
                                "lng": 17.9190552235
                            },
                            {
                                "lat": 48.2314355671,
                                "lng": 17.9190659523
                            },
                            {
                                "lat": 48.2314000279,
                                "lng": 17.9190820456
                            },
                            {
                                "lat": 48.231369853,
                                "lng": 17.919100821
                            },
                            {
                                "lat": 48.2313463837,
                                "lng": 17.9191356897
                            },
                            {
                                "lat": 48.2313430309,
                                "lng": 17.9192295671
                            },
                            {
                                "lat": 48.2313644886,
                                "lng": 17.9192912579
                            },
                            {
                                "lat": 48.2313872874,
                                "lng": 17.9193690419
                            },
                            {
                                "lat": 48.2314409316,
                                "lng": 17.9194816947
                            },
                            {
                                "lat": 48.2314697653,
                                "lng": 17.9195594788
                            },
                            {
                                "lat": 48.2315374911,
                                "lng": 17.9196855426
                            },
                            {
                                "lat": 48.2315730304,
                                "lng": 17.9198089242
                            },
                            {
                                "lat": 48.2316642255,
                                "lng": 17.9199752212
                            },
                            {
                                "lat": 48.2317232341,
                                "lng": 17.9201361537
                            },
                            {
                                "lat": 48.2317748666,
                                "lng": 17.9202675819
                            },
                            {
                                "lat": 48.2318466157,
                                "lng": 17.9204043746
                            },
                            {
                                "lat": 48.2319036126,
                                "lng": 17.9205465317
                            },
                            {
                                "lat": 48.2319431752,
                                "lng": 17.9206645489
                            },
                            {
                                "lat": 48.2319948077,
                                "lng": 17.9207423329
                            },
                            {
                                "lat": 48.2321020961,
                                "lng": 17.9206752777
                            },
                            {
                                "lat": 48.2322375476,
                                "lng": 17.9205814004
                            },
                            {
                                "lat": 48.2323542237,
                                "lng": 17.9205036163
                            },
                            {
                                "lat": 48.2324863225,
                                "lng": 17.9204392433
                            },
                            {
                                "lat": 48.2326237857,
                                "lng": 17.9204446077
                            },
                            {
                                "lat": 48.2327277213,
                                "lng": 17.9205304384
                            },
                            {
                                "lat": 48.2327773422,
                                "lng": 17.9206672311
                            },
                            {
                                "lat": 48.2327967882,
                                "lng": 17.9208120704
                            },
                            {
                                "lat": 48.2328222692,
                                "lng": 17.9209595919
                            },
                            {
                                "lat": 48.232845068,
                                "lng": 17.921128571
                            },
                            {
                                "lat": 48.2328739017,
                                "lng": 17.9213163257
                            },
                            {
                                "lat": 48.2328792661,
                                "lng": 17.9214799404
                            },
                            {
                                "lat": 48.2329060882,
                                "lng": 17.9216516018
                            },
                            {
                                "lat": 48.2329275459,
                                "lng": 17.9217763245
                            },
                            {
                                "lat": 48.2327920943,
                                "lng": 17.9219050705
                            },
                            {
                                "lat": 48.232698217,
                                "lng": 17.9220311344
                            },
                            {
                                "lat": 48.2326700538,
                                "lng": 17.9221746325
                            },
                            {
                                "lat": 48.2326271385,
                                "lng": 17.9223167896
                            },
                            {
                                "lat": 48.2326023281,
                                "lng": 17.9224589467
                            },
                            {
                                "lat": 48.2326003164,
                                "lng": 17.922603786
                            },
                            {
                                "lat": 48.2326076925,
                                "lng": 17.9226654768
                            },
                            {
                                "lat": 48.2326257974,
                                "lng": 17.9227781296
                            },
                            {
                                "lat": 48.2326559722,
                                "lng": 17.9230463505
                            },
                            {
                                "lat": 48.2327277213,
                                "lng": 17.9232689738
                            },
                            {
                                "lat": 48.232788071,
                                "lng": 17.9234862328
                            },
                            {
                                "lat": 48.2328651845,
                                "lng": 17.9236766696
                            },
                            {
                                "lat": 48.2329168171,
                                "lng": 17.9238134623
                            },
                            {
                                "lat": 48.2329563797,
                                "lng": 17.9239743948
                            },
                            {
                                "lat": 48.2330046594,
                                "lng": 17.9241326451
                            },
                            {
                                "lat": 48.233147487,
                                "lng": 17.9242023826
                            },
                            {
                                "lat": 48.2332742214,
                                "lng": 17.9243472219
                            },
                            {
                                "lat": 48.2333667576,
                                "lng": 17.9244464636
                            },
                            {
                                "lat": 48.2334277779,
                                "lng": 17.9245430231
                            },
                            {
                                "lat": 48.2335317135,
                                "lng": 17.9246851802
                            },
                            {
                                "lat": 48.2336155325,
                                "lng": 17.924862206
                            },
                            {
                                "lat": 48.2336544245,
                                "lng": 17.925041914
                            },
                            {
                                "lat": 48.2336651534,
                                "lng": 17.9252430797
                            },
                            {
                                "lat": 48.2336618006,
                                "lng": 17.9254737496
                            },
                            {
                                "lat": 48.2336584479,
                                "lng": 17.9257071018
                            },
                            {
                                "lat": 48.233667165,
                                "lng": 17.9258868098
                            },
                            {
                                "lat": 48.2336584479,
                                "lng": 17.9259699583
                            },
                            {
                                "lat": 48.2336618006,
                                "lng": 17.9261228442
                            },
                            {
                                "lat": 48.2336812466,
                                "lng": 17.926286459
                            },
                            {
                                "lat": 48.2337583601,
                                "lng": 17.9263669252
                            },
                            {
                                "lat": 48.2338777184,
                                "lng": 17.9263240099
                            },
                            {
                                "lat": 48.2340373099,
                                "lng": 17.926222086
                            },
                            {
                                "lat": 48.2342029363,
                                "lng": 17.9261577129
                            },
                            {
                                "lat": 48.2343766093,
                                "lng": 17.9260987043
                            },
                            {
                                "lat": 48.2345120609,
                                "lng": 17.9260611534
                            },
                            {
                                "lat": 48.2346823812,
                                "lng": 17.9260343313
                            },
                            {
                                "lat": 48.2348050922,
                                "lng": 17.9260021448
                            },
                            {
                                "lat": 48.234982118,
                                "lng": 17.9259887338
                            },
                            {
                                "lat": 48.2351001352,
                                "lng": 17.9259887338
                            },
                            {
                                "lat": 48.2352624089,
                                "lng": 17.9259458184
                            },
                            {
                                "lat": 48.2354447991,
                                "lng": 17.9259082675
                            },
                            {
                                "lat": 48.2355768979,
                                "lng": 17.9258814454
                            },
                            {
                                "lat": 48.2356949151,
                                "lng": 17.9258626699
                            },
                            {
                                "lat": 48.235835731,
                                "lng": 17.9258438945
                            },
                            {
                                "lat": 48.2359108329,
                                "lng": 17.9259780049
                            },
                            {
                                "lat": 48.235937655,
                                "lng": 17.9261496663
                            },
                            {
                                "lat": 48.2359792292,
                                "lng": 17.9264259338
                            },
                            {
                                "lat": 48.2360147685,
                                "lng": 17.9265922308
                            },
                            {
                                "lat": 48.2360449433,
                                "lng": 17.9267880321
                            },
                            {
                                "lat": 48.2360952348,
                                "lng": 17.9269865155
                            },
                            {
                                "lat": 48.23615022,
                                "lng": 17.9271769524
                            },
                            {
                                "lat": 48.2361931354,
                                "lng": 17.9273754358
                            },
                            {
                                "lat": 48.236232698,
                                "lng": 17.9275470972
                            },
                            {
                                "lat": 48.2362648845,
                                "lng": 17.9277348518
                            },
                            {
                                "lat": 48.2362863421,
                                "lng": 17.9279601574
                            },
                            {
                                "lat": 48.2363151759,
                                "lng": 17.9281935096
                            },
                            {
                                "lat": 48.2363540679,
                                "lng": 17.9284027219
                            },
                            {
                                "lat": 48.2363936305,
                                "lng": 17.9285824299
                            },
                            {
                                "lat": 48.2364097238,
                                "lng": 17.9287594557
                            },
                            {
                                "lat": 48.2364472747,
                                "lng": 17.9290062189
                            },
                            {
                                "lat": 48.2364593446,
                                "lng": 17.9291322827
                            },
                            {
                                "lat": 48.2364687324,
                                "lng": 17.929341495
                            },
                            {
                                "lat": 48.2364633679,
                                "lng": 17.929507792
                            },
                            {
                                "lat": 48.2364580035,
                                "lng": 17.9297357798
                            },
                            {
                                "lat": 48.2364667207,
                                "lng": 17.9299449921
                            },
                            {
                                "lat": 48.2364754379,
                                "lng": 17.9301461577
                            },
                            {
                                "lat": 48.2364848256,
                                "lng": 17.9303741455
                            },
                            {
                                "lat": 48.236509636,
                                "lng": 17.9306396842
                            },
                            {
                                "lat": 48.2365310937,
                                "lng": 17.9308542609
                            },
                            {
                                "lat": 48.2365599275,
                                "lng": 17.9310500622
                            },
                            {
                                "lat": 48.2365847379,
                                "lng": 17.931291461
                            },
                            {
                                "lat": 48.2366182655,
                                "lng": 17.9315891862
                            },
                            {
                                "lat": 48.2366202772,
                                "lng": 17.9318198562
                            },
                            {
                                "lat": 48.2366222888,
                                "lng": 17.9321283102
                            },
                            {
                                "lat": 48.2366491109,
                                "lng": 17.932471633
                            },
                            {
                                "lat": 48.2366524637,
                                "lng": 17.9326620698
                            },
                            {
                                "lat": 48.2366846502,
                                "lng": 17.9329651594
                            },
                            {
                                "lat": 48.2367188483,
                                "lng": 17.9332280159
                            },
                            {
                                "lat": 48.2367684692,
                                "lng": 17.9334640503
                            },
                            {
                                "lat": 48.2368435711,
                                "lng": 17.9337456822
                            },
                            {
                                "lat": 48.2368992269,
                                "lng": 17.9339548945
                            },
                            {
                                "lat": 48.2369488478,
                                "lng": 17.9341855645
                            },
                            {
                                "lat": 48.2369937748,
                                "lng": 17.9344135523
                            },
                            {
                                "lat": 48.2370011508,
                                "lng": 17.9346656799
                            },
                            {
                                "lat": 48.2369917631,
                                "lng": 17.9348668456
                            },
                            {
                                "lat": 48.2369669527,
                                "lng": 17.9350653291
                            },
                            {
                                "lat": 48.2369508594,
                                "lng": 17.9352718592
                            },
                            {
                                "lat": 48.2369099557,
                                "lng": 17.9354730248
                            },
                            {
                                "lat": 48.2368844748,
                                "lng": 17.935577631
                            },
                            {
                                "lat": 48.2368522882,
                                "lng": 17.9356259108
                            },
                            {
                                "lat": 48.2368180901,
                                "lng": 17.9356728494
                            },
                            {
                                "lat": 48.2367684692,
                                "lng": 17.9357305169
                            },
                            {
                                "lat": 48.236714825,
                                "lng": 17.935757339
                            },
                            {
                                "lat": 48.2366470993,
                                "lng": 17.9357975721
                            },
                            {
                                "lat": 48.2366202772,
                                "lng": 17.9358378053
                            },
                            {
                                "lat": 48.2365968078,
                                "lng": 17.9358914495
                            },
                            {
                                "lat": 48.2366236299,
                                "lng": 17.935950458
                            },
                            {
                                "lat": 48.2366846502,
                                "lng": 17.9360496998
                            },
                            {
                                "lat": 48.2368006557,
                                "lng": 17.936167717
                            },
                            {
                                "lat": 48.2369421422,
                                "lng": 17.9362750053
                            },
                            {
                                "lat": 48.237054795,
                                "lng": 17.9363930225
                            },
                            {
                                "lat": 48.2371687889,
                                "lng": 17.9365003109
                            },
                            {
                                "lat": 48.2373203337,
                                "lng": 17.9367122054
                            },
                            {
                                "lat": 48.2374329865,
                                "lng": 17.9368248582
                            },
                            {
                                "lat": 48.2375972718,
                                "lng": 17.9370126128
                            },
                            {
                                "lat": 48.2377226651,
                                "lng": 17.9371681809
                            },
                            {
                                "lat": 48.237863481,
                                "lng": 17.9373291135
                            },
                            {
                                "lat": 48.2379707694,
                                "lng": 17.9374632239
                            },
                            {
                                "lat": 48.2381015271,
                                "lng": 17.9376429319
                            },
                            {
                                "lat": 48.2382175326,
                                "lng": 17.9377904534
                            },
                            {
                                "lat": 48.2383818179,
                                "lng": 17.9380211234
                            },
                            {
                                "lat": 48.2385051996,
                                "lng": 17.9382115602
                            },
                            {
                                "lat": 48.2386567444,
                                "lng": 17.9383724928
                            },
                            {
                                "lat": 48.238780126,
                                "lng": 17.9385951161
                            },
                            {
                                "lat": 48.2389249653,
                                "lng": 17.9387828708
                            },
                            {
                                "lat": 48.2390483469,
                                "lng": 17.9389894009
                            },
                            {
                                "lat": 48.2392179966,
                                "lng": 17.939222753
                            },
                            {
                                "lat": 48.2393715531,
                                "lng": 17.939440012
                            },
                            {
                                "lat": 48.239594847,
                                "lng": 17.9397752881
                            },
                            {
                                "lat": 48.2397034764,
                                "lng": 17.9399549961
                            },
                            {
                                "lat": 48.2398503274,
                                "lng": 17.940158844
                            },
                            {
                                "lat": 48.2400327176,
                                "lng": 17.9404243827
                            },
                            {
                                "lat": 48.2401822507,
                                "lng": 17.9406523705
                            },
                            {
                                "lat": 48.2402761281,
                                "lng": 17.9407931864
                            },
                            {
                                "lat": 48.2402513176,
                                "lng": 17.9408629239
                            },
                            {
                                "lat": 48.2401943207,
                                "lng": 17.9409702122
                            },
                            {
                                "lat": 48.2401299477,
                                "lng": 17.9410748184
                            },
                            {
                                "lat": 48.240063563,
                                "lng": 17.9411874712
                            },
                            {
                                "lat": 48.2399851084,
                                "lng": 17.9413081706
                            },
                            {
                                "lat": 48.2398992777,
                                "lng": 17.9414583743
                            },
                            {
                                "lat": 48.2397906482,
                                "lng": 17.941557616
                            },
                            {
                                "lat": 48.2397007942,
                                "lng": 17.9416380823
                            },
                            {
                                "lat": 48.2395995408,
                                "lng": 17.9417346418
                            },
                            {
                                "lat": 48.2395298034,
                                "lng": 17.9418097436
                            },
                            {
                                "lat": 48.2394258678,
                                "lng": 17.9419063032
                            },
                            {
                                "lat": 48.2393601537,
                                "lng": 17.9419760406
                            },
                            {
                                "lat": 48.2392850518,
                                "lng": 17.9420565069
                            },
                            {
                                "lat": 48.2392273843,
                                "lng": 17.9421316087
                            },
                            {
                                "lat": 48.239165023,
                                "lng": 17.9421798885
                            },
                            {
                                "lat": 48.2390939444,
                                "lng": 17.9422228038
                            },
                            {
                                "lat": 48.2390403003,
                                "lng": 17.9422925413
                            },
                            {
                                "lat": 48.2390061021,
                                "lng": 17.9423327744
                            },
                            {
                                "lat": 48.2389665395,
                                "lng": 17.942378372
                            },
                            {
                                "lat": 48.2389189303,
                                "lng": 17.9424293339
                            },
                            {
                                "lat": 48.2388344407,
                                "lng": 17.9425017536
                            },
                            {
                                "lat": 48.2387559861,
                                "lng": 17.9425634444
                            },
                            {
                                "lat": 48.238645345,
                                "lng": 17.9426492751
                            },
                            {
                                "lat": 48.2385702431,
                                "lng": 17.9426975548
                            },
                            {
                                "lat": 48.2384971529,
                                "lng": 17.9427699745
                            },
                            {
                                "lat": 48.2384166867,
                                "lng": 17.9428343475
                            },
                            {
                                "lat": 48.2383060455,
                                "lng": 17.9429067671
                            },
                            {
                                "lat": 48.2382041216,
                                "lng": 17.942981869
                            },
                            {
                                "lat": 48.2381290197,
                                "lng": 17.943046242
                            },
                            {
                                "lat": 48.2380968332,
                                "lng": 17.9430945218
                            },
                            {
                                "lat": 48.2380519062,
                                "lng": 17.9431508482
                            },
                            {
                                "lat": 48.2380183786,
                                "lng": 17.9431937635
                            },
                            {
                                "lat": 48.2379573584,
                                "lng": 17.9432313144
                            },
                            {
                                "lat": 48.2378219068,
                                "lng": 17.9432742298
                            },
                            {
                                "lat": 48.2377608865,
                                "lng": 17.9432983696
                            },
                            {
                                "lat": 48.2376609743,
                                "lng": 17.9433600605
                            },
                            {
                                "lat": 48.2375986129,
                                "lng": 17.9434297979
                            },
                            {
                                "lat": 48.2375235111,
                                "lng": 17.94345662
                            },
                            {
                                "lat": 48.2374162227,
                                "lng": 17.9435370862
                            },
                            {
                                "lat": 48.2373337448,
                                "lng": 17.9436229169
                            },
                            {
                                "lat": 48.2372700423,
                                "lng": 17.9436711967
                            },
                            {
                                "lat": 48.2372003049,
                                "lng": 17.9437489808
                            },
                            {
                                "lat": 48.237125203,
                                "lng": 17.9438187182
                            },
                            {
                                "lat": 48.2370534539,
                                "lng": 17.9438857734
                            },
                            {
                                "lat": 48.236996457,
                                "lng": 17.9439367354
                            },
                            {
                                "lat": 48.2369233668,
                                "lng": 17.9439930618
                            },
                            {
                                "lat": 48.2368408889,
                                "lng": 17.9440627992
                            },
                            {
                                "lat": 48.2367698103,
                                "lng": 17.9441030324
                            },
                            {
                                "lat": 48.2367161661,
                                "lng": 17.9441298544
                            },
                            {
                                "lat": 48.236644417,
                                "lng": 17.9441834986
                            },
                            {
                                "lat": 48.2365572453,
                                "lng": 17.9442290962
                            },
                            {
                                "lat": 48.2364714146,
                                "lng": 17.9442666471
                            },
                            {
                                "lat": 48.2363835722,
                                "lng": 17.9443068802
                            },
                            {
                                "lat": 48.2363352925,
                                "lng": 17.9443256557
                            },
                            {
                                "lat": 48.2362923771,
                                "lng": 17.944341749
                            },
                            {
                                "lat": 48.2362105697,
                                "lng": 17.9443497956
                            },
                            {
                                "lat": 48.2361529022,
                                "lng": 17.9443578422
                            },
                            {
                                "lat": 48.2360871881,
                                "lng": 17.9443873465
                            },
                            {
                                "lat": 48.2360228151,
                                "lng": 17.9444168508
                            },
                            {
                                "lat": 48.2359584421,
                                "lng": 17.9444624484
                            },
                            {
                                "lat": 48.2358833402,
                                "lng": 17.9444946349
                            },
                            {
                                "lat": 48.2358068973,
                                "lng": 17.9445402324
                            },
                            {
                                "lat": 48.2357210666,
                                "lng": 17.9445724189
                            },
                            {
                                "lat": 48.2356473058,
                                "lng": 17.9446206987
                            },
                            {
                                "lat": 48.2355815917,
                                "lng": 17.9446582496
                            },
                            {
                                "lat": 48.2355205715,
                                "lng": 17.9446877539
                            },
                            {
                                "lat": 48.2354226708,
                                "lng": 17.9447279871
                            },
                            {
                                "lat": 48.2353489101,
                                "lng": 17.9447494447
                            },
                            {
                                "lat": 48.2352530211,
                                "lng": 17.9447843134
                            },
                            {
                                "lat": 48.2351631671,
                                "lng": 17.9448218644
                            },
                            {
                                "lat": 48.2350880653,
                                "lng": 17.9448728263
                            },
                            {
                                "lat": 48.2350277156,
                                "lng": 17.9449130595
                            },
                            {
                                "lat": 48.2349559665,
                                "lng": 17.9449667037
                            },
                            {
                                "lat": 48.234886229,
                                "lng": 17.944996208
                            },
                            {
                                "lat": 48.2348540425,
                                "lng": 17.9450015724
                            },
                            {
                                "lat": 48.2348077744,
                                "lng": 17.9449720681
                            },
                            {
                                "lat": 48.2347722352,
                                "lng": 17.9449237883
                            },
                            {
                                "lat": 48.2347098738,
                                "lng": 17.9448540509
                            },
                            {
                                "lat": 48.2346776873,
                                "lng": 17.9448084533
                            },
                            {
                                "lat": 48.2346240431,
                                "lng": 17.9447387159
                            },
                            {
                                "lat": 48.234597221,
                                "lng": 17.9447387159
                            },
                            {
                                "lat": 48.2345931977,
                                "lng": 17.9448594153
                            },
                            {
                                "lat": 48.2346005738,
                                "lng": 17.9450069368
                            },
                            {
                                "lat": 48.2346113026,
                                "lng": 17.9451517761
                            },
                            {
                                "lat": 48.2346200198,
                                "lng": 17.9452885687
                            },
                            {
                                "lat": 48.2346307486,
                                "lng": 17.9454173148
                            },
                            {
                                "lat": 48.2346294075,
                                "lng": 17.9455621541
                            },
                            {
                                "lat": 48.2346468419,
                                "lng": 17.9457847774
                            },
                            {
                                "lat": 48.2346595824,
                                "lng": 17.9459564388
                            },
                            {
                                "lat": 48.2347024977,
                                "lng": 17.9461254179
                            },
                            {
                                "lat": 48.234718591,
                                "lng": 17.9462568462
                            },
                            {
                                "lat": 48.234763518,
                                "lng": 17.9464741051
                            },
                            {
                                "lat": 48.2347936928,
                                "lng": 17.9466296732
                            },
                            {
                                "lat": 48.2348117977,
                                "lng": 17.9467530549
                            },
                            {
                                "lat": 48.2348345965,
                                "lng": 17.9468952119
                            },
                            {
                                "lat": 48.2348647714,
                                "lng": 17.9469998181
                            },
                            {
                                "lat": 48.2348775119,
                                "lng": 17.9471285641
                            },
                            {
                                "lat": 48.2349278033,
                                "lng": 17.9472546279
                            },
                            {
                                "lat": 48.2349559665,
                                "lng": 17.9473806918
                            },
                            {
                                "lat": 48.2349707186,
                                "lng": 17.9475174844
                            },
                            {
                                "lat": 48.2349868119,
                                "lng": 17.9476891458
                            },
                            {
                                "lat": 48.2349988818,
                                "lng": 17.9478044808
                            },
                            {
                                "lat": 48.2350029051,
                                "lng": 17.9479037225
                            },
                            {
                                "lat": 48.2350223511,
                                "lng": 17.9480727017
                            },
                            {
                                "lat": 48.23503308,
                                "lng": 17.9481960833
                            },
                            {
                                "lat": 48.2350417972,
                                "lng": 17.9483301938
                            },
                            {
                                "lat": 48.2350954413,
                                "lng": 17.9484830797
                            },
                            {
                                "lat": 48.2351671904,
                                "lng": 17.9486118257
                            },
                            {
                                "lat": 48.2352208346,
                                "lng": 17.9487620294
                            },
                            {
                                "lat": 48.2352778316,
                                "lng": 17.948936373
                            },
                            {
                                "lat": 48.2353334874,
                                "lng": 17.9491080344
                            },
                            {
                                "lat": 48.235386461,
                                "lng": 17.9492636025
                            },
                            {
                                "lat": 48.235450834,
                                "lng": 17.9494138062
                            },
                            {
                                "lat": 48.2355138659,
                                "lng": 17.9496069252
                            },
                            {
                                "lat": 48.2355567813,
                                "lng": 17.9497544467
                            },
                            {
                                "lat": 48.2356459647,
                                "lng": 17.9499422014
                            },
                            {
                                "lat": 48.235726431,
                                "lng": 17.950116545
                            },
                            {
                                "lat": 48.2357566059,
                                "lng": 17.9502479732
                            },
                            {
                                "lat": 48.2357673347,
                                "lng": 17.9504142702
                            },
                            {
                                "lat": 48.2357478887,
                                "lng": 17.950540334
                            },
                            {
                                "lat": 48.2357532531,
                                "lng": 17.9506476223
                            },
                            {
                                "lat": 48.235726431,
                                "lng": 17.9507522285
                            },
                            {
                                "lat": 48.2357224077,
                                "lng": 17.9508541524
                            },
                            {
                                "lat": 48.2356975973,
                                "lng": 17.9509936273
                            },
                            {
                                "lat": 48.2356794924,
                                "lng": 17.9510633647
                            },
                            {
                                "lat": 48.2356580347,
                                "lng": 17.9511733353
                            },
                            {
                                "lat": 48.2356312126,
                                "lng": 17.9512940347
                            },
                            {
                                "lat": 48.2356030494,
                                "lng": 17.9514415562
                            },
                            {
                                "lat": 48.2355708629,
                                "lng": 17.9515971243
                            },
                            {
                                "lat": 48.235540688,
                                "lng": 17.9517124593
                            },
                            {
                                "lat": 48.2355085015,
                                "lng": 17.9518653452
                            },
                            {
                                "lat": 48.2354850322,
                                "lng": 17.9520048201
                            },
                            {
                                "lat": 48.2354454696,
                                "lng": 17.9521684349
                            },
                            {
                                "lat": 48.2354079187,
                                "lng": 17.9522971809
                            },
                            {
                                "lat": 48.2353938371,
                                "lng": 17.9524634778
                            },
                            {
                                "lat": 48.2353918254,
                                "lng": 17.9526592791
                            },
                            {
                                "lat": 48.2353918254,
                                "lng": 17.9528148472
                            },
                            {
                                "lat": 48.2353971899,
                                "lng": 17.9529838264
                            },
                            {
                                "lat": 48.2353938371,
                                "lng": 17.9531286657
                            },
                            {
                                "lat": 48.2353884727,
                                "lng": 17.9532600939
                            },
                            {
                                "lat": 48.2353797555,
                                "lng": 17.953453213
                            },
                            {
                                "lat": 48.2353757322,
                                "lng": 17.9536195099
                            },
                            {
                                "lat": 48.2353636622,
                                "lng": 17.9537804425
                            },
                            {
                                "lat": 48.2353435457,
                                "lng": 17.9539038241
                            },
                            {
                                "lat": 48.2352959365,
                                "lng": 17.9539842904
                            },
                            {
                                "lat": 48.2352080941,
                                "lng": 17.9541184008
                            },
                            {
                                "lat": 48.2351417094,
                                "lng": 17.9542417824
                            },
                            {
                                "lat": 48.2350759953,
                                "lng": 17.9543785751
                            },
                            {
                                "lat": 48.2350008935,
                                "lng": 17.9544992745
                            },
                            {
                                "lat": 48.2349385321,
                                "lng": 17.9546146095
                            },
                            {
                                "lat": 48.2348687947,
                                "lng": 17.9547514021
                            },
                            {
                                "lat": 48.2347809523,
                                "lng": 17.9548962414
                            },
                            {
                                "lat": 48.2346723229,
                                "lng": 17.9551135004
                            },
                            {
                                "lat": 48.2345724106,
                                "lng": 17.9552958906
                            },
                            {
                                "lat": 48.2344651222,
                                "lng": 17.9554755986
                            },
                            {
                                "lat": 48.2343645394,
                                "lng": 17.9556284845
                            },
                            {
                                "lat": 48.2342344522,
                                "lng": 17.9558189213
                            },
                            {
                                "lat": 48.2340949774,
                                "lng": 17.9560415447
                            },
                            {
                                "lat": 48.2339863479,
                                "lng": 17.9562748969
                            },
                            {
                                "lat": 48.2338502258,
                                "lng": 17.9565055668
                            },
                            {
                                "lat": 48.2337503135,
                                "lng": 17.9566852748
                            },
                            {
                                "lat": 48.2336141914,
                                "lng": 17.9568998516
                            },
                            {
                                "lat": 48.2334841043,
                                "lng": 17.9570044577
                            },
                            {
                                "lat": 48.233319819,
                                "lng": 17.9571788013
                            },
                            {
                                "lat": 48.2331555337,
                                "lng": 17.9574121535
                            },
                            {
                                "lat": 48.2330388576,
                                "lng": 17.9575757682
                            },
                            {
                                "lat": 48.2329000533,
                                "lng": 17.9577983916
                            },
                            {
                                "lat": 48.2327833772,
                                "lng": 17.9579512775
                            },
                            {
                                "lat": 48.2326553017,
                                "lng": 17.958098799
                            },
                            {
                                "lat": 48.2325835526,
                                "lng": 17.9582087696
                            },
                            {
                                "lat": 48.2324863225,
                                "lng": 17.9582986236
                            },
                            {
                                "lat": 48.2323944569,
                                "lng": 17.9583857954
                            },
                            {
                                "lat": 48.2323367894,
                                "lng": 17.9584287107
                            },
                            {
                                "lat": 48.2322925329,
                                "lng": 17.9583777487
                            },
                            {
                                "lat": 48.2321993262,
                                "lng": 17.9582463205
                            },
                            {
                                "lat": 48.2320994139,
                                "lng": 17.9580800235
                            },
                            {
                                "lat": 48.2320209593,
                                "lng": 17.9579405487
                            },
                            {
                                "lat": 48.2318902016,
                                "lng": 17.9576562345
                            },
                            {
                                "lat": 48.2317654788,
                                "lng": 17.95744434
                            },
                            {
                                "lat": 48.2316669077,
                                "lng": 17.957278043
                            },
                            {
                                "lat": 48.2315938175,
                                "lng": 17.9571519792
                            },
                            {
                                "lat": 48.2315187156,
                                "lng": 17.9570285976
                            },
                            {
                                "lat": 48.2314456254,
                                "lng": 17.9568864405
                            },
                            {
                                "lat": 48.2313832641,
                                "lng": 17.9567603767
                            },
                            {
                                "lat": 48.2313048095,
                                "lng": 17.9566624761
                            },
                            {
                                "lat": 48.2312491536,
                                "lng": 17.9565645754
                            },
                            {
                                "lat": 48.2311881334,
                                "lng": 17.9564626515
                            },
                            {
                                "lat": 48.2311277837,
                                "lng": 17.9563365877
                            },
                            {
                                "lat": 48.231061399,
                                "lng": 17.9562266171
                            },
                            {
                                "lat": 48.2310057431,
                                "lng": 17.9561085999
                            },
                            {
                                "lat": 48.2309252769,
                                "lng": 17.9559610784
                            },
                            {
                                "lat": 48.2308662683,
                                "lng": 17.95585379
                            },
                            {
                                "lat": 48.2307972014,
                                "lng": 17.9557572305
                            },
                            {
                                "lat": 48.2307288051,
                                "lng": 17.9556633532
                            },
                            {
                                "lat": 48.2306309044,
                                "lng": 17.9555828869
                            },
                            {
                                "lat": 48.2305591553,
                                "lng": 17.9555372894
                            },
                            {
                                "lat": 48.2304625958,
                                "lng": 17.9555426538
                            },
                            {
                                "lat": 48.2303700596,
                                "lng": 17.9554782808
                            },
                            {
                                "lat": 48.2303090394,
                                "lng": 17.9554085433
                            },
                            {
                                "lat": 48.2302520424,
                                "lng": 17.9553173482
                            },
                            {
                                "lat": 48.2301843166,
                                "lng": 17.9551886022
                            },
                            {
                                "lat": 48.230137378,
                                "lng": 17.9551027715
                            },
                            {
                                "lat": 48.2300837338,
                                "lng": 17.9549579322
                            },
                            {
                                "lat": 48.2300126553,
                                "lng": 17.9548613727
                            },
                            {
                                "lat": 48.229951635,
                                "lng": 17.9547648132
                            },
                            {
                                "lat": 48.2298765332,
                                "lng": 17.9546253383
                            },
                            {
                                "lat": 48.2298088074,
                                "lng": 17.9545126855
                            },
                            {
                                "lat": 48.2297370583,
                                "lng": 17.9544000328
                            },
                            {
                                "lat": 48.2296552509,
                                "lng": 17.9542820156
                            },
                            {
                                "lat": 48.2295694202,
                                "lng": 17.9541586339
                            },
                            {
                                "lat": 48.2294835895,
                                "lng": 17.9540191591
                            },
                            {
                                "lat": 48.22938703,
                                "lng": 17.9538474977
                            },
                            {
                                "lat": 48.2292797416,
                                "lng": 17.9537026584
                            },
                            {
                                "lat": 48.2291617244,
                                "lng": 17.953568548
                            },
                            {
                                "lat": 48.2290691882,
                                "lng": 17.9534880817
                            },
                            {
                                "lat": 48.228969276,
                                "lng": 17.9533647001
                            },
                            {
                                "lat": 48.2288546115,
                                "lng": 17.9532681406
                            },
                            {
                                "lat": 48.2287117839,
                                "lng": 17.9531876743
                            },
                            {
                                "lat": 48.228629306,
                                "lng": 17.9531340301
                            },
                            {
                                "lat": 48.2285186648,
                                "lng": 17.9530857503
                            },
                            {
                                "lat": 48.2284542918,
                                "lng": 17.9530267417
                            },
                            {
                                "lat": 48.2283402979,
                                "lng": 17.9530052841
                            },
                            {
                                "lat": 48.2282363623,
                                "lng": 17.9529570043
                            },
                            {
                                "lat": 48.2281471789,
                                "lng": 17.9528872669
                            },
                            {
                                "lat": 48.2280579954,
                                "lng": 17.9527799785
                            },
                            {
                                "lat": 48.2279895991,
                                "lng": 17.9526941478
                            },
                            {
                                "lat": 48.2279151678,
                                "lng": 17.9525868595
                            },
                            {
                                "lat": 48.2278682292,
                                "lng": 17.9524312913
                            },
                            {
                                "lat": 48.2278078794,
                                "lng": 17.9522971809
                            },
                            {
                                "lat": 48.2277435064,
                                "lng": 17.952157706
                            },
                            {
                                "lat": 48.227693215,
                                "lng": 17.9520182312
                            },
                            {
                                "lat": 48.227628842,
                                "lng": 17.9518519342
                            },
                            {
                                "lat": 48.2275684923,
                                "lng": 17.9516963661
                            },
                            {
                                "lat": 48.227507472,
                                "lng": 17.9515890777
                            },
                            {
                                "lat": 48.2274075598,
                                "lng": 17.9513262212
                            },
                            {
                                "lat": 48.2273136824,
                                "lng": 17.9511076212
                            },
                            {
                                "lat": 48.2272385806,
                                "lng": 17.9509305954
                            },
                            {
                                "lat": 48.2271748781,
                                "lng": 17.9507254064
                            },
                            {
                                "lat": 48.22712861,
                                "lng": 17.9505752027
                            },
                            {
                                "lat": 48.2270716131,
                                "lng": 17.9504196346
                            },
                            {
                                "lat": 48.2269891351,
                                "lng": 17.9502318799
                            },
                            {
                                "lat": 48.2269462198,
                                "lng": 17.9501138628
                            },
                            {
                                "lat": 48.2268603891,
                                "lng": 17.9498295486
                            },
                            {
                                "lat": 48.2267745584,
                                "lng": 17.9496203363
                            },
                            {
                                "lat": 48.2266746461,
                                "lng": 17.9493199289
                            },
                            {
                                "lat": 48.2265854627,
                                "lng": 17.9491268098
                            },
                            {
                                "lat": 48.2264781743,
                                "lng": 17.948885411
                            },
                            {
                                "lat": 48.226370886,
                                "lng": 17.9486654699
                            },
                            {
                                "lat": 48.2263031602,
                                "lng": 17.9484723508
                            },
                            {
                                "lat": 48.2262280583,
                                "lng": 17.9482899606
                            },
                            {
                                "lat": 48.2260818779,
                                "lng": 17.9479412735
                            },
                            {
                                "lat": 48.2260530442,
                                "lng": 17.9478232563
                            },
                            {
                                "lat": 48.2259564847,
                                "lng": 17.9476086795
                            },
                            {
                                "lat": 48.2259102166,
                                "lng": 17.9473887384
                            },
                            {
                                "lat": 48.2257955521,
                                "lng": 17.9471956193
                            },
                            {
                                "lat": 48.2257244736,
                                "lng": 17.9469810426
                            },
                            {
                                "lat": 48.2256527245,
                                "lng": 17.9468308389
                            },
                            {
                                "lat": 48.2255380601,
                                "lng": 17.9465948045
                            },
                            {
                                "lat": 48.2254099846,
                                "lng": 17.9462729394
                            },
                            {
                                "lat": 48.2252812386,
                                "lng": 17.945843786
                            },
                            {
                                "lat": 48.2251524925,
                                "lng": 17.9456292093
                            },
                            {
                                "lat": 48.2249519974,
                                "lng": 17.9452858865
                            },
                            {
                                "lat": 48.2248809189,
                                "lng": 17.9449640214
                            },
                            {
                                "lat": 48.2247521728,
                                "lng": 17.9446206987
                            },
                            {
                                "lat": 48.2245664299,
                                "lng": 17.9441915452
                            },
                            {
                                "lat": 48.2244236022,
                                "lng": 17.9437623918
                            },
                            {
                                "lat": 48.224280104,
                                "lng": 17.943354696
                            },
                            {
                                "lat": 48.2241372764,
                                "lng": 17.9429684579
                            },
                            {
                                "lat": 48.223965615,
                                "lng": 17.9425607622
                            },
                            {
                                "lat": 48.2238087058,
                                "lng": 17.9421745241
                            },
                            {
                                "lat": 48.2235800475,
                                "lng": 17.9417024553
                            },
                            {
                                "lat": 48.2233225554,
                                "lng": 17.9410158098
                            },
                            {
                                "lat": 48.2230938971,
                                "lng": 17.940543741
                            },
                            {
                                "lat": 48.2229081541,
                                "lng": 17.9400287569
                            },
                            {
                                "lat": 48.2227364928,
                                "lng": 17.9396425188
                            },
                            {
                                "lat": 48.222521916,
                                "lng": 17.939234823
                            },
                            {
                                "lat": 48.2223650068,
                                "lng": 17.9388271272
                            },
                            {
                                "lat": 48.2221933454,
                                "lng": 17.9384838045
                            },
                            {
                                "lat": 48.2220357656,
                                "lng": 17.9382263124
                            },
                            {
                                "lat": 48.2219217718,
                                "lng": 17.9379688203
                            },
                            {
                                "lat": 48.2219003141,
                                "lng": 17.9381082952
                            },
                            {
                                "lat": 48.221828565,
                                "lng": 17.9383014143
                            },
                            {
                                "lat": 48.2217789441,
                                "lng": 17.9384408891
                            },
                            {
                                "lat": 48.2217360288,
                                "lng": 17.9385910928
                            },
                            {
                                "lat": 48.2215657085,
                                "lng": 17.9387117922
                            },
                            {
                                "lat": 48.2213571668,
                                "lng": 17.9389505088
                            },
                            {
                                "lat": 48.2212237269,
                                "lng": 17.9391731322
                            },
                            {
                                "lat": 48.2210634649,
                                "lng": 17.9393568635
                            },
                            {
                                "lat": 48.2209099084,
                                "lng": 17.9395499825
                            },
                            {
                                "lat": 48.2207985967,
                                "lng": 17.9397511482
                            },
                            {
                                "lat": 48.2206785679,
                                "lng": 17.9398463666
                            },
                            {
                                "lat": 48.220519647,
                                "lng": 17.939940244
                            },
                            {
                                "lat": 48.2204224169,
                                "lng": 17.9401414096
                            },
                            {
                                "lat": 48.2202588022,
                                "lng": 17.9403533041
                            },
                            {
                                "lat": 48.2202239335,
                                "lng": 17.9403989017
                            },
                            {
                                "lat": 48.220109269,
                                "lng": 17.9405598342
                            },
                            {
                                "lat": 48.2199878991,
                                "lng": 17.9407529533
                            },
                            {
                                "lat": 48.2198021561,
                                "lng": 17.9410748184
                            },
                            {
                                "lat": 48.2196378708,
                                "lng": 17.9413215816
                            },
                            {
                                "lat": 48.2194232941,
                                "lng": 17.941557616
                            },
                            {
                                "lat": 48.219294548,
                                "lng": 17.9417936504
                            },
                            {
                                "lat": 48.2191731781,
                                "lng": 17.9419867694
                            },
                            {
                                "lat": 48.219044432,
                                "lng": 17.9422013462
                            },
                            {
                                "lat": 48.2188727707,
                                "lng": 17.9424695671
                            },
                            {
                                "lat": 48.2186796516,
                                "lng": 17.9428128898
                            },
                            {
                                "lat": 48.2184369117,
                                "lng": 17.9431562126
                            },
                            {
                                "lat": 48.218222335,
                                "lng": 17.9435531795
                            },
                            {
                                "lat": 48.2180432975,
                                "lng": 17.9438321292
                            },
                            {
                                "lat": 48.217843473,
                                "lng": 17.9441647232
                            },
                            {
                                "lat": 48.217600733,
                                "lng": 17.9445724189
                            },
                            {
                                "lat": 48.217407614,
                                "lng": 17.9448728263
                            },
                            {
                                "lat": 48.2172071189,
                                "lng": 17.9452268779
                            },
                            {
                                "lat": 48.2168423384,
                                "lng": 17.9458276927
                            },
                            {
                                "lat": 48.2165995985,
                                "lng": 17.9462246597
                            },
                            {
                                "lat": 48.2163421065,
                                "lng": 17.9466216266
                            },
                            {
                                "lat": 48.2160919905,
                                "lng": 17.9470829666
                            },
                            {
                                "lat": 48.2158418745,
                                "lng": 17.9474799335
                            },
                            {
                                "lat": 48.2155200094,
                                "lng": 17.9480780661
                            },
                            {
                                "lat": 48.2151766866,
                                "lng": 17.9485635459
                            },
                            {
                                "lat": 48.2147978246,
                                "lng": 17.9491321743
                            },
                            {
                                "lat": 48.2143693417,
                                "lng": 17.95000121
                            },
                            {
                                "lat": 48.2140119374,
                                "lng": 17.9505483806
                            },
                            {
                                "lat": 48.2136967778,
                                "lng": 17.9510097206
                            },
                            {
                                "lat": 48.2133682072,
                                "lng": 17.9515783489
                            },
                            {
                                "lat": 48.2132039219,
                                "lng": 17.9518894851
                            },
                            {
                                "lat": 48.2128391415,
                                "lng": 17.9524902999
                            },
                            {
                                "lat": 48.2125105709,
                                "lng": 17.9530374706
                            },
                            {
                                "lat": 48.2121954113,
                                "lng": 17.953530997
                            },
                            {
                                "lat": 48.2119955868,
                                "lng": 17.953927964
                            },
                            {
                                "lat": 48.211652264,
                                "lng": 17.9544644058
                            },
                            {
                                "lat": 48.2113733143,
                                "lng": 17.9548721015
                            },
                            {
                                "lat": 48.2111446559,
                                "lng": 17.9552797973
                            },
                            {
                                "lat": 48.2108590007,
                                "lng": 17.9558055103
                            },
                            {
                                "lat": 48.2106229663,
                                "lng": 17.9562239349
                            },
                            {
                                "lat": 48.2104439288,
                                "lng": 17.9564492404
                            },
                            {
                                "lat": 48.2102226466,
                                "lng": 17.9567818344
                            },
                            {
                                "lat": 48.2099510729,
                                "lng": 17.9572324455
                            },
                            {
                                "lat": 48.2097934932,
                                "lng": 17.9574684799
                            },
                            {
                                "lat": 48.2096218318,
                                "lng": 17.9577581584
                            },
                            {
                                "lat": 48.2094575465,
                                "lng": 17.9580907524
                            },
                            {
                                "lat": 48.2093288004,
                                "lng": 17.958278507
                            },
                            {
                                "lat": 48.2092107832,
                                "lng": 17.958471626
                            },
                            {
                                "lat": 48.2091430575,
                                "lng": 17.9585950077
                            },
                            {
                                "lat": 48.2090498507,
                                "lng": 17.9585038126
                            },
                            {
                                "lat": 48.2089211047,
                                "lng": 17.9583482444
                            },
                            {
                                "lat": 48.2087601721,
                                "lng": 17.9581765831
                            },
                            {
                                "lat": 48.2086602598,
                                "lng": 17.9580424726
                            },
                            {
                                "lat": 48.2085529715,
                                "lng": 17.9579298198
                            },
                            {
                                "lat": 48.2084242254,
                                "lng": 17.9577581584
                            },
                            {
                                "lat": 48.2082599401,
                                "lng": 17.9575757682
                            },
                            {
                                "lat": 48.2081526518,
                                "lng": 17.9573987424
                            },
                            {
                                "lat": 48.2079454511,
                                "lng": 17.9571305215
                            },
                            {
                                "lat": 48.2078200579,
                                "lng": 17.9569588602
                            },
                            {
                                "lat": 48.2076591253,
                                "lng": 17.9567925632
                            },
                            {
                                "lat": 48.2074552774,
                                "lng": 17.9565833509
                            },
                            {
                                "lat": 48.2073339075,
                                "lng": 17.9564331472
                            },
                            {
                                "lat": 48.2071910799,
                                "lng": 17.9561971128
                            },
                            {
                                "lat": 48.2070549577,
                                "lng": 17.9560630023
                            },
                            {
                                "lat": 48.2069087774,
                                "lng": 17.9559020698
                            },
                            {
                                "lat": 48.2068048418,
                                "lng": 17.9557679594
                            },
                            {
                                "lat": 48.2065654546,
                                "lng": 17.9554729164
                            },
                            {
                                "lat": 48.2064796239,
                                "lng": 17.9553495347
                            },
                            {
                                "lat": 48.2063616067,
                                "lng": 17.9551886022
                            },
                            {
                                "lat": 48.2062328607,
                                "lng": 17.9550383985
                            },
                            {
                                "lat": 48.2061436772,
                                "lng": 17.9548506439
                            },
                            {
                                "lat": 48.2060752809,
                                "lng": 17.954775542
                            },
                            {
                                "lat": 48.2061684877,
                                "lng": 17.9546521604
                            },
                            {
                                "lat": 48.2063220441,
                                "lng": 17.9544536769
                            },
                            {
                                "lat": 48.2064507902,
                                "lng": 17.9542283714
                            },
                            {
                                "lat": 48.206582889,
                                "lng": 17.9538957775
                            },
                            {
                                "lat": 48.206737116,
                                "lng": 17.953568548
                            },
                            {
                                "lat": 48.2068873197,
                                "lng": 17.9532949626
                            },
                            {
                                "lat": 48.2070408762,
                                "lng": 17.9530160129
                            },
                            {
                                "lat": 48.2071910799,
                                "lng": 17.9527156055
                            },
                            {
                                "lat": 48.2074123621,
                                "lng": 17.9522918165
                            },
                            {
                                "lat": 48.207551837,
                                "lng": 17.9520450532
                            },
                            {
                                "lat": 48.2077053934,
                                "lng": 17.9517875612
                            },
                            {
                                "lat": 48.2078985125,
                                "lng": 17.9514656961
                            },
                            {
                                "lat": 48.208020553,
                                "lng": 17.9513262212
                            },
                            {
                                "lat": 48.2081345469,
                                "lng": 17.9511062801
                            },
                            {
                                "lat": 48.2081848383,
                                "lng": 17.9508219659
                            },
                            {
                                "lat": 48.2081130892,
                                "lng": 17.950553745
                            },
                            {
                                "lat": 48.2079736143,
                                "lng": 17.9502265155
                            },
                            {
                                "lat": 48.2078448683,
                                "lng": 17.9498831928
                            },
                            {
                                "lat": 48.2077664137,
                                "lng": 17.9496954381
                            },
                            {
                                "lat": 48.2076410204,
                                "lng": 17.9494003952
                            },
                            {
                                "lat": 48.2075344026,
                                "lng": 17.9491482675
                            },
                            {
                                "lat": 48.2074271142,
                                "lng": 17.9489122331
                            },
                            {
                                "lat": 48.2073231786,
                                "lng": 17.948627919
                            },
                            {
                                "lat": 48.2071977854,
                                "lng": 17.9482899606
                            },
                            {
                                "lat": 48.2070978731,
                                "lng": 17.9480110109
                            },
                            {
                                "lat": 48.2069724798,
                                "lng": 17.94774279
                            },
                            {
                                "lat": 48.2068444043,
                                "lng": 17.9473619163
                            },
                            {
                                "lat": 48.2067297399,
                                "lng": 17.9471044242
                            },
                            {
                                "lat": 48.2065580785,
                                "lng": 17.946691364
                            },
                            {
                                "lat": 48.2064507902,
                                "lng": 17.9463641346
                            },
                            {
                                "lat": 48.2063616067,
                                "lng": 17.9461441934
                            },
                            {
                                "lat": 48.2062362134,
                                "lng": 17.9458598793
                            },
                            {
                                "lat": 48.2060109079,
                                "lng": 17.9452966154
                            },
                            {
                                "lat": 48.2058466226,
                                "lng": 17.9448460042
                            },
                            {
                                "lat": 48.205703795,
                                "lng": 17.9444919527
                            },
                            {
                                "lat": 48.2055535913,
                                "lng": 17.9440842569
                            },
                            {
                                "lat": 48.2053745538,
                                "lng": 17.9435907304
                            },
                            {
                                "lat": 48.2051747292,
                                "lng": 17.943161577
                            },
                            {
                                "lat": 48.205031231,
                                "lng": 17.9426573217
                            },
                            {
                                "lat": 48.2048810273,
                                "lng": 17.9422710836
                            },
                            {
                                "lat": 48.2046738267,
                                "lng": 17.9417346418
                            },
                            {
                                "lat": 48.2045169175,
                                "lng": 17.941326946
                            },
                            {
                                "lat": 48.2044377923,
                                "lng": 17.941069454
                            },
                            {
                                "lat": 48.2042949647,
                                "lng": 17.9408763349
                            },
                            {
                                "lat": 48.2041950524,
                                "lng": 17.9408924282
                            },
                            {
                                "lat": 48.2041588426,
                                "lng": 17.9409728944
                            },
                            {
                                "lat": 48.2041803002,
                                "lng": 17.9413537681
                            },
                            {
                                "lat": 48.204087764,
                                "lng": 17.9415147007
                            },
                            {
                                "lat": 48.2040589303,
                                "lng": 17.9416327178
                            },
                            {
                                "lat": 48.2038658112,
                                "lng": 17.9418365657
                            },
                            {
                                "lat": 48.2037518173,
                                "lng": 17.9420082271
                            },
                            {
                                "lat": 48.2035727799,
                                "lng": 17.9422228038
                            },
                            {
                                "lat": 48.2034152001,
                                "lng": 17.9424266517
                            },
                            {
                                "lat": 48.2031798363,
                                "lng": 17.9427056015
                            },
                            {
                                "lat": 48.2029223442,
                                "lng": 17.9429738224
                            },
                            {
                                "lat": 48.2027077675,
                                "lng": 17.9431883991
                            },
                            {
                                "lat": 48.2024931908,
                                "lng": 17.9434995353
                            },
                            {
                                "lat": 48.2022926956,
                                "lng": 17.9436819255
                            },
                            {
                                "lat": 48.2021069527,
                                "lng": 17.9439286888
                            },
                            {
                                "lat": 48.2019212097,
                                "lng": 17.9441218078
                            },
                            {
                                "lat": 48.2016637176,
                                "lng": 17.9443900287
                            },
                            {
                                "lat": 48.2014136016,
                                "lng": 17.9446582496
                            },
                            {
                                "lat": 48.2012131065,
                                "lng": 17.9449050128
                            },
                            {
                                "lat": 48.2009911537,
                                "lng": 17.9451625049
                            },
                            {
                                "lat": 48.2007054985,
                                "lng": 17.9454950988
                            },
                            {
                                "lat": 48.2004835457,
                                "lng": 17.9456882179
                            },
                            {
                                "lat": 48.1998827308,
                                "lng": 17.9463963211
                            },
                            {
                                "lat": 48.1995467842,
                                "lng": 17.9467611015
                            },
                            {
                                "lat": 48.1991109252,
                                "lng": 17.9471795261
                            },
                            {
                                "lat": 48.1988319755,
                                "lng": 17.9475550354
                            },
                            {
                                "lat": 48.198459819,
                                "lng": 17.9479198158
                            },
                            {
                                "lat": 48.1981024146,
                                "lng": 17.9483060539
                            },
                            {
                                "lat": 48.1978590041,
                                "lng": 17.9485957325
                            },
                            {
                                "lat": 48.1975800544,
                                "lng": 17.9489283264
                            },
                            {
                                "lat": 48.1971938163,
                                "lng": 17.9494003952
                            },
                            {
                                "lat": 48.1967646629,
                                "lng": 17.9498939216
                            },
                            {
                                "lat": 48.1962355971,
                                "lng": 17.9504840076
                            },
                            {
                                "lat": 48.1958996505,
                                "lng": 17.9508595169
                            },
                            {
                                "lat": 48.1954490393,
                                "lng": 17.951310128
                            },
                            {
                                "lat": 48.1951700896,
                                "lng": 17.9516427219
                            },
                            {
                                "lat": 48.1947623938,
                                "lng": 17.9522006214
                            },
                            {
                                "lat": 48.1943546981,
                                "lng": 17.9525868595
                            },
                            {
                                "lat": 48.1939972937,
                                "lng": 17.9529730976
                            },
                            {
                                "lat": 48.1936184317,
                                "lng": 17.953402251
                            },
                            {
                                "lat": 48.1931678206,
                                "lng": 17.9538957775
                            },
                            {
                                "lat": 48.1929029524,
                                "lng": 17.9541747272
                            },
                            {
                                "lat": 48.1926099211,
                                "lng": 17.9544751346
                            },
                            {
                                "lat": 48.1922303885,
                                "lng": 17.9548613727
                            },
                            {
                                "lat": 48.1921606511,
                                "lng": 17.9549793899
                            },
                            {
                                "lat": 48.1920801848,
                                "lng": 17.9551000893
                            },
                            {
                                "lat": 48.1919856369,
                                "lng": 17.9552100599
                            },
                            {
                                "lat": 48.1919212639,
                                "lng": 17.9552905262
                            },
                            {
                                "lat": 48.1919608265,
                                "lng": 17.9553709924
                            },
                            {
                                "lat": 48.192005083,
                                "lng": 17.9554836452
                            },
                            {
                                "lat": 48.1920821965,
                                "lng": 17.9556043446
                            },
                            {
                                "lat": 48.1921821088,
                                "lng": 17.9557357728
                            },
                            {
                                "lat": 48.1922719628,
                                "lng": 17.9558296502
                            },
                            {
                                "lat": 48.1923859566,
                                "lng": 17.9559288919
                            },
                            {
                                "lat": 48.1923510879,
                                "lng": 17.9559490085
                            },
                            {
                                "lat": 48.1923121959,
                                "lng": 17.9559597373
                            },
                            {
                                "lat": 48.192184791,
                                "lng": 17.9559248686
                            },
                            {
                                "lat": 48.1920815259,
                                "lng": 17.9558899999
                            },
                            {
                                "lat": 48.1919702142,
                                "lng": 17.9558229446
                            },
                            {
                                "lat": 48.1918615848,
                                "lng": 17.9557478428
                            },
                            {
                                "lat": 48.1917844713,
                                "lng": 17.9555949569
                            },
                            {
                                "lat": 48.1917650253,
                                "lng": 17.9555144906
                            },
                            {
                                "lat": 48.2041098922,
                                "lng": 17.9408803582
                            },
                            {
                                "lat": 48.2040482014,
                                "lng": 17.940774411
                            },
                            {
                                "lat": 48.2039999217,
                                "lng": 17.940621525
                            },
                            {
                                "lat": 48.2039214671,
                                "lng": 17.9404900968
                            },
                            {
                                "lat": 48.203849718,
                                "lng": 17.9403237998
                            },
                            {
                                "lat": 48.2037947327,
                                "lng": 17.9401655495
                            },
                            {
                                "lat": 48.2037625462,
                                "lng": 17.94006899
                            },
                            {
                                "lat": 48.203708902,
                                "lng": 17.9398839176
                            },
                            {
                                "lat": 48.2036907971,
                                "lng": 17.939773947
                            },
                            {
                                "lat": 48.2038698345,
                                "lng": 17.9396827519
                            },
                            {
                                "lat": 48.2041199505,
                                "lng": 17.9395325482
                            },
                            {
                                "lat": 48.204357326,
                                "lng": 17.939414531
                            },
                            {
                                "lat": 48.2047811151,
                                "lng": 17.9391650856
                            },
                            {
                                "lat": 48.2050620764,
                                "lng": 17.9390336573
                            },
                            {
                                "lat": 48.2052766532,
                                "lng": 17.9389156401
                            },
                            {
                                "lat": 48.205556944,
                                "lng": 17.9387573898
                            },
                            {
                                "lat": 48.2058177888,
                                "lng": 17.9386098683
                            },
                            {
                                "lat": 48.2060451061,
                                "lng": 17.9384945333
                            },
                            {
                                "lat": 48.206295222,
                                "lng": 17.9383631051
                            },
                            {
                                "lat": 48.2066901773,
                                "lng": 17.9381404817
                            },
                            {
                                "lat": 48.2070247829,
                                "lng": 17.9380331933
                            },
                            {
                                "lat": 48.2075572014,
                                "lng": 17.9378293455
                            },
                            {
                                "lat": 48.2078200579,
                                "lng": 17.9377327859
                            },
                            {
                                "lat": 48.2081452757,
                                "lng": 17.9375799
                            },
                            {
                                "lat": 48.2086193562,
                                "lng": 17.9373733699
                            },
                            {
                                "lat": 48.2089029998,
                                "lng": 17.9372473061
                            },
                            {
                                "lat": 48.2091249526,
                                "lng": 17.9371373355
                            },
                            {
                                "lat": 48.2095433772,
                                "lng": 17.9369281232
                            },
                            {
                                "lat": 48.2097686827,
                                "lng": 17.9368181527
                            },
                            {
                                "lat": 48.209997341,
                                "lng": 17.9366867244
                            },
                            {
                                "lat": 48.2103835791,
                                "lng": 17.9364185035
                            },
                            {
                                "lat": 48.2106176019,
                                "lng": 17.936257571
                            },
                            {
                                "lat": 48.2108160853,
                                "lng": 17.9360483587
                            },
                            {
                                "lat": 48.2109622657,
                                "lng": 17.9359222949
                            },
                            {
                                "lat": 48.2112036645,
                                "lng": 17.9357291758
                            },
                            {
                                "lat": 48.2114075124,
                                "lng": 17.935538739
                            },
                            {
                                "lat": 48.2116448879,
                                "lng": 17.9353348911
                            },
                            {
                                "lat": 48.2116931677,
                                "lng": 17.9352678359
                            },
                            {
                                "lat": 48.2116435468,
                                "lng": 17.935141772
                            },
                            {
                                "lat": 48.2115919143,
                                "lng": 17.9349862039
                            },
                            {
                                "lat": 48.2115201652,
                                "lng": 17.934846729
                            },
                            {
                                "lat": 48.2114578038,
                                "lng": 17.9347072542
                            },
                            {
                                "lat": 48.211402148,
                                "lng": 17.9345838726
                            },
                            {
                                "lat": 48.2114806026,
                                "lng": 17.9343907535
                            },
                            {
                                "lat": 48.211575821,
                                "lng": 17.9342512786
                            },
                            {
                                "lat": 48.2116576284,
                                "lng": 17.9341010749
                            },
                            {
                                "lat": 48.2117541879,
                                "lng": 17.933934778
                            },
                            {
                                "lat": 48.2118507475,
                                "lng": 17.9337202013
                            },
                            {
                                "lat": 48.2119493186,
                                "lng": 17.9334895313
                            },
                            {
                                "lat": 48.2120425254,
                                "lng": 17.9332776368
                            },
                            {
                                "lat": 48.212197423,
                                "lng": 17.9330603778
                            },
                            {
                                "lat": 48.2122866064,
                                "lng": 17.9328645766
                            },
                            {
                                "lat": 48.2123885304,
                                "lng": 17.9327116907
                            },
                            {
                                "lat": 48.2125192881,
                                "lng": 17.9325051606
                            },
                            {
                                "lat": 48.212601766,
                                "lng": 17.9323281348
                            },
                            {
                                "lat": 48.2126708329,
                                "lng": 17.9321618378
                            },
                            {
                                "lat": 48.2127298415,
                                "lng": 17.932035774
                            },
                            {
                                "lat": 48.2128176838,
                                "lng": 17.9320062697
                            },
                            {
                                "lat": 48.2128391415,
                                "lng": 17.9317729175
                            },
                            {
                                "lat": 48.2128304243,
                                "lng": 17.9314510524
                            },
                            {
                                "lat": 48.2128143311,
                                "lng": 17.9311801493
                            },
                            {
                                "lat": 48.2128196955,
                                "lng": 17.930906564
                            },
                            {
                                "lat": 48.2128445059,
                                "lng": 17.9305283725
                            },
                            {
                                "lat": 48.2128505409,
                                "lng": 17.9302226007
                            },
                            {
                                "lat": 48.2128820568,
                                "lng": 17.9297424853
                            },
                            {
                                "lat": 48.2128733397,
                                "lng": 17.9293401539
                            },
                            {
                                "lat": 48.2128250599,
                                "lng": 17.9288734496
                            },
                            {
                                "lat": 48.2126922905,
                                "lng": 17.9283101857
                            },
                            {
                                "lat": 48.2125964016,
                                "lng": 17.9279775918
                            },
                            {
                                "lat": 48.2124763727,
                                "lng": 17.9275859892
                            },
                            {
                                "lat": 48.2123979181,
                                "lng": 17.9273284972
                            },
                            {
                                "lat": 48.2123348862,
                                "lng": 17.9271568358
                            },
                            {
                                "lat": 48.2122638077,
                                "lng": 17.9268617928
                            },
                            {
                                "lat": 48.2121102512,
                                "lng": 17.926376313
                            },
                            {
                                "lat": 48.2120364904,
                                "lng": 17.926132232
                            },
                            {
                                "lat": 48.2119882107,
                                "lng": 17.9258935153
                            },
                            {
                                "lat": 48.2120545954,
                                "lng": 17.9258184135
                            },
                            {
                                "lat": 48.212177977,
                                "lng": 17.9256896675
                            },
                            {
                                "lat": 48.2123315334,
                                "lng": 17.9255716503
                            },
                            {
                                "lat": 48.2125440985,
                                "lng": 17.9254348576
                            },
                            {
                                "lat": 48.212742582,
                                "lng": 17.9252739251
                            },
                            {
                                "lat": 48.2129001617,
                                "lng": 17.9251371324
                            },
                            {
                                "lat": 48.2130751759,
                                "lng": 17.9249842465
                            },
                            {
                                "lat": 48.2132394612,
                                "lng": 17.9248823225
                            },
                            {
                                "lat": 48.2133273035,
                                "lng": 17.9247911274
                            },
                            {
                                "lat": 48.21348086,
                                "lng": 17.9246811569
                            },
                            {
                                "lat": 48.2135881484,
                                "lng": 17.9245792329
                            },
                            {
                                "lat": 48.2136236876,
                                "lng": 17.9245068133
                            },
                            {
                                "lat": 48.2136062533,
                                "lng": 17.9243700206
                            },
                            {
                                "lat": 48.2134882361,
                                "lng": 17.9240481555
                            },
                            {
                                "lat": 48.2134057581,
                                "lng": 17.9237477481
                            },
                            {
                                "lat": 48.2133574784,
                                "lng": 17.9235626757
                            },
                            {
                                "lat": 48.2133273035,
                                "lng": 17.9234339297
                            },
                            {
                                "lat": 48.2132320851,
                                "lng": 17.9231657088
                            },
                            {
                                "lat": 48.2132200152,
                                "lng": 17.9231013358
                            },
                            {
                                "lat": 48.2131556422,
                                "lng": 17.9230342805
                            },
                            {
                                "lat": 48.2130785286,
                                "lng": 17.9229725897
                            },
                            {
                                "lat": 48.2130248845,
                                "lng": 17.9229055345
                            },
                            {
                                "lat": 48.2129712403,
                                "lng": 17.922822386
                            },
                            {
                                "lat": 48.2129249722,
                                "lng": 17.9226855934
                            },
                            {
                                "lat": 48.2128874213,
                                "lng": 17.9225327075
                            },
                            {
                                "lat": 48.2128424942,
                                "lng": 17.9223449528
                            },
                            {
                                "lat": 48.2127995789,
                                "lng": 17.9222108424
                            },
                            {
                                "lat": 48.2127479464,
                                "lng": 17.9221464694
                            },
                            {
                                "lat": 48.212660104,
                                "lng": 17.9221840203
                            },
                            {
                                "lat": 48.2125280052,
                                "lng": 17.9222886264
                            },
                            {
                                "lat": 48.2123959064,
                                "lng": 17.9223637283
                            },
                            {
                                "lat": 48.2122403383,
                                "lng": 17.922449559
                            },
                            {
                                "lat": 48.2121062279,
                                "lng": 17.922527343
                            },
                            {
                                "lat": 48.2119600475,
                                "lng": 17.922629267
                            },
                            {
                                "lat": 48.211845383,
                                "lng": 17.9226990044
                            },
                            {
                                "lat": 48.2116502523,
                                "lng": 17.9227741063
                            },
                            {
                                "lat": 48.2114055008,
                                "lng": 17.9228813946
                            },
                            {
                                "lat": 48.211228475,
                                "lng": 17.9229538143
                            },
                            {
                                "lat": 48.2110896707,
                                "lng": 17.9229913652
                            },
                            {
                                "lat": 48.2109569013,
                                "lng": 17.9230074584
                            },
                            {
                                "lat": 48.2108978927,
                                "lng": 17.9228438437
                            },
                            {
                                "lat": 48.2108442485,
                                "lng": 17.9226024449
                            },
                            {
                                "lat": 48.2107443362,
                                "lng": 17.922334224
                            },
                            {
                                "lat": 48.21066387,
                                "lng": 17.9220660031
                            },
                            {
                                "lat": 48.2106135786,
                                "lng": 17.921910435
                            },
                            {
                                "lat": 48.2105264068,
                                "lng": 17.9215724766
                            },
                            {
                                "lat": 48.2104546577,
                                "lng": 17.9213820398
                            },
                            {
                                "lat": 48.2103547454,
                                "lng": 17.9210467637
                            },
                            {
                                "lat": 48.21020253,
                                "lng": 17.9206068814
                            },
                            {
                                "lat": 48.2100898772,
                                "lng": 17.9202796519
                            },
                            {
                                "lat": 48.2098578662,
                                "lng": 17.9194803536
                            },
                            {
                                "lat": 48.2098008692,
                                "lng": 17.919292599
                            },
                            {
                                "lat": 48.209657371,
                                "lng": 17.9188339412
                            },
                            {
                                "lat": 48.2095145434,
                                "lng": 17.9184155166
                            },
                            {
                                "lat": 48.2093717158,
                                "lng": 17.9179756343
                            },
                            {
                                "lat": 48.2092288882,
                                "lng": 17.9175893962
                            },
                            {
                                "lat": 48.209021017,
                                "lng": 17.9173506796
                            },
                            {
                                "lat": 48.208835274,
                                "lng": 17.9170851409
                            },
                            {
                                "lat": 48.2083846629,
                                "lng": 17.9165808856
                            },
                            {
                                "lat": 48.2080058008,
                                "lng": 17.9160444438
                            },
                            {
                                "lat": 48.2076483965,
                                "lng": 17.9155831039
                            },
                            {
                                "lat": 48.2071622461,
                                "lng": 17.9149930179
                            },
                            {
                                "lat": 48.2067907602,
                                "lng": 17.9144673049
                            },
                            {
                                "lat": 48.206332773,
                                "lng": 17.9139094055
                            },
                            {
                                "lat": 48.2059465349,
                                "lng": 17.9133836925
                            },
                            {
                                "lat": 48.2055609673,
                                "lng": 17.9128150642
                            },
                            {
                                "lat": 48.2049172372,
                                "lng": 17.9120640457
                            },
                            {
                                "lat": 48.2043593377,
                                "lng": 17.9113022983
                            },
                            {
                                "lat": 48.2036586106,
                                "lng": 17.9104118049
                            },
                            {
                                "lat": 48.2030725479,
                                "lng": 17.909617871
                            },
                            {
                                "lat": 48.2023429871,
                                "lng": 17.908770293
                            },
                            {
                                "lat": 48.2019064575,
                                "lng": 17.9081694782
                            },
                            {
                                "lat": 48.2014417648,
                                "lng": 17.9076008499
                            },
                            {
                                "lat": 48.2010340691,
                                "lng": 17.9070429504
                            },
                            {
                                "lat": 48.2006337494,
                                "lng": 17.9065923393
                            },
                            {
                                "lat": 48.2002837211,
                                "lng": 17.9061631858
                            },
                            {
                                "lat": 48.200083226,
                                "lng": 17.9058735073
                            },
                            {
                                "lat": 48.1997754425,
                                "lng": 17.9055087268
                            },
                            {
                                "lat": 48.1992825866,
                                "lng": 17.9048864543
                            },
                            {
                                "lat": 48.198781684,
                                "lng": 17.9043285549
                            },
                            {
                                "lat": 48.1983022392,
                                "lng": 17.9038135707
                            },
                            {
                                "lat": 48.1980521232,
                                "lng": 17.9035024345
                            },
                            {
                                "lat": 48.1977302581,
                                "lng": 17.9030410945
                            },
                            {
                                "lat": 48.1973011047,
                                "lng": 17.9026012123
                            }
                        ],
                        position: {lat: 0, lng: 0},
                    },
                    {
                        color: '#3dc1d3',
                        id: 18,
                        type: 'road', // road
                        title: 'Trasa k Salašu v Cabaji - poľné cesty',
                        description: '',
                        photo: '',
                        label: '',
                        tags: ['cc1', 'cc2', 'cc3'],
                        path: [
                            {
                                "lat": 48.2619564235,
                                "lng": 18.0059319735
                            },
                            {
                                "lat": 48.2613133639,
                                "lng": 18.0067044497
                            },
                            {
                                "lat": 48.2610136271,
                                "lng": 18.0072838068
                            },
                            {
                                "lat": 48.2605563104,
                                "lng": 18.007927537
                            },
                            {
                                "lat": 48.2602277398,
                                "lng": 18.0085068941
                            },
                            {
                                "lat": 48.2598991692,
                                "lng": 18.0089145899
                            },
                            {
                                "lat": 48.2597134262,
                                "lng": 18.0091935396
                            },
                            {
                                "lat": 48.2594418526,
                                "lng": 18.0096441507
                            },
                            {
                                "lat": 48.2592279464,
                                "lng": 18.0099231005
                            },
                            {
                                "lat": 48.2589422911,
                                "lng": 18.0103093386
                            },
                            {
                                "lat": 48.2586707175,
                                "lng": 18.0107599497
                            },
                            {
                                "lat": 48.2584990561,
                                "lng": 18.0111032724
                            },
                            {
                                "lat": 48.2582851499,
                                "lng": 18.0114465952
                            },
                            {
                                "lat": 48.2580564916,
                                "lng": 18.0118328333
                            },
                            {
                                "lat": 48.2578419149,
                                "lng": 18.0122834444
                            },
                            {
                                "lat": 48.2576990873,
                                "lng": 18.0127125978
                            },
                            {
                                "lat": 48.2573993504,
                                "lng": 18.0129915476
                            },
                            {
                                "lat": 48.2571418583,
                                "lng": 18.0132704973
                            },
                            {
                                "lat": 48.2568562031,
                                "lng": 18.0135923624
                            },
                            {
                                "lat": 48.2566422969,
                                "lng": 18.0138498545
                            },
                            {
                                "lat": 48.2564565539,
                                "lng": 18.0141288042
                            },
                            {
                                "lat": 48.2562848926,
                                "lng": 18.0142790079
                            },
                            {
                                "lat": 48.2560562342,
                                "lng": 18.0145365
                            },
                            {
                                "lat": 48.2558564097,
                                "lng": 18.014729619
                            },
                            {
                                "lat": 48.2557564974,
                                "lng": 18.0149227381
                            },
                            {
                                "lat": 48.2556954771,
                                "lng": 18.0150300264
                            },
                            {
                                "lat": 48.2557169348,
                                "lng": 18.0151695013
                            },
                            {
                                "lat": 48.2558383048,
                                "lng": 18.0155020952
                            },
                            {
                                "lat": 48.255995214,
                                "lng": 18.0159312487
                            },
                            {
                                "lat": 48.2561279833,
                                "lng": 18.0163496733
                            },
                            {
                                "lat": 48.2562097907,
                                "lng": 18.0166715384
                            },
                            {
                                "lat": 48.2563848048,
                                "lng": 18.0172240734
                            },
                            {
                                "lat": 48.256502822,
                                "lng": 18.0175727606
                            },
                            {
                                "lat": 48.2566027343,
                                "lng": 18.0178463459
                            },
                            {
                                "lat": 48.2567811012,
                                "lng": 18.0183345079
                            },
                            {
                                "lat": 48.2569205761,
                                "lng": 18.0188119411
                            },
                            {
                                "lat": 48.2570707798,
                                "lng": 18.0192679167
                            },
                            {
                                "lat": 48.2572706044,
                                "lng": 18.0198204517
                            },
                            {
                                "lat": 48.2573792338,
                                "lng": 18.020195961
                            },
                            {
                                "lat": 48.2575294375,
                                "lng": 18.0205929279
                            },
                            {
                                "lat": 48.2576796412,
                                "lng": 18.0211293697
                            },
                            {
                                "lat": 48.2578580081,
                                "lng": 18.0217087269
                            },
                            {
                                "lat": 48.2581007481,
                                "lng": 18.0224168301
                            },
                            {
                                "lat": 48.2582435757,
                                "lng": 18.0228674412
                            },
                            {
                                "lat": 48.2583864033,
                                "lng": 18.0232858658
                            },
                            {
                                "lat": 48.2585117966,
                                "lng": 18.0235862732
                            },
                            {
                                "lat": 48.2585654408,
                                "lng": 18.0238544941
                            },
                            {
                                "lat": 48.2586727291,
                                "lng": 18.0241656303
                            },
                            {
                                "lat": 48.2587652653,
                                "lng": 18.0244714022
                            },
                            {
                                "lat": 48.2588866353,
                                "lng": 18.0248737335
                            },
                            {
                                "lat": 48.2589798421,
                                "lng": 18.025072217
                            },
                            {
                                "lat": 48.259075731,
                                "lng": 18.0253189802
                            },
                            {
                                "lat": 48.2592078298,
                                "lng": 18.0255174637
                            },
                            {
                                "lat": 48.2593868673,
                                "lng": 18.0257534981
                            },
                            {
                                "lat": 48.259447217,
                                "lng": 18.025919795
                            },
                            {
                                "lat": 48.2594438642,
                                "lng": 18.0261451006
                            },
                            {
                                "lat": 48.2594331354,
                                "lng": 18.026316762
                            },
                            {
                                "lat": 48.2594150305,
                                "lng": 18.0264884233
                            },
                            {
                                "lat": 48.2594116777,
                                "lng": 18.0266493559
                            },
                            {
                                "lat": 48.25939022,
                                "lng": 18.0268424749
                            },
                            {
                                "lat": 48.2593721151,
                                "lng": 18.0271697044
                            },
                            {
                                "lat": 48.2593761384,
                                "lng": 18.0273145437
                            },
                            {
                                "lat": 48.2593439519,
                                "lng": 18.0274540186
                            },
                            {
                                "lat": 48.2593224943,
                                "lng": 18.0276471376
                            },
                            {
                                "lat": 48.2593043894,
                                "lng": 18.0276846886
                            },
                            {
                                "lat": 48.2592507452,
                                "lng": 18.0276578665
                            },
                            {
                                "lat": 48.2592011243,
                                "lng": 18.0276095867
                            },
                            {
                                "lat": 48.2591689378,
                                "lng": 18.0275452137
                            },
                            {
                                "lat": 48.2591333985,
                                "lng": 18.0274647474
                            },
                            {
                                "lat": 48.259101212,
                                "lng": 18.0273467302
                            },
                            {
                                "lat": 48.2590690255,
                                "lng": 18.0272340775
                            },
                            {
                                "lat": 48.259036839,
                                "lng": 18.0271053314
                            },
                            {
                                "lat": 48.2589905709,
                                "lng": 18.027035594
                            },
                            {
                                "lat": 48.2589329034,
                                "lng": 18.0269175768
                            },
                            {
                                "lat": 48.2588725537,
                                "lng": 18.0268585682
                            },
                            {
                                "lat": 48.2587974519,
                                "lng": 18.0268317461
                            },
                            {
                                "lat": 48.2587257028,
                                "lng": 18.026804924
                            },
                            {
                                "lat": 48.2586512715,
                                "lng": 18.0267995596
                            },
                            {
                                "lat": 48.2585761696,
                                "lng": 18.0267995596
                            },
                            {
                                "lat": 48.2585010678,
                                "lng": 18.0267995596
                            },
                            {
                                "lat": 48.2584440708,
                                "lng": 18.026804924
                            },
                            {
                                "lat": 48.258368969,
                                "lng": 18.0268156528
                            },
                            {
                                "lat": 48.2583079487,
                                "lng": 18.0268156528
                            },
                            {
                                "lat": 48.2582616806,
                                "lng": 18.0267941952
                            },
                            {
                                "lat": 48.2581973076,
                                "lng": 18.0267995596
                            },
                            {
                                "lat": 48.258126229,
                                "lng": 18.0267941952
                            },
                            {
                                "lat": 48.258061856,
                                "lng": 18.0268156528
                            },
                            {
                                "lat": 48.2579686493,
                                "lng": 18.0268102884
                            },
                            {
                                "lat": 48.2579150051,
                                "lng": 18.0268317461
                            },
                            {
                                "lat": 48.2578439265,
                                "lng": 18.0268263817
                            },
                            {
                                "lat": 48.257747367,
                                "lng": 18.0268371105
                            },
                            {
                                "lat": 48.2576689124,
                                "lng": 18.0268317461
                            },
                            {
                                "lat": 48.2575864345,
                                "lng": 18.0268263817
                            },
                            {
                                "lat": 48.2575260848,
                                "lng": 18.0268424749
                            },
                            {
                                "lat": 48.2574543357,
                                "lng": 18.0268585682
                            },
                            {
                                "lat": 48.2573832572,
                                "lng": 18.0268585682
                            },
                            {
                                "lat": 48.2573155314,
                                "lng": 18.0268746614
                            },
                            {
                                "lat": 48.2572223246,
                                "lng": 18.0268746614
                            },
                            {
                                "lat": 48.2571579516,
                                "lng": 18.0268639326
                            },
                            {
                                "lat": 48.2570976019,
                                "lng": 18.0268800259
                            },
                            {
                                "lat": 48.2569869608,
                                "lng": 18.026906848
                            },
                            {
                                "lat": 48.2569078356,
                                "lng": 18.026906848
                            },
                            {
                                "lat": 48.256829381,
                                "lng": 18.0269175768
                            },
                            {
                                "lat": 48.2567401975,
                                "lng": 18.0269175768
                            },
                            {
                                "lat": 48.2566939294,
                                "lng": 18.0269229412
                            },
                            {
                                "lat": 48.2566221803,
                                "lng": 18.0269229412
                            },
                            {
                                "lat": 48.2565511018,
                                "lng": 18.0269443989
                            },
                            {
                                "lat": 48.2564652711,
                                "lng": 18.0269497633
                            },
                            {
                                "lat": 48.2563901693,
                                "lng": 18.0269443989
                            },
                            {
                                "lat": 48.2563083619,
                                "lng": 18.0269229412
                            },
                            {
                                "lat": 48.2561936975,
                                "lng": 18.0269443989
                            },
                            {
                                "lat": 48.2561011612,
                                "lng": 18.026971221
                            },
                            {
                                "lat": 48.2560113072,
                                "lng": 18.0269765854
                            },
                            {
                                "lat": 48.2558973134,
                                "lng": 18.0269551277
                            },
                            {
                                "lat": 48.2557618618,
                                "lng": 18.0269873142
                            },
                            {
                                "lat": 48.2556438446,
                                "lng": 18.0270034075
                            },
                            {
                                "lat": 48.2555365562,
                                "lng": 18.0269980431
                            },
                            {
                                "lat": 48.2554399967,
                                "lng": 18.0269765854
                            },
                            {
                                "lat": 48.2553327084,
                                "lng": 18.0269873142
                            },
                            {
                                "lat": 48.2552113384,
                                "lng": 18.0269604921
                            },
                            {
                                "lat": 48.2551047206,
                                "lng": 18.0269551277
                            },
                            {
                                "lat": 48.2549867034,
                                "lng": 18.0269390345
                            },
                            {
                                "lat": 48.2548975199,
                                "lng": 18.0269229412
                            },
                            {
                                "lat": 48.2547795027,
                                "lng": 18.0269443989
                            },
                            {
                                "lat": 48.2547077537,
                                "lng": 18.0269551277
                            },
                            {
                                "lat": 48.2546152174,
                                "lng": 18.0269980431
                            },
                            {
                                "lat": 48.2545434684,
                                "lng": 18.0270570517
                            },
                            {
                                "lat": 48.2544435561,
                                "lng": 18.0271267891
                            },
                            {
                                "lat": 48.2543617487,
                                "lng": 18.0272126198
                            },
                            {
                                "lat": 48.2542685419,
                                "lng": 18.0273360014
                            },
                            {
                                "lat": 48.2541612536,
                                "lng": 18.0274432898
                            },
                            {
                                "lat": 48.2541183382,
                                "lng": 18.0276095867
                            },
                            {
                                "lat": 48.2540291548,
                                "lng": 18.0277436972
                            },
                            {
                                "lat": 48.2539540529,
                                "lng": 18.0278617144
                            },
                            {
                                "lat": 48.2538755983,
                                "lng": 18.0280119181
                            },
                            {
                                "lat": 48.2538004965,
                                "lng": 18.0280977488
                            },
                            {
                                "lat": 48.2537186891,
                                "lng": 18.028178215
                            },
                            {
                                "lat": 48.2536006719,
                                "lng": 18.0282211304
                            },
                            {
                                "lat": 48.253486678,
                                "lng": 18.0282264948
                            },
                            {
                                "lat": 48.2534115762,
                                "lng": 18.0282747746
                            },
                            {
                                "lat": 48.2533290982,
                                "lng": 18.0283123255
                            },
                            {
                                "lat": 48.2531896234,
                                "lng": 18.0283659697
                            },
                            {
                                "lat": 48.2531004399,
                                "lng": 18.0284142494
                            },
                            {
                                "lat": 48.2529931515,
                                "lng": 18.0284625292
                            },
                            {
                                "lat": 48.2529146969,
                                "lng": 18.0286073685
                            },
                            {
                                "lat": 48.2528181374,
                                "lng": 18.0287843943
                            },
                            {
                                "lat": 48.2527866215,
                                "lng": 18.0289131403
                            },
                            {
                                "lat": 48.252728954,
                                "lng": 18.0291008949
                            },
                            {
                                "lat": 48.2526793331,
                                "lng": 18.0293691158
                            },
                            {
                                "lat": 48.2526290417,
                                "lng": 18.0295568705
                            },
                            {
                                "lat": 48.2525861263,
                                "lng": 18.0297285318
                            },
                            {
                                "lat": 48.2525398582,
                                "lng": 18.0298411846
                            },
                            {
                                "lat": 48.252478838,
                                "lng": 18.0299001932
                            },
                            {
                                "lat": 48.2524573803,
                                "lng": 18.0299538374
                            },
                            {
                                "lat": 48.2524365932,
                                "lng": 18.0300182104
                            },
                            {
                                "lat": 48.2526149601,
                                "lng": 18.0301630497
                            },
                            {
                                "lat": 48.2527758926,
                                "lng": 18.0303025246
                            },
                            {
                                "lat": 48.2529576123,
                                "lng": 18.0304473639
                            },
                            {
                                "lat": 48.2530830055,
                                "lng": 18.0305922031
                            },
                            {
                                "lat": 48.2532627136,
                                "lng": 18.0307558179
                            },
                            {
                                "lat": 48.2534933835,
                                "lng": 18.0308818817
                            },
                            {
                                "lat": 48.2536865026,
                                "lng": 18.031026721
                            },
                            {
                                "lat": 48.2539151609,
                                "lng": 18.0311501026
                            },
                            {
                                "lat": 48.2540935278,
                                "lng": 18.0313646793
                            },
                            {
                                "lat": 48.2543007284,
                                "lng": 18.0314934254
                            },
                            {
                                "lat": 48.2544294745,
                                "lng": 18.0316382647
                            },
                            {
                                "lat": 48.2543436438,
                                "lng": 18.03168118
                            }
                        ],
                        position: {lat: 0, lng: 0},
                    },
                    {
                        color: '#f78fb3',
                        id: 19,
                        type: 'road', // road
                        title: 'Trasa k salašu v Cabaji - cez obec\n',
                        description: '',
                        photo: '',
                        label: '',
                        tags: ['cc1', 'cc2', 'cc3'],
                        path: [
                            {
                                "lat": 48.2619550824,
                                "lng": 18.0058394372
                            },
                            {
                                "lat": 48.261910826,
                                "lng": 18.0059199035
                            },
                            {
                                "lat": 48.261873275,
                                "lng": 18.0059789121
                            },
                            {
                                "lat": 48.2618229836,
                                "lng": 18.0060406029
                            },
                            {
                                "lat": 48.2617961615,
                                "lng": 18.0060996115
                            },
                            {
                                "lat": 48.2617498934,
                                "lng": 18.0061505735
                            },
                            {
                                "lat": 48.2617143542,
                                "lng": 18.0062042177
                            },
                            {
                                "lat": 48.2616714388,
                                "lng": 18.0062605441
                            },
                            {
                                "lat": 48.2616392523,
                                "lng": 18.0063249171
                            },
                            {
                                "lat": 48.2615909725,
                                "lng": 18.0063946545
                            },
                            {
                                "lat": 48.2615406811,
                                "lng": 18.0064724386
                            },
                            {
                                "lat": 48.2614997774,
                                "lng": 18.0065153539
                            },
                            {
                                "lat": 48.2614783198,
                                "lng": 18.0065716803
                            },
                            {
                                "lat": 48.2614374161,
                                "lng": 18.0066280067
                            },
                            {
                                "lat": 48.2614018768,
                                "lng": 18.0066923797
                            },
                            {
                                "lat": 48.2613696903,
                                "lng": 18.0067326128
                            },
                            {
                                "lat": 48.2613227516,
                                "lng": 18.0068050325
                            },
                            {
                                "lat": 48.2612858713,
                                "lng": 18.0068694055
                            },
                            {
                                "lat": 48.2612375915,
                                "lng": 18.0069310963
                            },
                            {
                                "lat": 48.2611745596,
                                "lng": 18.0070222914
                            },
                            {
                                "lat": 48.2611303031,
                                "lng": 18.0070813
                            },
                            {
                                "lat": 48.2610800117,
                                "lng": 18.0071510375
                            },
                            {
                                "lat": 48.2610370964,
                                "lng": 18.0072288215
                            },
                            {
                                "lat": 48.2610102743,
                                "lng": 18.0072744191
                            },
                            {
                                "lat": 48.2609733939,
                                "lng": 18.0073387921
                            },
                            {
                                "lat": 48.2609465718,
                                "lng": 18.0073736608
                            },
                            {
                                "lat": 48.2609070092,
                                "lng": 18.0074460804
                            },
                            {
                                "lat": 48.2608620822,
                                "lng": 18.0075024068
                            },
                            {
                                "lat": 48.2608245313,
                                "lng": 18.0075587332
                            },
                            {
                                "lat": 48.2607910037,
                                "lng": 18.0076231062
                            },
                            {
                                "lat": 48.2607501,
                                "lng": 18.0076794326
                            },
                            {
                                "lat": 48.2606964558,
                                "lng": 18.0077625811
                            },
                            {
                                "lat": 48.2606394589,
                                "lng": 18.0078215897
                            },
                            {
                                "lat": 48.2605858147,
                                "lng": 18.0078993738
                            },
                            {
                                "lat": 48.2605335116,
                                "lng": 18.0079744756
                            },
                            {
                                "lat": 48.2604946196,
                                "lng": 18.0080388486
                            },
                            {
                                "lat": 48.2604537159,
                                "lng": 18.0080871284
                            },
                            {
                                "lat": 48.2604054362,
                                "lng": 18.008159548
                            },
                            {
                                "lat": 48.2603531331,
                                "lng": 18.0082480609
                            },
                            {
                                "lat": 48.2603175938,
                                "lng": 18.0083177984
                            },
                            {
                                "lat": 48.2602605969,
                                "lng": 18.0084009469
                            },
                            {
                                "lat": 48.2602035999,
                                "lng": 18.0084814131
                            },
                            {
                                "lat": 48.2601694018,
                                "lng": 18.0085270107
                            },
                            {
                                "lat": 48.2601251453,
                                "lng": 18.0086074769
                            },
                            {
                                "lat": 48.2600909472,
                                "lng": 18.0086530745
                            },
                            {
                                "lat": 48.2600460202,
                                "lng": 18.008736223
                            },
                            {
                                "lat": 48.2600017637,
                                "lng": 18.0088032782
                            },
                            {
                                "lat": 48.2599534839,
                                "lng": 18.0088756979
                            },
                            {
                                "lat": 48.2599085569,
                                "lng": 18.0089615285
                            },
                            {
                                "lat": 48.2598535717,
                                "lng": 18.009044677
                            },
                            {
                                "lat": 48.2598032802,
                                "lng": 18.0091224611
                            },
                            {
                                "lat": 48.2597550005,
                                "lng": 18.0091895163
                            },
                            {
                                "lat": 48.259710744,
                                "lng": 18.0092565715
                            },
                            {
                                "lat": 48.2596752048,
                                "lng": 18.0093236268
                            },
                            {
                                "lat": 48.2596215606,
                                "lng": 18.0093826354
                            },
                            {
                                "lat": 48.2595746219,
                                "lng": 18.0094577372
                            },
                            {
                                "lat": 48.2595209777,
                                "lng": 18.0095274746
                            },
                            {
                                "lat": 48.2594840974,
                                "lng": 18.0095972121
                            },
                            {
                                "lat": 48.2594371587,
                                "lng": 18.0096535385
                            },
                            {
                                "lat": 48.2593888789,
                                "lng": 18.0097286403
                            },
                            {
                                "lat": 48.2593352348,
                                "lng": 18.0098117888
                            },
                            {
                                "lat": 48.2592715323,
                                "lng": 18.0098842084
                            },
                            {
                                "lat": 48.2592178881,
                                "lng": 18.0099834502
                            },
                            {
                                "lat": 48.2591501623,
                                "lng": 18.0100773275
                            },
                            {
                                "lat": 48.2590784132,
                                "lng": 18.0101872981
                            },
                            {
                                "lat": 48.2589925826,
                                "lng": 18.0102919042
                            },
                            {
                                "lat": 48.2589429617,
                                "lng": 18.0103670061
                            },
                            {
                                "lat": 48.2588732243,
                                "lng": 18.0104769766
                            },
                            {
                                "lat": 48.258812204,
                                "lng": 18.0105547607
                            },
                            {
                                "lat": 48.2587444782,
                                "lng": 18.0106647313
                            },
                            {
                                "lat": 48.258671388,
                                "lng": 18.0107532442
                            },
                            {
                                "lat": 48.2586050034,
                                "lng": 18.0108551681
                            },
                            {
                                "lat": 48.2585339248,
                                "lng": 18.010957092
                            },
                            {
                                "lat": 48.2584554702,
                                "lng": 18.0110804737
                            },
                            {
                                "lat": 48.2583837211,
                                "lng": 18.0111716688
                            },
                            {
                                "lat": 48.2583428174,
                                "lng": 18.0112279952
                            },
                            {
                                "lat": 48.2583126426,
                                "lng": 18.011289686
                            },
                            {
                                "lat": 48.2582603395,
                                "lng": 18.0114237964
                            },
                            {
                                "lat": 48.2582174242,
                                "lng": 18.0115284026
                            },
                            {
                                "lat": 48.258171156,
                                "lng": 18.0116276443
                            },
                            {
                                "lat": 48.2581054419,
                                "lng": 18.0117483437
                            },
                            {
                                "lat": 48.2580377162,
                                "lng": 18.0119253695
                            },
                            {
                                "lat": 48.2579699904,
                                "lng": 18.0120487511
                            },
                            {
                                "lat": 48.2579123229,
                                "lng": 18.0121828616
                            },
                            {
                                "lat": 48.257874772,
                                "lng": 18.0123129487
                            },
                            {
                                "lat": 48.2578144222,
                                "lng": 18.0124081671
                            },
                            {
                                "lat": 48.2577721775,
                                "lng": 18.0124886334
                            },
                            {
                                "lat": 48.2577205449,
                                "lng": 18.0125530064
                            },
                            {
                                "lat": 48.2576970756,
                                "lng": 18.0126026273
                            },
                            {
                                "lat": 48.2576521486,
                                "lng": 18.0126844347
                            },
                            {
                                "lat": 48.2575938106,
                                "lng": 18.0127568543
                            },
                            {
                                "lat": 48.2575301081,
                                "lng": 18.012868166
                            },
                            {
                                "lat": 48.2574637234,
                                "lng": 18.0129285157
                            },
                            {
                                "lat": 48.2573872805,
                                "lng": 18.0129861832
                            },
                            {
                                "lat": 48.2573457062,
                                "lng": 18.0130626261
                            },
                            {
                                "lat": 48.2572940737,
                                "lng": 18.0131484568
                            },
                            {
                                "lat": 48.2572243363,
                                "lng": 18.0132302642
                            },
                            {
                                "lat": 48.2571445405,
                                "lng": 18.0133093894
                            },
                            {
                                "lat": 48.2570466399,
                                "lng": 18.0134113133
                            },
                            {
                                "lat": 48.2569822669,
                                "lng": 18.0134998262
                            },
                            {
                                "lat": 48.2568602264,
                                "lng": 18.0136285722
                            },
                            {
                                "lat": 48.2567857951,
                                "lng": 18.0137304962
                            },
                            {
                                "lat": 48.2567173988,
                                "lng": 18.0138002336
                            },
                            {
                                "lat": 48.2566355914,
                                "lng": 18.0139236152
                            },
                            {
                                "lat": 48.2565316558,
                                "lng": 18.0140148103
                            },
                            {
                                "lat": 48.2564424723,
                                "lng": 18.0141167343
                            },
                            {
                                "lat": 48.2563747466,
                                "lng": 18.0141811073
                            },
                            {
                                "lat": 48.256303668,
                                "lng": 18.014266938
                            },
                            {
                                "lat": 48.2562500238,
                                "lng": 18.0143366754
                            },
                            {
                                "lat": 48.2561608404,
                                "lng": 18.0144385993
                            },
                            {
                                "lat": 48.2560890913,
                                "lng": 18.0145351589
                            },
                            {
                                "lat": 48.2560354471,
                                "lng": 18.0146209896
                            },
                            {
                                "lat": 48.2559569925,
                                "lng": 18.0147014558
                            },
                            {
                                "lat": 48.2558959723,
                                "lng": 18.0147819221
                            },
                            {
                                "lat": 48.2558315992,
                                "lng": 18.0148516595
                            },
                            {
                                "lat": 48.2557746023,
                                "lng": 18.0149482191
                            },
                            {
                                "lat": 48.2556887716,
                                "lng": 18.0150340497
                            },
                            {
                                "lat": 48.2556565851,
                                "lng": 18.0151413381
                            },
                            {
                                "lat": 48.2555928826,
                                "lng": 18.0152218044
                            },
                            {
                                "lat": 48.2554748654,
                                "lng": 18.0153237283
                            },
                            {
                                "lat": 48.2553353906,
                                "lng": 18.0153934658
                            },
                            {
                                "lat": 48.2552602887,
                                "lng": 18.0154846609
                            },
                            {
                                "lat": 48.2551892102,
                                "lng": 18.0155865848
                            },
                            {
                                "lat": 48.2551067322,
                                "lng": 18.0156777799
                            },
                            {
                                "lat": 48.2550249249,
                                "lng": 18.0157636106
                            },
                            {
                                "lat": 48.2549390942,
                                "lng": 18.0158655345
                            },
                            {
                                "lat": 48.2548606396,
                                "lng": 18.0159460008
                            },
                            {
                                "lat": 48.2547781616,
                                "lng": 18.0160050094
                            },
                            {
                                "lat": 48.2547030598,
                                "lng": 18.0160747468
                            },
                            {
                                "lat": 48.2545997947,
                                "lng": 18.0161605775
                            },
                            {
                                "lat": 48.254506588,
                                "lng": 18.0162195861
                            },
                            {
                                "lat": 48.2544174045,
                                "lng": 18.0162893236
                            },
                            {
                                "lat": 48.2543141395,
                                "lng": 18.0163429677
                            },
                            {
                                "lat": 48.2542102039,
                                "lng": 18.0163805187
                            },
                            {
                                "lat": 48.2540673763,
                                "lng": 18.0164287984
                            },
                            {
                                "lat": 48.2539708167,
                                "lng": 18.0164502561
                            },
                            {
                                "lat": 48.2539138198,
                                "lng": 18.0165039003
                            },
                            {
                                "lat": 48.2537709922,
                                "lng": 18.0165521801
                            },
                            {
                                "lat": 48.2536462694,
                                "lng": 18.0166058242
                            },
                            {
                                "lat": 48.253531605,
                                "lng": 18.0166219175
                            },
                            {
                                "lat": 48.2534135878,
                                "lng": 18.0166862905
                            },
                            {
                                "lat": 48.253281489,
                                "lng": 18.0167345703
                            },
                            {
                                "lat": 48.253178224,
                                "lng": 18.0167506635
                            },
                            {
                                "lat": 48.2530675828,
                                "lng": 18.0167667568
                            },
                            {
                                "lat": 48.2529676706,
                                "lng": 18.0167667568
                            },
                            {
                                "lat": 48.2528315485,
                                "lng": 18.0168311298
                            },
                            {
                                "lat": 48.2526672632,
                                "lng": 18.0168418586
                            },
                            {
                                "lat": 48.252556622,
                                "lng": 18.0168740451
                            },
                            {
                                "lat": 48.2524064183,
                                "lng": 18.0169062316
                            },
                            {
                                "lat": 48.2522709668,
                                "lng": 18.0169276893
                            },
                            {
                                "lat": 48.2521529496,
                                "lng": 18.0169008672
                            },
                            {
                                "lat": 48.2520423084,
                                "lng": 18.0169384181
                            },
                            {
                                "lat": 48.2519383729,
                                "lng": 18.0169545114
                            },
                            {
                                "lat": 48.2518277317,
                                "lng": 18.0169813335
                            },
                            {
                                "lat": 48.2517278194,
                                "lng": 18.0169974267
                            },
                            {
                                "lat": 48.2516312599,
                                "lng": 18.0170188844
                            },
                            {
                                "lat": 48.2515206188,
                                "lng": 18.0170296133
                            },
                            {
                                "lat": 48.25138852,
                                "lng": 18.0170886219
                            },
                            {
                                "lat": 48.2512423396,
                                "lng": 18.017142266
                            },
                            {
                                "lat": 48.2511316985,
                                "lng": 18.0172012746
                            },
                            {
                                "lat": 48.2509989291,
                                "lng": 18.0172388256
                            },
                            {
                                "lat": 48.2508527488,
                                "lng": 18.0172710121
                            },
                            {
                                "lat": 48.2507602125,
                                "lng": 18.0173514783
                            },
                            {
                                "lat": 48.2506489009,
                                "lng": 18.0173997581
                            },
                            {
                                "lat": 48.2505563647,
                                "lng": 18.0174319446
                            },
                            {
                                "lat": 48.2504168898,
                                "lng": 18.017501682
                            },
                            {
                                "lat": 48.2502881438,
                                "lng": 18.0175231397
                            },
                            {
                                "lat": 48.2501526922,
                                "lng": 18.0175714195
                            },
                            {
                                "lat": 48.2499991357,
                                "lng": 18.0175714195
                            },
                            {
                                "lat": 48.2499025762,
                                "lng": 18.0175928771
                            },
                            {
                                "lat": 48.249784559,
                                "lng": 18.0176089704
                            },
                            {
                                "lat": 48.2496417314,
                                "lng": 18.017667979
                            },
                            {
                                "lat": 48.2494881749,
                                "lng": 18.0177001655
                            },
                            {
                                "lat": 48.2493808866,
                                "lng": 18.0177913606
                            },
                            {
                                "lat": 48.2492702454,
                                "lng": 18.0178771913
                            },
                            {
                                "lat": 48.2491629571,
                                "lng": 18.0179415643
                            },
                            {
                                "lat": 48.2490275055,
                                "lng": 18.0179898441
                            },
                            {
                                "lat": 48.2488987595,
                                "lng": 18.0181078613
                            },
                            {
                                "lat": 48.2487700135,
                                "lng": 18.0182527006
                            },
                            {
                                "lat": 48.2486701012,
                                "lng": 18.0183921754
                            },
                            {
                                "lat": 48.2485413551,
                                "lng": 18.0185262859
                            },
                            {
                                "lat": 48.2484736294,
                                "lng": 18.018617481
                            },
                            {
                                "lat": 48.248366341,
                                "lng": 18.0187891424
                            },
                            {
                                "lat": 48.2482094318,
                                "lng": 18.0189393461
                            },
                            {
                                "lat": 48.2480592281,
                                "lng": 18.0191324651
                            },
                            {
                                "lat": 48.2478949428,
                                "lng": 18.0193577707
                            },
                            {
                                "lat": 48.2477340102,
                                "lng": 18.0195401609
                            },
                            {
                                "lat": 48.2475449145,
                                "lng": 18.0197869241
                            },
                            {
                                "lat": 48.2474235445,
                                "lng": 18.0199103057
                            },
                            {
                                "lat": 48.2473055273,
                                "lng": 18.0200336874
                            },
                            {
                                "lat": 48.2471553236,
                                "lng": 18.0202053487
                            },
                            {
                                "lat": 48.2469984144,
                                "lng": 18.0203877389
                            },
                            {
                                "lat": 48.2468415052,
                                "lng": 18.020452112
                            },
                            {
                                "lat": 48.2466624677,
                                "lng": 18.0205218494
                            },
                            {
                                "lat": 48.2464901358,
                                "lng": 18.0205956101
                            },
                            {
                                "lat": 48.2464056462,
                                "lng": 18.0206237733
                            },
                            {
                                "lat": 48.2462661713,
                                "lng": 18.0206935108
                            },
                            {
                                "lat": 48.2461233437,
                                "lng": 18.020747155
                            },
                            {
                                "lat": 48.24597314,
                                "lng": 18.0207847059
                            },
                            {
                                "lat": 48.245844394,
                                "lng": 18.0208007991
                            },
                            {
                                "lat": 48.2457625866,
                                "lng": 18.0208651721
                            },
                            {
                                "lat": 48.2456982136,
                                "lng": 18.0208973587
                            },
                            {
                                "lat": 48.2458484173,
                                "lng": 18.0211012065
                            },
                            {
                                "lat": 48.2461374253,
                                "lng": 18.02153036
                            },
                            {
                                "lat": 48.2464552671,
                                "lng": 18.0219970644
                            },
                            {
                                "lat": 48.2467503101,
                                "lng": 18.0225335062
                            },
                            {
                                "lat": 48.2470091432,
                                "lng": 18.0229572952
                            },
                            {
                                "lat": 48.2472411543,
                                "lng": 18.0233435333
                            },
                            {
                                "lat": 48.2474805415,
                                "lng": 18.0237083137
                            },
                            {
                                "lat": 48.2477661967,
                                "lng": 18.0240999162
                            },
                            {
                                "lat": 48.24801296,
                                "lng": 18.0244593322
                            },
                            {
                                "lat": 48.2482771575,
                                "lng": 18.0248241127
                            },
                            {
                                "lat": 48.2486057281,
                                "lng": 18.0252854526
                            },
                            {
                                "lat": 48.2488558441,
                                "lng": 18.0255912244
                            },
                            {
                                "lat": 48.2490456104,
                                "lng": 18.0259130895
                            },
                            {
                                "lat": 48.2493634522,
                                "lng": 18.0263261497
                            },
                            {
                                "lat": 48.2495632768,
                                "lng": 18.0266158283
                            },
                            {
                                "lat": 48.2498314977,
                                "lng": 18.0269698799
                            },
                            {
                                "lat": 48.2501345873,
                                "lng": 18.0273078382
                            },
                            {
                                "lat": 48.2504530996,
                                "lng": 18.0277906358
                            },
                            {
                                "lat": 48.2508668303,
                                "lng": 18.0282197893
                            },
                            {
                                "lat": 48.2512208819,
                                "lng": 18.0286060274
                            },
                            {
                                "lat": 48.2515065372,
                                "lng": 18.0289332569
                            },
                            {
                                "lat": 48.2518639416,
                                "lng": 18.0292980373
                            },
                            {
                                "lat": 48.2521670312,
                                "lng": 18.02964136
                            },
                            {
                                "lat": 48.2525063306,
                                "lng": 18.0300007761
                            },
                            {
                                "lat": 48.2528389245,
                                "lng": 18.030295819
                            },
                            {
                                "lat": 48.2531386614,
                                "lng": 18.0305425823
                            },
                            {
                                "lat": 48.2534819841,
                                "lng": 18.0308161676
                            },
                            {
                                "lat": 48.2539319247,
                                "lng": 18.0311541259
                            },
                            {
                                "lat": 48.2542356849,
                                "lng": 18.031347245
                            },
                            {
                                "lat": 48.254449591,
                                "lng": 18.0315135419
                            },
                            {
                                "lat": 48.2543711364,
                                "lng": 18.0316905677
                            }
                        ],
                        position: {lat: 0, lng: 0},
                    },
                    {
                        color: '#f78fb3',
                        id: 20,
                        type: 'road', // road
                        title: 'Močenok - jestvujúca cyklocesta Duslo - Šaľa',
                        description: '',
                        photo: '',
                        label: '',
                        tags: ['cc1', 'cc2', 'cc3'],
                        path: [
                            {
                                "lat": 48.2319438457,
                                "lng": 17.9321095347
                            },
                            {
                                "lat": 48.2318010181,
                                "lng": 17.9322972894
                            },
                            {
                                "lat": 48.2317399979,
                                "lng": 17.9322865605
                            },
                            {
                                "lat": 48.2316434383,
                                "lng": 17.9321470857
                            },
                            {
                                "lat": 48.2315254211,
                                "lng": 17.9319861531
                            },
                            {
                                "lat": 48.2313866168,
                                "lng": 17.9318144917
                            },
                            {
                                "lat": 48.231247142,
                                "lng": 17.9316267371
                            },
                            {
                                "lat": 48.2311217487,
                                "lng": 17.9315301776
                            },
                            {
                                "lat": 48.2310432941,
                                "lng": 17.9314979911
                            },
                            {
                                "lat": 48.2309467345,
                                "lng": 17.9314979911
                            },
                            {
                                "lat": 48.2309004664,
                                "lng": 17.9315194488
                            },
                            {
                                "lat": 48.230850175,
                                "lng": 17.9313638806
                            },
                            {
                                "lat": 48.2307576388,
                                "lng": 17.9311975837
                            },
                            {
                                "lat": 48.230682537,
                                "lng": 17.9310366511
                            },
                            {
                                "lat": 48.2306074351,
                                "lng": 17.9308328032
                            },
                            {
                                "lat": 48.2305001467,
                                "lng": 17.9305323958
                            },
                            {
                                "lat": 48.2304357737,
                                "lng": 17.9303821921
                            },
                            {
                                "lat": 48.2303787768,
                                "lng": 17.9301568866
                            },
                            {
                                "lat": 48.2303036749,
                                "lng": 17.9299101233
                            },
                            {
                                "lat": 48.2302533835,
                                "lng": 17.929674089
                            },
                            {
                                "lat": 48.230221197,
                                "lng": 17.9293361306
                            },
                            {
                                "lat": 48.230156824,
                                "lng": 17.9290947318
                            },
                            {
                                "lat": 48.2300998271,
                                "lng": 17.9288426042
                            },
                            {
                                "lat": 48.2300388068,
                                "lng": 17.9286548495
                            },
                            {
                                "lat": 48.2299677283,
                                "lng": 17.9284402728
                            },
                            {
                                "lat": 48.2298959792,
                                "lng": 17.9282417893
                            },
                            {
                                "lat": 48.2298711687,
                                "lng": 17.9280754924
                            },
                            {
                                "lat": 48.2297960669,
                                "lng": 17.9278877378
                            },
                            {
                                "lat": 48.2297424227,
                                "lng": 17.9277428985
                            },
                            {
                                "lat": 48.2296673208,
                                "lng": 17.9277858138
                            },
                            {
                                "lat": 48.2296103239,
                                "lng": 17.9278501868
                            },
                            {
                                "lat": 48.2295244932,
                                "lng": 17.9279199243
                            },
                            {
                                "lat": 48.2294782251,
                                "lng": 17.9279574752
                            },
                            {
                                "lat": 48.2294534147,
                                "lng": 17.9278662801
                            },
                            {
                                "lat": 48.229406476,
                                "lng": 17.9276624322
                            },
                            {
                                "lat": 48.2293568552,
                                "lng": 17.9274961352
                            },
                            {
                                "lat": 48.2292924821,
                                "lng": 17.9273673892
                            },
                            {
                                "lat": 48.2292173803,
                                "lng": 17.9271474481
                            },
                            {
                                "lat": 48.2291530073,
                                "lng": 17.9270240664
                            },
                            {
                                "lat": 48.229117468,
                                "lng": 17.9268845916
                            },
                            {
                                "lat": 48.2290457189,
                                "lng": 17.9267182946
                            },
                            {
                                "lat": 48.2289350778,
                                "lng": 17.9265895486
                            },
                            {
                                "lat": 48.2288599759,
                                "lng": 17.9264608026
                            },
                            {
                                "lat": 48.2287815213,
                                "lng": 17.9263427854
                            },
                            {
                                "lat": 48.2286883146,
                                "lng": 17.9262408614
                            },
                            {
                                "lat": 48.228611201,
                                "lng": 17.9261764884
                            },
                            {
                                "lat": 48.2285615802,
                                "lng": 17.9261228442
                            },
                            {
                                "lat": 48.2284844667,
                                "lng": 17.9260316491
                            },
                            {
                                "lat": 48.2284147292,
                                "lng": 17.9259136319
                            },
                            {
                                "lat": 48.228359744,
                                "lng": 17.9260101914
                            },
                            {
                                "lat": 48.2283094525,
                                "lng": 17.9260906577
                            },
                            {
                                "lat": 48.2282222807,
                                "lng": 17.926184535
                            },
                            {
                                "lat": 48.2281216979,
                                "lng": 17.9262408614
                            },
                            {
                                "lat": 48.2280217856,
                                "lng": 17.9262837768
                            },
                            {
                                "lat": 48.2279272377,
                                "lng": 17.9263266921
                            },
                            {
                                "lat": 48.2278521359,
                                "lng": 17.9263374209
                            },
                            {
                                "lat": 48.2277790457,
                                "lng": 17.9263535142
                            },
                            {
                                "lat": 48.2276804745,
                                "lng": 17.9263669252
                            },
                            {
                                "lat": 48.2275966555,
                                "lng": 17.9263910651
                            },
                            {
                                "lat": 48.2275021076,
                                "lng": 17.9264205694
                            },
                            {
                                "lat": 48.2274390757,
                                "lng": 17.9264447093
                            },
                            {
                                "lat": 48.2273679972,
                                "lng": 17.9265037179
                            },
                            {
                                "lat": 48.2273163646,
                                "lng": 17.9265278578
                            },
                            {
                                "lat": 48.2272479683,
                                "lng": 17.9265895486
                            },
                            {
                                "lat": 48.2271500677,
                                "lng": 17.9266512394
                            },
                            {
                                "lat": 48.2270481437,
                                "lng": 17.9267209768
                            },
                            {
                                "lat": 48.2269857824,
                                "lng": 17.9267370701
                            },
                            {
                                "lat": 48.2268972695,
                                "lng": 17.9267880321
                            },
                            {
                                "lat": 48.2267940044,
                                "lng": 17.9268041253
                            },
                            {
                                "lat": 48.2266994566,
                                "lng": 17.9268229008
                            },
                            {
                                "lat": 48.2266189903,
                                "lng": 17.9268497229
                            },
                            {
                                "lat": 48.2265277952,
                                "lng": 17.926876545
                            },
                            {
                                "lat": 48.2263869792,
                                "lng": 17.926876545
                            },
                            {
                                "lat": 48.226268962,
                                "lng": 17.9268872738
                            },
                            {
                                "lat": 48.2261496037,
                                "lng": 17.9269006848
                            },
                            {
                                "lat": 48.2260959595,
                                "lng": 17.9269006848
                            },
                            {
                                "lat": 48.22601147,
                                "lng": 17.9268872738
                            },
                            {
                                "lat": 48.2259061933,
                                "lng": 17.9268524051
                            },
                            {
                                "lat": 48.2258277386,
                                "lng": 17.9268363118
                            },
                            {
                                "lat": 48.2257365435,
                                "lng": 17.9267907143
                            },
                            {
                                "lat": 48.2256433368,
                                "lng": 17.9267773032
                            },
                            {
                                "lat": 48.2255400717,
                                "lng": 17.92676121
                            },
                            {
                                "lat": 48.2254301012,
                                "lng": 17.9267263412
                            },
                            {
                                "lat": 48.2253275067,
                                "lng": 17.9266861081
                            },
                            {
                                "lat": 48.2252182066,
                                "lng": 17.9266512394
                            },
                            {
                                "lat": 48.225094825,
                                "lng": 17.9266110063
                            },
                            {
                                "lat": 48.2249714434,
                                "lng": 17.9265734553
                            },
                            {
                                "lat": 48.2248681784,
                                "lng": 17.926543951
                            },
                            {
                                "lat": 48.2247736305,
                                "lng": 17.9265171289
                            },
                            {
                                "lat": 48.2246911526,
                                "lng": 17.9264956713
                            },
                            {
                                "lat": 48.2246234268,
                                "lng": 17.9264688492
                            },
                            {
                                "lat": 48.2245288789,
                                "lng": 17.9264420271
                            },
                            {
                                "lat": 48.2244517654,
                                "lng": 17.926401794
                            },
                            {
                                "lat": 48.2243122905,
                                "lng": 17.9263803363
                            },
                            {
                                "lat": 48.2241989672,
                                "lng": 17.9263427854
                            },
                            {
                                "lat": 48.2241426408,
                                "lng": 17.9263052344
                            },
                            {
                                "lat": 48.2240802795,
                                "lng": 17.9262945056
                            },
                            {
                                "lat": 48.2240212709,
                                "lng": 17.9262623191
                            },
                            {
                                "lat": 48.2239837199,
                                "lng": 17.9262301326
                            },
                            {
                                "lat": 48.2239515334,
                                "lng": 17.926171124
                            },
                            {
                                "lat": 48.2239300758,
                                "lng": 17.9260879755
                            },
                            {
                                "lat": 48.2239280641,
                                "lng": 17.9260504246
                            },
                            {
                                "lat": 48.2238657027,
                                "lng": 17.9260852933
                            },
                            {
                                "lat": 48.2237711549,
                                "lng": 17.9261416197
                            },
                            {
                                "lat": 48.2236638665,
                                "lng": 17.926171124
                            },
                            {
                                "lat": 48.2235726714,
                                "lng": 17.9262247682
                            },
                            {
                                "lat": 48.2234741002,
                                "lng": 17.926286459
                            },
                            {
                                "lat": 48.2233775407,
                                "lng": 17.9263132811
                            },
                            {
                                "lat": 48.2233044505,
                                "lng": 17.9263588786
                            },
                            {
                                "lat": 48.2232152671,
                                "lng": 17.926401794
                            },
                            {
                                "lat": 48.2231187075,
                                "lng": 17.9264473915
                            },
                            {
                                "lat": 48.2230308652,
                                "lng": 17.9265090823
                            },
                            {
                                "lat": 48.2229631394,
                                "lng": 17.9265573621
                            },
                            {
                                "lat": 48.2228806615,
                                "lng": 17.9266029596
                            },
                            {
                                "lat": 48.2228008658,
                                "lng": 17.9266566038
                            },
                            {
                                "lat": 48.2227022946,
                                "lng": 17.9267156124
                            },
                            {
                                "lat": 48.22262384,
                                "lng": 17.9267907143
                            },
                            {
                                "lat": 48.2225232571,
                                "lng": 17.9268363118
                            },
                            {
                                "lat": 48.2224448025,
                                "lng": 17.9268819094
                            },
                            {
                                "lat": 48.2223469019,
                                "lng": 17.9269301891
                            },
                            {
                                "lat": 48.2222805172,
                                "lng": 17.9269731045
                            },
                            {
                                "lat": 48.2221732289,
                                "lng": 17.9270321131
                            },
                            {
                                "lat": 48.2220947742,
                                "lng": 17.9270642996
                            },
                            {
                                "lat": 48.2220055908,
                                "lng": 17.927120626
                            },
                            {
                                "lat": 48.22193183,
                                "lng": 17.9271554947
                            },
                            {
                                "lat": 48.2218144834,
                                "lng": 17.9272252321
                            },
                            {
                                "lat": 48.2217320055,
                                "lng": 17.9272708297
                            },
                            {
                                "lat": 48.2216729969,
                                "lng": 17.9273083806
                            },
                            {
                                "lat": 48.2215958834,
                                "lng": 17.9273432493
                            },
                            {
                                "lat": 48.2215248048,
                                "lng": 17.9273754358
                            },
                            {
                                "lat": 48.2214389741,
                                "lng": 17.9274076223
                            },
                            {
                                "lat": 48.2213585079,
                                "lng": 17.927415669
                            },
                            {
                                "lat": 48.2212585956,
                                "lng": 17.9274237156
                            },
                            {
                                "lat": 48.2211727649,
                                "lng": 17.9274103045
                            },
                            {
                                "lat": 48.2211137563,
                                "lng": 17.9274076223
                            },
                            {
                                "lat": 48.2210420072,
                                "lng": 17.9274022579
                            },
                            {
                                "lat": 48.2209709287,
                                "lng": 17.9273968935
                            },
                            {
                                "lat": 48.2208958268,
                                "lng": 17.9273727536
                            },
                            {
                                "lat": 48.2208153605,
                                "lng": 17.9273593426
                            },
                            {
                                "lat": 48.2207704335,
                                "lng": 17.9273378849
                            },
                            {
                                "lat": 48.220730871,
                                "lng": 17.9272761941
                            },
                            {
                                "lat": 48.2207167894,
                                "lng": 17.9272064567
                            },
                            {
                                "lat": 48.2207080722,
                                "lng": 17.9271259904
                            },
                            {
                                "lat": 48.2206953317,
                                "lng": 17.9270455241
                            },
                            {
                                "lat": 48.2206812501,
                                "lng": 17.9269731045
                            },
                            {
                                "lat": 48.2206671685,
                                "lng": 17.9269060493
                            },
                            {
                                "lat": 48.2206363231,
                                "lng": 17.9268148541
                            },
                            {
                                "lat": 48.2206141949,
                                "lng": 17.9267397523
                            },
                            {
                                "lat": 48.2205793262,
                                "lng": 17.9266834259
                            },
                            {
                                "lat": 48.2205417752,
                                "lng": 17.9266244173
                            },
                            {
                                "lat": 48.220506236,
                                "lng": 17.9265466332
                            },
                            {
                                "lat": 48.2204539329,
                                "lng": 17.926466167
                            },
                            {
                                "lat": 48.2204110175,
                                "lng": 17.9264044762
                            },
                            {
                                "lat": 48.2203613967,
                                "lng": 17.9263293743
                            },
                            {
                                "lat": 48.2203057408,
                                "lng": 17.9262676835
                            },
                            {
                                "lat": 48.2202574611,
                                "lng": 17.9262006283
                            },
                            {
                                "lat": 48.2202078402,
                                "lng": 17.9261389375
                            },
                            {
                                "lat": 48.2201649249,
                                "lng": 17.9260638356
                            },
                            {
                                "lat": 48.2201166451,
                                "lng": 17.9259994626
                            },
                            {
                                "lat": 48.2200630009,
                                "lng": 17.9259163141
                            },
                            {
                                "lat": 48.2200073451,
                                "lng": 17.9258626699
                            },
                            {
                                "lat": 48.2199577242,
                                "lng": 17.9257687926
                            },
                            {
                                "lat": 48.2199020684,
                                "lng": 17.925696373
                            },
                            {
                                "lat": 48.2198571414,
                                "lng": 17.9256480932
                            },
                            {
                                "lat": 48.2198088616,
                                "lng": 17.9255756736
                            },
                            {
                                "lat": 48.2197518647,
                                "lng": 17.9255193472
                            },
                            {
                                "lat": 48.2196962088,
                                "lng": 17.9254415631
                            },
                            {
                                "lat": 48.2196304947,
                                "lng": 17.9253852367
                            },
                            {
                                "lat": 48.21956411,
                                "lng": 17.9253235459
                            },
                            {
                                "lat": 48.2195091248,
                                "lng": 17.9252618551
                            },
                            {
                                "lat": 48.2194514573,
                                "lng": 17.9252108932
                            },
                            {
                                "lat": 48.2193857431,
                                "lng": 17.9251518846
                            },
                            {
                                "lat": 48.2193227112,
                                "lng": 17.9250687361
                            },
                            {
                                "lat": 48.2192442566,
                                "lng": 17.9249721766
                            },
                            {
                                "lat": 48.2191979885,
                                "lng": 17.9248595238
                            },
                            {
                                "lat": 48.2191584259,
                                "lng": 17.9247844219
                            },
                            {
                                "lat": 48.2191262394,
                                "lng": 17.9246771336
                            },
                            {
                                "lat": 48.2190873474,
                                "lng": 17.9245644808
                            },
                            {
                                "lat": 48.2190316916,
                                "lng": 17.9243981838
                            },
                            {
                                "lat": 48.2189867646,
                                "lng": 17.9242667556
                            },
                            {
                                "lat": 48.2189458609,
                                "lng": 17.9241326451
                            },
                            {
                                "lat": 48.2188942283,
                                "lng": 17.9239931703
                            },
                            {
                                "lat": 48.2188633829,
                                "lng": 17.9238992929
                            },
                            {
                                "lat": 48.2188224792,
                                "lng": 17.9237276316
                            },
                            {
                                "lat": 48.2187741995,
                                "lng": 17.9235801101
                            },
                            {
                                "lat": 48.2187527418,
                                "lng": 17.9234755039
                            },
                            {
                                "lat": 48.2187172025,
                                "lng": 17.9233467579
                            },
                            {
                                "lat": 48.2186816633,
                                "lng": 17.9232394695
                            },
                            {
                                "lat": 48.2186132669,
                                "lng": 17.923078537
                            },
                            {
                                "lat": 48.2185690105,
                                "lng": 17.9228934646
                            },
                            {
                                "lat": 48.2185133547,
                                "lng": 17.9227378964
                            },
                            {
                                "lat": 48.21844697,
                                "lng": 17.9225581884
                            },
                            {
                                "lat": 48.2184007019,
                                "lng": 17.9223811626
                            },
                            {
                                "lat": 48.2183202356,
                                "lng": 17.9221612215
                            },
                            {
                                "lat": 48.2182719558,
                                "lng": 17.9219895601
                            },
                            {
                                "lat": 48.2182129472,
                                "lng": 17.921769619
                            },
                            {
                                "lat": 48.2181505859,
                                "lng": 17.9215791821
                            },
                            {
                                "lat": 48.2181002945,
                                "lng": 17.9214128852
                            },
                            {
                                "lat": 48.2180345803,
                                "lng": 17.9212573171
                            },
                            {
                                "lat": 48.2179614902,
                                "lng": 17.9211339355
                            },
                            {
                                "lat": 48.2178790122,
                                "lng": 17.9210802913
                            },
                            {
                                "lat": 48.2177951932,
                                "lng": 17.921064198
                            },
                            {
                                "lat": 48.2176644355,
                                "lng": 17.9211097956
                            },
                            {
                                "lat": 48.2175537944,
                                "lng": 17.9211714864
                            },
                            {
                                "lat": 48.2174324244,
                                "lng": 17.9212358594
                            },
                            {
                                "lat": 48.2173358649,
                                "lng": 17.9212868214
                            },
                            {
                                "lat": 48.2172124833,
                                "lng": 17.9213404655
                            },
                            {
                                "lat": 48.2170622796,
                                "lng": 17.9214343429
                            },
                            {
                                "lat": 48.2169496268,
                                "lng": 17.921487987
                            },
                            {
                                "lat": 48.2167779654,
                                "lng": 17.9215711355
                            },
                            {
                                "lat": 48.216606304,
                                "lng": 17.9216381907
                            },
                            {
                                "lat": 48.216541931,
                                "lng": 17.9216569662
                            },
                            {
                                "lat": 48.2164205611,
                                "lng": 17.9216971993
                            },
                            {
                                "lat": 48.2162830979,
                                "lng": 17.9217749834
                            },
                            {
                                "lat": 48.2161791623,
                                "lng": 17.9218071699
                            },
                            {
                                "lat": 48.216034323,
                                "lng": 17.9218608141
                            },
                            {
                                "lat": 48.2159505039,
                                "lng": 17.9219278693
                            },
                            {
                                "lat": 48.2158324867,
                                "lng": 17.9219600558
                            },
                            {
                                "lat": 48.215707764,
                                "lng": 17.9220271111
                            },
                            {
                                "lat": 48.2155642658,
                                "lng": 17.9220834374
                            },
                            {
                                "lat": 48.2154361904,
                                "lng": 17.922129035
                            },
                            {
                                "lat": 48.215348348,
                                "lng": 17.9221612215
                            },
                            {
                                "lat": 48.215239048,
                                "lng": 17.9222041368
                            },
                            {
                                "lat": 48.2151445001,
                                "lng": 17.9222470522
                            },
                            {
                                "lat": 48.2150016725,
                                "lng": 17.9223141074
                            },
                            {
                                "lat": 48.2149138302,
                                "lng": 17.9223543406
                            },
                            {
                                "lat": 48.2148266584,
                                "lng": 17.9224133492
                            },
                            {
                                "lat": 48.2146831602,
                                "lng": 17.9224777222
                            },
                            {
                                "lat": 48.2145584375,
                                "lng": 17.9225420952
                            },
                            {
                                "lat": 48.2144370675,
                                "lng": 17.922603786
                            },
                            {
                                "lat": 48.2143063098,
                                "lng": 17.9226735234
                            },
                            {
                                "lat": 48.2141634822,
                                "lng": 17.9227083921
                            },
                            {
                                "lat": 48.2140367478,
                                "lng": 17.9227647185
                            },
                            {
                                "lat": 48.2139683515,
                                "lng": 17.9227942228
                            },
                            {
                                "lat": 48.2138664275,
                                "lng": 17.9228317738
                            },
                            {
                                "lat": 48.2137718797,
                                "lng": 17.9228585958
                            },
                            {
                                "lat": 48.2136733085,
                                "lng": 17.92291224
                            },
                            {
                                "lat": 48.2135935128,
                                "lng": 17.9229417443
                            },
                            {
                                "lat": 48.2134768367,
                                "lng": 17.9229873419
                            },
                            {
                                "lat": 48.2133876532,
                                "lng": 17.923027575
                            },
                            {
                                "lat": 48.213307187,
                                "lng": 17.9230490327
                            },
                            {
                                "lat": 48.2132448256,
                                "lng": 17.9230597615
                            },
                            {
                                "lat": 48.2131804526,
                                "lng": 17.9230597615
                            },
                            {
                                "lat": 48.2131429017,
                                "lng": 17.923027575
                            },
                            {
                                "lat": 48.2130838931,
                                "lng": 17.9229900241
                            },
                            {
                                "lat": 48.2130248845,
                                "lng": 17.9229229689
                            },
                            {
                                "lat": 48.2129685581,
                                "lng": 17.9228505492
                            },
                            {
                                "lat": 48.2129497826,
                                "lng": 17.9227432609
                            },
                            {
                                "lat": 48.21291022,
                                "lng": 17.9226064682
                            },
                            {
                                "lat": 48.2128746808,
                                "lng": 17.9224509001
                            },
                            {
                                "lat": 48.2128445059,
                                "lng": 17.9223543406
                            },
                            {
                                "lat": 48.212826401,
                                "lng": 17.9222524166
                            },
                            {
                                "lat": 48.2127922028,
                                "lng": 17.9222121835
                            },
                            {
                                "lat": 48.2127512991,
                                "lng": 17.9221665859
                            },
                            {
                                "lat": 48.2126902789,
                                "lng": 17.9221692681
                            },
                            {
                                "lat": 48.2126225531,
                                "lng": 17.9222095013
                            },
                            {
                                "lat": 48.2125729322,
                                "lng": 17.9222738743
                            },
                            {
                                "lat": 48.2124884427,
                                "lng": 17.9223248363
                            },
                            {
                                "lat": 48.2124173641,
                                "lng": 17.9223623872
                            },
                            {
                                "lat": 48.2123187929,
                                "lng": 17.9224106669
                            },
                            {
                                "lat": 48.2122275978,
                                "lng": 17.9224696755
                            },
                            {
                                "lat": 48.2121062279,
                                "lng": 17.9225420952
                            },
                            {
                                "lat": 48.2120150328,
                                "lng": 17.9226064682
                            },
                            {
                                "lat": 48.2119325548,
                                "lng": 17.9226574302
                            },
                            {
                                "lat": 48.2118561119,
                                "lng": 17.9227003455
                            },
                            {
                                "lat": 48.2117434591,
                                "lng": 17.9227352142
                            },
                            {
                                "lat": 48.2116502523,
                                "lng": 17.9227754474
                            },
                            {
                                "lat": 48.2115523517,
                                "lng": 17.9228076339
                            },
                            {
                                "lat": 48.2114806026,
                                "lng": 17.9228451848
                            },
                            {
                                "lat": 48.2113927603,
                                "lng": 17.9228881001
                            },
                            {
                                "lat": 48.2112908363,
                                "lng": 17.9229202867
                            },
                            {
                                "lat": 48.2111983001,
                                "lng": 17.922976613
                            },
                            {
                                "lat": 48.2111017406,
                                "lng": 17.9230195284
                            },
                            {
                                "lat": 48.2109998167,
                                "lng": 17.9230222106
                            },
                            {
                                "lat": 48.2109481841,
                                "lng": 17.9230195284
                            },
                            {
                                "lat": 48.2109267265,
                                "lng": 17.9229068756
                            },
                            {
                                "lat": 48.2108408958,
                                "lng": 17.9225581884
                            },
                            {
                                "lat": 48.2106759399,
                                "lng": 17.922064662
                            },
                            {
                                "lat": 48.2105331123,
                                "lng": 17.9216784239
                            },
                            {
                                "lat": 48.2104224712,
                                "lng": 17.9212331772
                            },
                            {
                                "lat": 48.2103151828,
                                "lng": 17.9209971428
                            },
                            {
                                "lat": 48.2101435214,
                                "lng": 17.9204767942
                            },
                            {
                                "lat": 48.2100080699,
                                "lng": 17.9199939966
                            },
                            {
                                "lat": 48.2098719478,
                                "lng": 17.9195165634
                            },
                            {
                                "lat": 48.2097646594,
                                "lng": 17.9191839695
                            },
                            {
                                "lat": 48.2096359134,
                                "lng": 17.9188030958
                            },
                            {
                                "lat": 48.2095178962,
                                "lng": 17.9184275866
                            },
                            {
                                "lat": 48.2093857974,
                                "lng": 17.9179823399
                            },
                            {
                                "lat": 48.209278509,
                                "lng": 17.9176604748
                            },
                            {
                                "lat": 48.2092034072,
                                "lng": 17.9175853729
                            },
                            {
                                "lat": 48.20908539,
                                "lng": 17.9174619913
                            },
                            {
                                "lat": 48.2089566439,
                                "lng": 17.9172581434
                            },
                            {
                                "lat": 48.2087246329,
                                "lng": 17.9169684649
                            },
                            {
                                "lat": 48.208520785,
                                "lng": 17.9166787863
                            },
                            {
                                "lat": 48.208309561,
                                "lng": 17.9163998365
                            },
                            {
                                "lat": 48.2081452757,
                                "lng": 17.9162657261
                            },
                            {
                                "lat": 48.2079843432,
                                "lng": 17.9160887003
                            },
                            {
                                "lat": 48.2078448683,
                                "lng": 17.9158526659
                            },
                            {
                                "lat": 48.2076698542,
                                "lng": 17.915584445
                            },
                            {
                                "lat": 48.207366094,
                                "lng": 17.9152518511
                            },
                            {
                                "lat": 48.2071796805,
                                "lng": 17.914994359
                            },
                            {
                                "lat": 48.2069939375,
                                "lng": 17.9147797823
                            },
                            {
                                "lat": 48.2068618387,
                                "lng": 17.9146081209
                            },
                            {
                                "lat": 48.2066150755,
                                "lng": 17.9142433405
                            },
                            {
                                "lat": 48.2064574957,
                                "lng": 17.9140770435
                            },
                            {
                                "lat": 48.2062362134,
                                "lng": 17.9137659073
                            },
                            {
                                "lat": 48.2060397416,
                                "lng": 17.9135191441
                            },
                            {
                                "lat": 48.2058573514,
                                "lng": 17.9132992029
                            },
                            {
                                "lat": 48.2056535035,
                                "lng": 17.9130363464
                            },
                            {
                                "lat": 48.2053960115,
                                "lng": 17.9126608372
                            },
                            {
                                "lat": 48.2051707059,
                                "lng": 17.912376523
                            },
                            {
                                "lat": 48.2049561292,
                                "lng": 17.9121404886
                            },
                            {
                                "lat": 48.2047630101,
                                "lng": 17.9119098186
                            },
                            {
                                "lat": 48.2045665383,
                                "lng": 17.9116469622
                            },
                            {
                                "lat": 48.2043016702,
                                "lng": 17.9112714529
                            },
                            {
                                "lat": 48.2040482014,
                                "lng": 17.9109656811
                            },
                            {
                                "lat": 48.2038624585,
                                "lng": 17.9107618332
                            },
                            {
                                "lat": 48.2036371529,
                                "lng": 17.910477519
                            },
                            {
                                "lat": 48.2034400105,
                                "lng": 17.9101449251
                            },
                            {
                                "lat": 48.2032220811,
                                "lng": 17.9099142551
                            },
                            {
                                "lat": 48.2029692829,
                                "lng": 17.9095990956
                            },
                            {
                                "lat": 48.2027821988,
                                "lng": 17.9092919827
                            },
                            {
                                "lat": 48.2025890797,
                                "lng": 17.9090934992
                            },
                            {
                                "lat": 48.202438876,
                                "lng": 17.9089057446
                            },
                            {
                                "lat": 48.2021532208,
                                "lng": 17.9085355997
                            },
                            {
                                "lat": 48.2019352913,
                                "lng": 17.9082405567
                            },
                            {
                                "lat": 48.2016134262,
                                "lng": 17.9078382254
                            },
                            {
                                "lat": 48.2013043016,
                                "lng": 17.9074573517
                            },
                            {
                                "lat": 48.2010877132,
                                "lng": 17.9071462154
                            },
                            {
                                "lat": 48.2008731365,
                                "lng": 17.9068726301
                            },
                            {
                                "lat": 48.2006337494,
                                "lng": 17.9065561295
                            },
                            {
                                "lat": 48.2004547119,
                                "lng": 17.9063683748
                            },
                            {
                                "lat": 48.200315237,
                                "lng": 17.9061484337
                            },
                            {
                                "lat": 48.2000362873,
                                "lng": 17.9058694839
                            },
                            {
                                "lat": 48.1998505443,
                                "lng": 17.9056227207
                            },
                            {
                                "lat": 48.1995856762,
                                "lng": 17.9053330421
                            },
                            {
                                "lat": 48.1993429363,
                                "lng": 17.9050219059
                            },
                            {
                                "lat": 48.1991424412,
                                "lng": 17.9047858715
                            },
                            {
                                "lat": 48.1988997012,
                                "lng": 17.9045283794
                            },
                            {
                                "lat": 48.1985771656,
                                "lng": 17.9041340947
                            },
                            {
                                "lat": 48.1983632594,
                                "lng": 17.9039061069
                            },
                            {
                                "lat": 48.1981768459,
                                "lng": 17.903637886
                            },
                            {
                                "lat": 48.1979555637,
                                "lng": 17.9034340382
                            },
                            {
                                "lat": 48.1977698207,
                                "lng": 17.9031550884
                            },
                            {
                                "lat": 48.197555244,
                                "lng": 17.9029405117
                            },
                            {
                                "lat": 48.1973621249,
                                "lng": 17.902661562
                            },
                            {
                                "lat": 48.1971971691,
                                "lng": 17.9024791718
                            },
                            {
                                "lat": 48.1970831752,
                                "lng": 17.9026508331
                            },
                            {
                                "lat": 48.1969470531,
                                "lng": 17.9028975964
                            },
                            {
                                "lat": 48.1968578696,
                                "lng": 17.9030612111
                            },
                            {
                                "lat": 48.1967485696,
                                "lng": 17.9032301903
                            },
                            {
                                "lat": 48.1966325641,
                                "lng": 17.9033911228
                            },
                            {
                                "lat": 48.1965500861,
                                "lng": 17.9035440087
                            },
                            {
                                "lat": 48.1964146346,
                                "lng": 17.9037451744
                            },
                            {
                                "lat": 48.1963127106,
                                "lng": 17.903932929
                            },
                            {
                                "lat": 48.196208775,
                                "lng": 17.9040965438
                            },
                            {
                                "lat": 48.1961155683,
                                "lng": 17.9042172432
                            },
                            {
                                "lat": 48.1960190088,
                                "lng": 17.9043620825
                            },
                            {
                                "lat": 48.1959331781,
                                "lng": 17.9045310616
                            },
                            {
                                "lat": 48.1958567351,
                                "lng": 17.9046544433
                            },
                            {
                                "lat": 48.1957561523,
                                "lng": 17.9048421979
                            },
                            {
                                "lat": 48.1956810504,
                                "lng": 17.9050004482
                            },
                            {
                                "lat": 48.1955811381,
                                "lng": 17.9051989317
                            },
                            {
                                "lat": 48.195470497,
                                "lng": 17.9054510593
                            },
                            {
                                "lat": 48.1953591853,
                                "lng": 17.9056683183
                            },
                            {
                                "lat": 48.195251897,
                                "lng": 17.9058989882
                            },
                            {
                                "lat": 48.1951090693,
                                "lng": 17.906177938
                            },
                            {
                                "lat": 48.1949984282,
                                "lng": 17.9064702988
                            },
                            {
                                "lat": 48.1949125975,
                                "lng": 17.906652689
                            },
                            {
                                "lat": 48.1948442012,
                                "lng": 17.9068136215
                            },
                            {
                                "lat": 48.1947690994,
                                "lng": 17.9069557786
                            },
                            {
                                "lat": 48.1946926564,
                                "lng": 17.9071193933
                            },
                            {
                                "lat": 48.1946142018,
                                "lng": 17.9072749615
                            },
                            {
                                "lat": 48.1945283711,
                                "lng": 17.9074841738
                            },
                            {
                                "lat": 48.1944425404,
                                "lng": 17.9076558352
                            },
                            {
                                "lat": 48.1943513453,
                                "lng": 17.9078891873
                            },
                            {
                                "lat": 48.1942688674,
                                "lng": 17.9080340266
                            },
                            {
                                "lat": 48.1942132115,
                                "lng": 17.9081600904
                            },
                            {
                                "lat": 48.1941327453,
                                "lng": 17.9083424807
                            },
                            {
                                "lat": 48.1940683722,
                                "lng": 17.9085168242
                            },
                            {
                                "lat": 48.1939972937,
                                "lng": 17.9086455703
                            },
                            {
                                "lat": 48.1939288974,
                                "lng": 17.9087984562
                            },
                            {
                                "lat": 48.19384709,
                                "lng": 17.9089647532
                            },
                            {
                                "lat": 48.1937753409,
                                "lng": 17.9091364145
                            },
                            {
                                "lat": 48.1937324256,
                                "lng": 17.9092437029
                            },
                            {
                                "lat": 48.1936573237,
                                "lng": 17.9093563557
                            },
                            {
                                "lat": 48.1935426593,
                                "lng": 17.9094958305
                            },
                            {
                                "lat": 48.1934568286,
                                "lng": 17.9095977545
                            },
                            {
                                "lat": 48.1933602691,
                                "lng": 17.9096728563
                            },
                            {
                                "lat": 48.1932462752,
                                "lng": 17.9097425938
                            },
                            {
                                "lat": 48.1931497157,
                                "lng": 17.9098552465
                            },
                            {
                                "lat": 48.1930531561,
                                "lng": 17.9099142551
                            },
                            {
                                "lat": 48.1929244101,
                                "lng": 17.9100269079
                            },
                            {
                                "lat": 48.1927701831,
                                "lng": 17.9101234674
                            },
                            {
                                "lat": 48.1926628947,
                                "lng": 17.9102253914
                            },
                            {
                                "lat": 48.1925522536,
                                "lng": 17.9103541374
                            },
                            {
                                "lat": 48.1924342364,
                                "lng": 17.9104560614
                            },
                            {
                                "lat": 48.1923484057,
                                "lng": 17.9105579853
                            },
                            {
                                "lat": 48.1922592223,
                                "lng": 17.9106706381
                            },
                            {
                                "lat": 48.1921264529,
                                "lng": 17.9108315706
                            },
                            {
                                "lat": 48.1920406222,
                                "lng": 17.9109710455
                            },
                            {
                                "lat": 48.1919547915,
                                "lng": 17.9111158848
                            },
                            {
                                "lat": 48.1918119639,
                                "lng": 17.9112607241
                            },
                            {
                                "lat": 48.1916691363,
                                "lng": 17.9114162922
                            },
                            {
                                "lat": 48.1915866584,
                                "lng": 17.9115450382
                            },
                            {
                                "lat": 48.1914579123,
                                "lng": 17.9116845131
                            },
                            {
                                "lat": 48.1913754344,
                                "lng": 17.9118186235
                            },
                            {
                                "lat": 48.1912614405,
                                "lng": 17.911952734
                            },
                            {
                                "lat": 48.1911501288,
                                "lng": 17.9121619463
                            },
                            {
                                "lat": 48.1910073012,
                                "lng": 17.9124033451
                            },
                            {
                                "lat": 48.190914765,
                                "lng": 17.9125481844
                            },
                            {
                                "lat": 48.1907967478,
                                "lng": 17.9127037525
                            },
                            {
                                "lat": 48.1907068938,
                                "lng": 17.9128646851
                            },
                            {
                                "lat": 48.1905962527,
                                "lng": 17.9130470753
                            },
                            {
                                "lat": 48.1905285269,
                                "lng": 17.9131919146
                            },
                            {
                                "lat": 48.1904064864,
                                "lng": 17.9133743048
                            },
                            {
                                "lat": 48.1902891397,
                                "lng": 17.9135553539
                            },
                            {
                                "lat": 48.1902422011,
                                "lng": 17.9136532545
                            },
                            {
                                "lat": 48.1901563704,
                                "lng": 17.9137927294
                            },
                            {
                                "lat": 48.1900457293,
                                "lng": 17.9139858484
                            },
                            {
                                "lat": 48.1899062544,
                                "lng": 17.9141950607
                            },
                            {
                                "lat": 48.1897882372,
                                "lng": 17.9143667221
                            },
                            {
                                "lat": 48.1897164881,
                                "lng": 17.9144847393
                            },
                            {
                                "lat": 48.1896125525,
                                "lng": 17.9146510363
                            },
                            {
                                "lat": 48.1895092875,
                                "lng": 17.9148226976
                            },
                            {
                                "lat": 48.1893590838,
                                "lng": 17.915058732
                            },
                            {
                                "lat": 48.1892873347,
                                "lng": 17.9152143002
                            },
                            {
                                "lat": 48.1892336905,
                                "lng": 17.9153805971
                            },
                            {
                                "lat": 48.189201504,
                                "lng": 17.9154396057
                            },
                            {
                                "lat": 48.1891264021,
                                "lng": 17.9155683517
                            },
                            {
                                "lat": 48.1890405715,
                                "lng": 17.9157346487
                            },
                            {
                                "lat": 48.188925907,
                                "lng": 17.9159224033
                            },
                            {
                                "lat": 48.1888508052,
                                "lng": 17.9160565138
                            },
                            {
                                "lat": 48.1887542456,
                                "lng": 17.9161638021
                            },
                            {
                                "lat": 48.1886254996,
                                "lng": 17.9163354635
                            },
                            {
                                "lat": 48.1885329634,
                                "lng": 17.9164159298
                            },
                            {
                                "lat": 48.188400194,
                                "lng": 17.9165446758
                            },
                            {
                                "lat": 48.188271448,
                                "lng": 17.9167217016
                            },
                            {
                                "lat": 48.1881782413,
                                "lng": 17.9168128967
                            },
                            {
                                "lat": 48.1880642474,
                                "lng": 17.916957736
                            },
                            {
                                "lat": 48.1879247725,
                                "lng": 17.9171454906
                            },
                            {
                                "lat": 48.1877886504,
                                "lng": 17.9173386097
                            },
                            {
                                "lat": 48.1877028197,
                                "lng": 17.9174727201
                            },
                            {
                                "lat": 48.1875311583,
                                "lng": 17.9176926613
                            },
                            {
                                "lat": 48.1873950362,
                                "lng": 17.9178482294
                            },
                            {
                                "lat": 48.1872555614,
                                "lng": 17.918035984
                            },
                            {
                                "lat": 48.1871127337,
                                "lng": 17.9182130098
                            },
                            {
                                "lat": 48.1869699061,
                                "lng": 17.9183524847
                            },
                            {
                                "lat": 48.1867834926,
                                "lng": 17.9185335338
                            },
                            {
                                "lat": 48.186648041,
                                "lng": 17.918690443
                            },
                            {
                                "lat": 48.1865152717,
                                "lng": 17.9188138247
                            },
                            {
                                "lat": 48.1863690913,
                                "lng": 17.9189908504
                            },
                            {
                                "lat": 48.1861685961,
                                "lng": 17.9191946983
                            },
                            {
                                "lat": 48.1860613078,
                                "lng": 17.9192698002
                            },
                            {
                                "lat": 48.1859003752,
                                "lng": 17.9194521904
                            },
                            {
                                "lat": 48.185774982,
                                "lng": 17.9196131229
                            },
                            {
                                "lat": 48.185589239,
                                "lng": 17.9198330641
                            },
                            {
                                "lat": 48.1854283065,
                                "lng": 17.9199886322
                            },
                            {
                                "lat": 48.1853243709,
                                "lng": 17.9201066494
                            },
                            {
                                "lat": 48.1851634383,
                                "lng": 17.9203212261
                            },
                            {
                                "lat": 48.1850206107,
                                "lng": 17.9204660654
                            },
                            {
                                "lat": 48.1849025935,
                                "lng": 17.9206055403
                            },
                            {
                                "lat": 48.1847450137,
                                "lng": 17.9207986593
                            },
                            {
                                "lat": 48.1845733523,
                                "lng": 17.9210025072
                            },
                            {
                                "lat": 48.1844908744,
                                "lng": 17.9211473465
                            },
                            {
                                "lat": 48.1843299419,
                                "lng": 17.9213190079
                            },
                            {
                                "lat": 48.1842052191,
                                "lng": 17.9214638472
                            },
                            {
                                "lat": 48.1841120124,
                                "lng": 17.9216247797
                            },
                            {
                                "lat": 48.1840121001,
                                "lng": 17.9217535257
                            },
                            {
                                "lat": 48.1839222461,
                                "lng": 17.9218822718
                            },
                            {
                                "lat": 48.1837901473,
                                "lng": 17.9220968485
                            },
                            {
                                "lat": 48.1836935878,
                                "lng": 17.9222738743
                            },
                            {
                                "lat": 48.1836111099,
                                "lng": 17.9223757982
                            },
                            {
                                "lat": 48.1835574657,
                                "lng": 17.9224938154
                            },
                            {
                                "lat": 48.1834930927,
                                "lng": 17.9226118326
                            },
                            {
                                "lat": 48.1834220141,
                                "lng": 17.922719121
                            }
                        ],
                        position: {lat: 0, lng: 0},
                    },
                    {
                        color: '#574b90',
                        id: 22,
                        type: 'road', // road
                        title: 'Močenok - Nitra',
                        description: '',
                        photo: '',
                        label: '',
                        tags: ['cc1', 'cc2', 'cc3'],
                        path: [
                            {
                                "lat": 48.2930210978,
                                "lng": 18.0594339967
                            },
                            {
                                "lat": 48.2926784456,
                                "lng": 18.0587473512
                            },
                            {
                                "lat": 48.2922787964,
                                "lng": 18.0579319596
                            },
                            {
                                "lat": 48.2921218872,
                                "lng": 18.0575886369
                            },
                            {
                                "lat": 48.2918938994,
                                "lng": 18.0571380258
                            },
                            {
                                "lat": 48.2916934043,
                                "lng": 18.0566874146
                            },
                            {
                                "lat": 48.2914084196,
                                "lng": 18.0562153459
                            },
                            {
                                "lat": 48.2911227643,
                                "lng": 18.0557861924
                            },
                            {
                                "lat": 48.2909940183,
                                "lng": 18.0555716157
                            },
                            {
                                "lat": 48.2908082753,
                                "lng": 18.0553999543
                            },
                            {
                                "lat": 48.2906232029,
                                "lng": 18.0552282929
                            },
                            {
                                "lat": 48.2903945446,
                                "lng": 18.0550137162
                            },
                            {
                                "lat": 48.2902088016,
                                "lng": 18.0546060205
                            },
                            {
                                "lat": 48.2900089771,
                                "lng": 18.0541554093
                            },
                            {
                                "lat": 48.289880231,
                                "lng": 18.0537262559
                            },
                            {
                                "lat": 48.2897380739,
                                "lng": 18.0534043908
                            },
                            {
                                "lat": 48.289552331,
                                "lng": 18.0529752374
                            },
                            {
                                "lat": 48.2894524187,
                                "lng": 18.052803576
                            },
                            {
                                "lat": 48.2893236727,
                                "lng": 18.0522242188
                            },
                            {
                                "lat": 48.2892666757,
                                "lng": 18.0520096421
                            },
                            {
                                "lat": 48.2892264426,
                                "lng": 18.0517964065
                            },
                            {
                                "lat": 48.2890380174,
                                "lng": 18.0511942506
                            },
                            {
                                "lat": 48.2889521867,
                                "lng": 18.0507436395
                            },
                            {
                                "lat": 48.2888951898,
                                "lng": 18.0504003167
                            },
                            {
                                "lat": 48.2887811959,
                                "lng": 18.0503574014
                            },
                            {
                                "lat": 48.2887241989,
                                "lng": 18.0505290627
                            },
                            {
                                "lat": 48.2886242867,
                                "lng": 18.0507007241
                            },
                            {
                                "lat": 48.2885243744,
                                "lng": 18.0509568751
                            },
                            {
                                "lat": 48.2884646952,
                                "lng": 18.0513176322
                            },
                            {
                                "lat": 48.2884526253,
                                "lng": 18.0515804887
                            },
                            {
                                "lat": 48.2883674651,
                                "lng": 18.0517092347
                            },
                            {
                                "lat": 48.2882601768,
                                "lng": 18.0517521501
                            },
                            {
                                "lat": 48.2881602645,
                                "lng": 18.0517843366
                            },
                            {
                                "lat": 48.2880174369,
                                "lng": 18.051687777
                            },
                            {
                                "lat": 48.2878960669,
                                "lng": 18.0516019464
                            },
                            {
                                "lat": 48.287782073,
                                "lng": 18.0515375733
                            },
                            {
                                "lat": 48.2876962423,
                                "lng": 18.051430285
                            },
                            {
                                "lat": 48.2876459509,
                                "lng": 18.0513122678
                            },
                            {
                                "lat": 48.2875788957,
                                "lng": 18.05108428
                            },
                            {
                                "lat": 48.2875815779,
                                "lng": 18.0508227646
                            },
                            {
                                "lat": 48.2876499742,
                                "lng": 18.0505947769
                            },
                            {
                                "lat": 48.2876969129,
                                "lng": 18.0503721535
                            },
                            {
                                "lat": 48.2877653092,
                                "lng": 18.0500891805
                            },
                            {
                                "lat": 48.2878444344,
                                "lng": 18.0498893559
                            },
                            {
                                "lat": 48.2879322767,
                                "lng": 18.049607724
                            },
                            {
                                "lat": 48.2880301774,
                                "lng": 18.0493274331
                            },
                            {
                                "lat": 48.288096562,
                                "lng": 18.0490779877
                            },
                            {
                                "lat": 48.2881636173,
                                "lng": 18.0488486588
                            },
                            {
                                "lat": 48.2882420719,
                                "lng": 18.0485737324
                            },
                            {
                                "lat": 48.288295716,
                                "lng": 18.0483752489
                            },
                            {
                                "lat": 48.2883372903,
                                "lng": 18.0482129753
                            },
                            {
                                "lat": 48.2883614302,
                                "lng": 18.0480748415
                            },
                            {
                                "lat": 48.2883279026,
                                "lng": 18.0478897691
                            },
                            {
                                "lat": 48.28827627,
                                "lng": 18.0476765335
                            },
                            {
                                "lat": 48.2882132381,
                                "lng": 18.0475075543
                            },
                            {
                                "lat": 48.2881622761,
                                "lng": 18.0473506451
                            },
                            {
                                "lat": 48.2881079614,
                                "lng": 18.0471038818
                            },
                            {
                                "lat": 48.2880456001,
                                "lng": 18.0469456315
                            },
                            {
                                "lat": 48.2879818976,
                                "lng": 18.0468168855
                            },
                            {
                                "lat": 48.2878960669,
                                "lng": 18.0466559529
                            },
                            {
                                "lat": 48.2878544927,
                                "lng": 18.0465218425
                            },
                            {
                                "lat": 48.2877921313,
                                "lng": 18.046335429
                            },
                            {
                                "lat": 48.2877438515,
                                "lng": 18.0462133884
                            },
                            {
                                "lat": 48.2877103239,
                                "lng": 18.0460712314
                            },
                            {
                                "lat": 48.2877103239,
                                "lng": 18.0459049344
                            },
                            {
                                "lat": 48.2876244932,
                                "lng": 18.0457654595
                            },
                            {
                                "lat": 48.2875393331,
                                "lng": 18.0456152558
                            },
                            {
                                "lat": 48.2874246687,
                                "lng": 18.0454865098
                            },
                            {
                                "lat": 48.2873750478,
                                "lng": 18.0453899503
                            },
                            {
                                "lat": 48.2872892171,
                                "lng": 18.0452075601
                            },
                            {
                                "lat": 48.2871966809,
                                "lng": 18.0450466275
                            },
                            {
                                "lat": 48.2871148735,
                                "lng": 18.0449071527
                            },
                            {
                                "lat": 48.2870042324,
                                "lng": 18.0447086692
                            },
                            {
                                "lat": 48.2869036496,
                                "lng": 18.0445101857
                            },
                            {
                                "lat": 48.2868077606,
                                "lng": 18.0443425477
                            },
                            {
                                "lat": 48.2867132127,
                                "lng": 18.0441682041
                            },
                            {
                                "lat": 48.2866441458,
                                "lng": 18.0439817905
                            },
                            {
                                "lat": 48.286582455,
                                "lng": 18.0437913537
                            },
                            {
                                "lat": 48.286518082,
                                "lng": 18.0437269807
                            },
                            {
                                "lat": 48.28647919,
                                "lng": 18.0436250567
                            },
                            {
                                "lat": 48.2864181697,
                                "lng": 18.0435338616
                            },
                            {
                                "lat": 48.2863752544,
                                "lng": 18.043474853
                            },
                            {
                                "lat": 48.2863108814,
                                "lng": 18.0434051156
                            },
                            {
                                "lat": 48.2862042636,
                                "lng": 18.0432602763
                            },
                            {
                                "lat": 48.2860258967,
                                "lng": 18.0430456996
                            },
                            {
                                "lat": 48.2859434187,
                                "lng": 18.0429330468
                            },
                            {
                                "lat": 48.2858575881,
                                "lng": 18.0428472161
                            },
                            {
                                "lat": 48.2857865095,
                                "lng": 18.0427238345
                            },
                            {
                                "lat": 48.2856718451,
                                "lng": 18.0425843596
                            },
                            {
                                "lat": 48.2855793089,
                                "lng": 18.0424878001
                            },
                            {
                                "lat": 48.2854975015,
                                "lng": 18.0423805118
                            },
                            {
                                "lat": 48.2854297757,
                                "lng": 18.0422732234
                            },
                            {
                                "lat": 48.2853654027,
                                "lng": 18.0421766639
                            },
                            {
                                "lat": 48.2852614671,
                                "lng": 18.0420640111
                            },
                            {
                                "lat": 48.285176307,
                                "lng": 18.0419781804
                            },
                            {
                                "lat": 48.2850831002,
                                "lng": 18.0418494344
                            },
                            {
                                "lat": 48.2849972695,
                                "lng": 18.041742146
                            },
                            {
                                "lat": 48.2848799229,
                                "lng": 18.0416187644
                            },
                            {
                                "lat": 48.2848189026,
                                "lng": 18.0415222049
                            },
                            {
                                "lat": 48.2847189903,
                                "lng": 18.0414041877
                            },
                            {
                                "lat": 48.2846224308,
                                "lng": 18.0413934588
                            },
                            {
                                "lat": 48.2844977081,
                                "lng": 18.0413559079
                            },
                            {
                                "lat": 48.2843904197,
                                "lng": 18.0413451791
                            },
                            {
                                "lat": 48.2842475921,
                                "lng": 18.0413398147
                            },
                            {
                                "lat": 48.2840906829,
                                "lng": 18.041318357
                            },
                            {
                                "lat": 48.2839518785,
                                "lng": 18.0412915349
                            },
                            {
                                "lat": 48.2838157564,
                                "lng": 18.0412754416
                            },
                            {
                                "lat": 48.2836729288,
                                "lng": 18.041253984
                            },
                            {
                                "lat": 48.2835515589,
                                "lng": 18.0412271619
                            },
                            {
                                "lat": 48.2834053785,
                                "lng": 18.0412110686
                            },
                            {
                                "lat": 48.2832873613,
                                "lng": 18.0411949754
                            },
                            {
                                "lat": 48.2831626385,
                                "lng": 18.041189611
                            },
                            {
                                "lat": 48.2830305398,
                                "lng": 18.0411735177
                            },
                            {
                                "lat": 48.2828662544,
                                "lng": 18.0411413312
                            },
                            {
                                "lat": 48.2826845348,
                                "lng": 18.0411198735
                            },
                            {
                                "lat": 48.2825698704,
                                "lng": 18.0411091447
                            },
                            {
                                "lat": 48.2824592292,
                                "lng": 18.041087687
                            },
                            {
                                "lat": 48.2823345065,
                                "lng": 18.0410662293
                            },
                            {
                                "lat": 48.2821950316,
                                "lng": 18.0410501361
                            },
                            {
                                "lat": 48.2820736617,
                                "lng": 18.041023314
                            },
                            {
                                "lat": 48.2819348574,
                                "lng": 18.041023314
                            },
                            {
                                "lat": 48.2818027586,
                                "lng": 18.0409803987
                            },
                            {
                                "lat": 48.2816706598,
                                "lng": 18.0409643054
                            },
                            {
                                "lat": 48.2815667242,
                                "lng": 18.0409911275
                            },
                            {
                                "lat": 48.2814560831,
                                "lng": 18.0409428477
                            },
                            {
                                "lat": 48.2814064622,
                                "lng": 18.0409267545
                            },
                            {
                                "lat": 48.2813883573,
                                "lng": 18.0406907201
                            },
                            {
                                "lat": 48.2813494653,
                                "lng": 18.0403259397
                            },
                            {
                                "lat": 48.2813347131,
                                "lng": 18.0401059985
                            },
                            {
                                "lat": 48.2813099027,
                                "lng": 18.0399343371
                            },
                            {
                                "lat": 48.2812991738,
                                "lng": 18.0396983027
                            },
                            {
                                "lat": 48.2812817395,
                                "lng": 18.0395051837
                            },
                            {
                                "lat": 48.2812529057,
                                "lng": 18.0393348634
                            },
                            {
                                "lat": 48.281249553,
                                "lng": 18.0391833186
                            },
                            {
                                "lat": 48.2812421769,
                                "lng": 18.0390653014
                            },
                            {
                                "lat": 48.281224072,
                                "lng": 18.0389365554
                            },
                            {
                                "lat": 48.2812173665,
                                "lng": 18.0387917161
                            },
                            {
                                "lat": 48.2812066376,
                                "lng": 18.038636148
                            },
                            {
                                "lat": 48.2811918855,
                                "lng": 18.0385395885
                            },
                            {
                                "lat": 48.2811851799,
                                "lng": 18.0384269357
                            },
                            {
                                "lat": 48.2811851799,
                                "lng": 18.0382713675
                            },
                            {
                                "lat": 48.281167075,
                                "lng": 18.0381426215
                            },
                            {
                                "lat": 48.2811496407,
                                "lng": 18.0380299687
                            },
                            {
                                "lat": 48.281128183,
                                "lng": 18.037879765
                            },
                            {
                                "lat": 48.281128183,
                                "lng": 18.0377027392
                            },
                            {
                                "lat": 48.2811100781,
                                "lng": 18.0375954509
                            },
                            {
                                "lat": 48.2810919732,
                                "lng": 18.0374774337
                            },
                            {
                                "lat": 48.2810919732,
                                "lng": 18.0373433232
                            },
                            {
                                "lat": 48.2810778916,
                                "lng": 18.0371502042
                            },
                            {
                                "lat": 48.2810671628,
                                "lng": 18.0370536447
                            },
                            {
                                "lat": 48.2810564339,
                                "lng": 18.0369409919
                            },
                            {
                                "lat": 48.2810316235,
                                "lng": 18.0368497968
                            },
                            {
                                "lat": 48.2809920609,
                                "lng": 18.0367907882
                            },
                            {
                                "lat": 48.2809491456,
                                "lng": 18.036672771
                            },
                            {
                                "lat": 48.280878067,
                                "lng": 18.0365815759
                            },
                            {
                                "lat": 48.2808170468,
                                "lng": 18.0364313722
                            },
                            {
                                "lat": 48.2807318866,
                                "lng": 18.0363079906
                            },
                            {
                                "lat": 48.2806427032,
                                "lng": 18.0361256003
                            },
                            {
                                "lat": 48.2805676013,
                                "lng": 18.0359968543
                            },
                            {
                                "lat": 48.2804851234,
                                "lng": 18.0358412862
                            },
                            {
                                "lat": 48.2804207504,
                                "lng": 18.0357125401
                            },
                            {
                                "lat": 48.2803422958,
                                "lng": 18.0355623364
                            },
                            {
                                "lat": 48.2802571356,
                                "lng": 18.0354067683
                            },
                            {
                                "lat": 48.2802034914,
                                "lng": 18.0352941155
                            },
                            {
                                "lat": 48.2801605761,
                                "lng": 18.0351868272
                            },
                            {
                                "lat": 48.2801069319,
                                "lng": 18.0351009965
                            },
                            {
                                "lat": 48.2800284773,
                                "lng": 18.0349883437
                            },
                            {
                                "lat": 48.2799674571,
                                "lng": 18.0348542333
                            },
                            {
                                "lat": 48.2798997313,
                                "lng": 18.0347040296
                            },
                            {
                                "lat": 48.2798212767,
                                "lng": 18.0345484614
                            },
                            {
                                "lat": 48.2797642797,
                                "lng": 18.0344304442
                            },
                            {
                                "lat": 48.2796999067,
                                "lng": 18.0343070626
                            },
                            {
                                "lat": 48.279639557,
                                "lng": 18.0342051387
                            },
                            {
                                "lat": 48.2796033472,
                                "lng": 18.0341032147
                            },
                            {
                                "lat": 48.2795570791,
                                "lng": 18.0339691043
                            },
                            {
                                "lat": 48.2794940472,
                                "lng": 18.0338671803
                            },
                            {
                                "lat": 48.279453814,
                                "lng": 18.0337223411
                            },
                            {
                                "lat": 48.2793927938,
                                "lng": 18.0336472392
                            },
                            {
                                "lat": 48.2793217152,
                                "lng": 18.0334863067
                            },
                            {
                                "lat": 48.2792787999,
                                "lng": 18.0334018171
                            },
                            {
                                "lat": 48.2792446017,
                                "lng": 18.0333092809
                            },
                            {
                                "lat": 48.2792177796,
                                "lng": 18.0332583189
                            },
                            {
                                "lat": 48.2791788876,
                                "lng": 18.0331724882
                            },
                            {
                                "lat": 48.2791426778,
                                "lng": 18.0331081152
                            },
                            {
                                "lat": 48.2791111618,
                                "lng": 18.0330437422
                            },
                            {
                                "lat": 48.279074952,
                                "lng": 18.0329605937
                            },
                            {
                                "lat": 48.2790286839,
                                "lng": 18.0328720808
                            },
                            {
                                "lat": 48.2789857686,
                                "lng": 18.0327728391
                            },
                            {
                                "lat": 48.2789448649,
                                "lng": 18.0326870084
                            },
                            {
                                "lat": 48.2789093256,
                                "lng": 18.0325958133
                            },
                            {
                                "lat": 48.2788771391,
                                "lng": 18.0325368047
                            },
                            {
                                "lat": 48.2788449526,
                                "lng": 18.0324670672
                            },
                            {
                                "lat": 48.2788214833,
                                "lng": 18.0323973298
                            },
                            {
                                "lat": 48.278785944,
                                "lng": 18.0323302746
                            },
                            {
                                "lat": 48.278766498,
                                "lng": 18.0322498083
                            },
                            {
                                "lat": 48.2787255943,
                                "lng": 18.0321639776
                            },
                            {
                                "lat": 48.2786913961,
                                "lng": 18.0320674181
                            },
                            {
                                "lat": 48.2786464691,
                                "lng": 18.0319413543
                            },
                            {
                                "lat": 48.2786109298,
                                "lng": 18.0318528414
                            },
                            {
                                "lat": 48.2785827667,
                                "lng": 18.0317482352
                            },
                            {
                                "lat": 48.2785572857,
                                "lng": 18.0316650867
                            },
                            {
                                "lat": 48.2785237581,
                                "lng": 18.0315993726
                            },
                            {
                                "lat": 48.2784989476,
                                "lng": 18.0315041542
                            },
                            {
                                "lat": 48.2784667611,
                                "lng": 18.0313995481
                            },
                            {
                                "lat": 48.2784292102,
                                "lng": 18.0313083529
                            },
                            {
                                "lat": 48.2783883065,
                                "lng": 18.031206429
                            },
                            {
                                "lat": 48.2783507556,
                                "lng": 18.0311192572
                            },
                            {
                                "lat": 48.2783232629,
                                "lng": 18.0310280621
                            },
                            {
                                "lat": 48.2783011347,
                                "lng": 18.0309435725
                            },
                            {
                                "lat": 48.2782702893,
                                "lng": 18.0308657885
                            },
                            {
                                "lat": 48.2782488316,
                                "lng": 18.0307987332
                            },
                            {
                                "lat": 48.2782220095,
                                "lng": 18.0307343602
                            },
                            {
                                "lat": 48.2782005519,
                                "lng": 18.0306592584
                            },
                            {
                                "lat": 48.2781770825,
                                "lng": 18.0305975676
                            },
                            {
                                "lat": 48.2781422138,
                                "lng": 18.0305399001
                            },
                            {
                                "lat": 48.2781093568,
                                "lng": 18.0304741859
                            },
                            {
                                "lat": 48.2781006396,
                                "lng": 18.0304071307
                            },
                            {
                                "lat": 48.2780704647,
                                "lng": 18.0303266644
                            },
                            {
                                "lat": 48.2780449837,
                                "lng": 18.0302274227
                            },
                            {
                                "lat": 48.2780362666,
                                "lng": 18.0301469564
                            },
                            {
                                "lat": 48.2780148089,
                                "lng": 18.0300450325
                            },
                            {
                                "lat": 48.2780114561,
                                "lng": 18.0299699306
                            },
                            {
                                "lat": 48.277996704,
                                "lng": 18.0298921466
                            },
                            {
                                "lat": 48.2779806107,
                                "lng": 18.0298143625
                            },
                            {
                                "lat": 48.2779537886,
                                "lng": 18.029731214
                            },
                            {
                                "lat": 48.2779363543,
                                "lng": 18.0296158791
                            },
                            {
                                "lat": 48.2779343426,
                                "lng": 18.0295085907
                            },
                            {
                                "lat": 48.2779236138,
                                "lng": 18.02942276
                            },
                            {
                                "lat": 48.2779041678,
                                "lng": 18.0293262005
                            },
                            {
                                "lat": 48.2778847218,
                                "lng": 18.029229641
                            },
                            {
                                "lat": 48.2778699696,
                                "lng": 18.0291169882
                            },
                            {
                                "lat": 48.2778545469,
                                "lng": 18.0290257931
                            },
                            {
                                "lat": 48.2778330892,
                                "lng": 18.0289372802
                            },
                            {
                                "lat": 48.2778257132,
                                "lng": 18.0288541317
                            },
                            {
                                "lat": 48.2778076082,
                                "lng": 18.0287897587
                            },
                            {
                                "lat": 48.2778009027,
                                "lng": 18.0287146568
                            },
                            {
                                "lat": 48.2777754217,
                                "lng": 18.0286154151
                            },
                            {
                                "lat": 48.2777579874,
                                "lng": 18.0285349488
                            },
                            {
                                "lat": 48.2777365297,
                                "lng": 18.0284410715
                            },
                            {
                                "lat": 48.2777184248,
                                "lng": 18.028357923
                            },
                            {
                                "lat": 48.2777023315,
                                "lng": 18.028242588
                            },
                            {
                                "lat": 48.2776741683,
                                "lng": 18.0281433463
                            },
                            {
                                "lat": 48.277662769,
                                "lng": 18.0280789733
                            },
                            {
                                "lat": 48.2776151597,
                                "lng": 18.0280400813
                            },
                            {
                                "lat": 48.2775950432,
                                "lng": 18.0279743671
                            },
                            {
                                "lat": 48.2775762677,
                                "lng": 18.0279059708
                            },
                            {
                                "lat": 48.2775494456,
                                "lng": 18.0278214812
                            },
                            {
                                "lat": 48.277527988,
                                "lng": 18.0277383327
                            },
                            {
                                "lat": 48.2775259763,
                                "lng": 18.0276283622
                            },
                            {
                                "lat": 48.2775112242,
                                "lng": 18.0275934935
                            },
                            {
                                "lat": 48.2775004953,
                                "lng": 18.0275371671
                            },
                            {
                                "lat": 48.2774937898,
                                "lng": 18.0274620652
                            },
                            {
                                "lat": 48.2774937898,
                                "lng": 18.0274030566
                            },
                            {
                                "lat": 48.2774917781,
                                "lng": 18.0272904038
                            },
                            {
                                "lat": 48.2774790376,
                                "lng": 18.0271804333
                            },
                            {
                                "lat": 48.2774636149,
                                "lng": 18.0270141363
                            },
                            {
                                "lat": 48.2774683088,
                                "lng": 18.0269390345
                            },
                            {
                                "lat": 48.2774790376,
                                "lng": 18.0268317461
                            },
                            {
                                "lat": 48.2774937898,
                                "lng": 18.0267378688
                            },
                            {
                                "lat": 48.2775045186,
                                "lng": 18.0266332626
                            },
                            {
                                "lat": 48.277521953,
                                "lng": 18.0265259743
                            },
                            {
                                "lat": 48.2775212824,
                                "lng": 18.0264280736
                            },
                            {
                                "lat": 48.2775407284,
                                "lng": 18.0263087153
                            },
                            {
                                "lat": 48.2775514573,
                                "lng": 18.0261974037
                            },
                            {
                                "lat": 48.2775742561,
                                "lng": 18.0260834098
                            },
                            {
                                "lat": 48.2775903493,
                                "lng": 18.0259788036
                            },
                            {
                                "lat": 48.2776051015,
                                "lng": 18.0258835852
                            },
                            {
                                "lat": 48.2776131481,
                                "lng": 18.0258071423
                            },
                            {
                                "lat": 48.2776238769,
                                "lng": 18.0257239938
                            },
                            {
                                "lat": 48.2776480168,
                                "lng": 18.0256301165
                            },
                            {
                                "lat": 48.2776641101,
                                "lng": 18.0255362391
                            },
                            {
                                "lat": 48.2776741683,
                                "lng": 18.0254209042
                            },
                            {
                                "lat": 48.2776540518,
                                "lng": 18.0253243446
                            },
                            {
                                "lat": 48.2776359469,
                                "lng": 18.0252358317
                            },
                            {
                                "lat": 48.2776131481,
                                "lng": 18.0251419544
                            },
                            {
                                "lat": 48.2776004076,
                                "lng": 18.025021255
                            },
                            {
                                "lat": 48.2775702327,
                                "lng": 18.0248992145
                            },
                            {
                                "lat": 48.2775682211,
                                "lng": 18.0247999728
                            },
                            {
                                "lat": 48.2775454223,
                                "lng": 18.0247221887
                            },
                            {
                                "lat": 48.2775299996,
                                "lng": 18.0246336758
                            },
                            {
                                "lat": 48.2775199413,
                                "lng": 18.0245612562
                            },
                            {
                                "lat": 48.2775051892,
                                "lng": 18.02446872
                            },
                            {
                                "lat": 48.2774803787,
                                "lng": 18.0243936181
                            },
                            {
                                "lat": 48.2774817199,
                                "lng": 18.0243104696
                            },
                            {
                                "lat": 48.2774616033,
                                "lng": 18.0242058635
                            },
                            {
                                "lat": 48.2774401456,
                                "lng": 18.0240958929
                            },
                            {
                                "lat": 48.2774220407,
                                "lng": 18.0239644647
                            },
                            {
                                "lat": 48.2774072886,
                                "lng": 18.0238933861
                            },
                            {
                                "lat": 48.2773844898,
                                "lng": 18.0237954855
                            },
                            {
                                "lat": 48.2773596793,
                                "lng": 18.023698926
                            },
                            {
                                "lat": 48.2773328573,
                                "lng": 18.0236265063
                            },
                            {
                                "lat": 48.2773147523,
                                "lng": 18.0235219002
                            },
                            {
                                "lat": 48.2772993296,
                                "lng": 18.0234065652
                            },
                            {
                                "lat": 48.2772704959,
                                "lng": 18.0233234167
                            },
                            {
                                "lat": 48.2772362977,
                                "lng": 18.0232080817
                            },
                            {
                                "lat": 48.2771974057,
                                "lng": 18.0230847001
                            },
                            {
                                "lat": 48.2771598548,
                                "lng": 18.0229827762
                            },
                            {
                                "lat": 48.2771296799,
                                "lng": 18.0229049921
                            },
                            {
                                "lat": 48.2770881057,
                                "lng": 18.0227789283
                            },
                            {
                                "lat": 48.2770565897,
                                "lng": 18.0226823688
                            },
                            {
                                "lat": 48.277027756,
                                "lng": 18.0225804448
                            },
                            {
                                "lat": 48.2769922167,
                                "lng": 18.022467792
                            },
                            {
                                "lat": 48.2769526541,
                                "lng": 18.0223551393
                            },
                            {
                                "lat": 48.2769278437,
                                "lng": 18.022288084
                            },
                            {
                                "lat": 48.2769097388,
                                "lng": 18.0222022533
                            },
                            {
                                "lat": 48.2768795639,
                                "lng": 18.0221110582
                            },
                            {
                                "lat": 48.2768312842,
                                "lng": 18.0219957232
                            },
                            {
                                "lat": 48.2767957449,
                                "lng": 18.0218830705
                            },
                            {
                                "lat": 48.2767615467,
                                "lng": 18.0217704177
                            },
                            {
                                "lat": 48.2767293602,
                                "lng": 18.0216631293
                            },
                            {
                                "lat": 48.2766830921,
                                "lng": 18.0215477943
                            },
                            {
                                "lat": 48.27665627,
                                "lng": 18.0214458704
                            },
                            {
                                "lat": 48.2766240835,
                                "lng": 18.0213412642
                            },
                            {
                                "lat": 48.2765865326,
                                "lng": 18.0212286115
                            },
                            {
                                "lat": 48.2765402645,
                                "lng": 18.0211186409
                            },
                            {
                                "lat": 48.2765188068,
                                "lng": 18.0210274458
                            },
                            {
                                "lat": 48.2764758915,
                                "lng": 18.0209174752
                            },
                            {
                                "lat": 48.276451081,
                                "lng": 18.0208209157
                            },
                            {
                                "lat": 48.2764135301,
                                "lng": 18.0207136273
                            },
                            {
                                "lat": 48.2763833553,
                                "lng": 18.0206143856
                            },
                            {
                                "lat": 48.2763511688,
                                "lng": 18.0205070972
                            },
                            {
                                "lat": 48.2763062418,
                                "lng": 18.02038908
                            },
                            {
                                "lat": 48.2762586325,
                                "lng": 18.0202576518
                            },
                            {
                                "lat": 48.2761902362,
                                "lng": 18.0200511217
                            },
                            {
                                "lat": 48.2761687785,
                                "lng": 18.0199706554
                            },
                            {
                                "lat": 48.2761090994,
                                "lng": 18.0198767781
                            },
                            {
                                "lat": 48.276078254,
                                "lng": 18.0197668076
                            },
                            {
                                "lat": 48.2760413736,
                                "lng": 18.0196689069
                            },
                            {
                                "lat": 48.2760152221,
                                "lng": 18.0195575953
                            },
                            {
                                "lat": 48.2759770006,
                                "lng": 18.0194529891
                            },
                            {
                                "lat": 48.2759367675,
                                "lng": 18.0193671584
                            },
                            {
                                "lat": 48.2759132981,
                                "lng": 18.0192679167
                            },
                            {
                                "lat": 48.275886476,
                                "lng": 18.0191887915
                            },
                            {
                                "lat": 48.2758556306,
                                "lng": 18.0191217363
                            },
                            {
                                "lat": 48.2758388668,
                                "lng": 18.0190372467
                            },
                            {
                                "lat": 48.2758247852,
                                "lng": 18.0189621449
                            },
                            {
                                "lat": 48.2758046687,
                                "lng": 18.018900454
                            },
                            {
                                "lat": 48.2757765055,
                                "lng": 18.0188280344
                            },
                            {
                                "lat": 48.2757476717,
                                "lng": 18.0187287927
                            },
                            {
                                "lat": 48.2757141441,
                                "lng": 18.0186510086
                            },
                            {
                                "lat": 48.2756806165,
                                "lng": 18.0185638368
                            },
                            {
                                "lat": 48.2756604999,
                                "lng": 18.0184954405
                            },
                            {
                                "lat": 48.2756531239,
                                "lng": 18.018425703
                            },
                            {
                                "lat": 48.2756195962,
                                "lng": 18.0183452368
                            },
                            {
                                "lat": 48.2755927742,
                                "lng": 18.0182674527
                            },
                            {
                                "lat": 48.2755672932,
                                "lng": 18.0181896687
                            },
                            {
                                "lat": 48.2755424827,
                                "lng": 18.0181199312
                            },
                            {
                                "lat": 48.2755156606,
                                "lng": 18.0180421472
                            },
                            {
                                "lat": 48.275482133,
                                "lng": 18.017937541
                            },
                            {
                                "lat": 48.2754512876,
                                "lng": 18.0178436637
                            },
                            {
                                "lat": 48.2754191011,
                                "lng": 18.0177175999
                            },
                            {
                                "lat": 48.2753909379,
                                "lng": 18.0175432563
                            },
                            {
                                "lat": 48.2753299177,
                                "lng": 18.017398417
                            },
                            {
                                "lat": 48.2752232999,
                                "lng": 18.0171194673
                            },
                            {
                                "lat": 48.2751119882,
                                "lng": 18.016808331
                            },
                            {
                                "lat": 48.2750409096,
                                "lng": 18.0165991187
                            },
                            {
                                "lat": 48.2749329507,
                                "lng": 18.0163671076
                            },
                            {
                                "lat": 48.2748444378,
                                "lng": 18.0160787702
                            },
                            {
                                "lat": 48.2747733593,
                                "lng": 18.0158641934
                            },
                            {
                                "lat": 48.2747089863,
                                "lng": 18.0156871676
                            },
                            {
                                "lat": 48.2746412605,
                                "lng": 18.0155208707
                            },
                            {
                                "lat": 48.2745768875,
                                "lng": 18.0153438449
                            },
                            {
                                "lat": 48.2745125145,
                                "lng": 18.0151990056
                            },
                            {
                                "lat": 48.2744588703,
                                "lng": 18.0150058866
                            },
                            {
                                "lat": 48.2743837684,
                                "lng": 18.0148074031
                            },
                            {
                                "lat": 48.2743267715,
                                "lng": 18.0146303773
                            },
                            {
                                "lat": 48.2742697746,
                                "lng": 18.0144801736
                            },
                            {
                                "lat": 48.2742020488,
                                "lng": 18.0142977834
                            },
                            {
                                "lat": 48.2741517574,
                                "lng": 18.0141368508
                            },
                            {
                                "lat": 48.2740873843,
                                "lng": 18.0139544606
                            },
                            {
                                "lat": 48.2740122825,
                                "lng": 18.0137827992
                            },
                            {
                                "lat": 48.27394858,
                                "lng": 18.013600409
                            },
                            {
                                "lat": 48.2738593966,
                                "lng": 18.0133590102
                            },
                            {
                                "lat": 48.2737735659,
                                "lng": 18.0131390691
                            },
                            {
                                "lat": 48.2737091929,
                                "lng": 18.0129566789
                            },
                            {
                                "lat": 48.2736448199,
                                "lng": 18.0127850175
                            },
                            {
                                "lat": 48.2735804468,
                                "lng": 18.0125704408
                            },
                            {
                                "lat": 48.2735127211,
                                "lng": 18.0124041438
                            },
                            {
                                "lat": 48.273448348,
                                "lng": 18.0121949315
                            },
                            {
                                "lat": 48.2733732462,
                                "lng": 18.0120125413
                            },
                            {
                                "lat": 48.2733128965,
                                "lng": 18.0118516088
                            },
                            {
                                "lat": 48.2732451707,
                                "lng": 18.0116638541
                            },
                            {
                                "lat": 48.2731807977,
                                "lng": 18.0114921927
                            },
                            {
                                "lat": 48.2731305063,
                                "lng": 18.011341989
                            },
                            {
                                "lat": 48.2730627805,
                                "lng": 18.0111381412
                            },
                            {
                                "lat": 48.2729950547,
                                "lng": 18.0109611154
                            },
                            {
                                "lat": 48.2729487866,
                                "lng": 18.0108699203
                            },
                            {
                                "lat": 48.2728381455,
                                "lng": 18.0107679963
                            },
                            {
                                "lat": 48.272748962,
                                "lng": 18.0106714368
                            },
                            {
                                "lat": 48.2726483792,
                                "lng": 18.0105426908
                            },
                            {
                                "lat": 48.2725665718,
                                "lng": 18.0103871226
                            },
                            {
                                "lat": 48.2724807411,
                                "lng": 18.0102422833
                            },
                            {
                                "lat": 48.2723989338,
                                "lng": 18.0100813508
                            },
                            {
                                "lat": 48.2723486423,
                                "lng": 18.0099901557
                            },
                            {
                                "lat": 48.2722775638,
                                "lng": 18.0098882318
                            },
                            {
                                "lat": 48.2723540068,
                                "lng": 18.0097259581
                            },
                            {
                                "lat": 48.2722520828,
                                "lng": 18.0098077655
                            },
                            {
                                "lat": 48.2721991092,
                                "lng": 18.0097594857
                            },
                            {
                                "lat": 48.2720629871,
                                "lng": 18.0096897483
                            },
                            {
                                "lat": 48.2719556987,
                                "lng": 18.0096361041
                            },
                            {
                                "lat": 48.2718598098,
                                "lng": 18.0095824599
                            },
                            {
                                "lat": 48.271766603,
                                "lng": 18.0095556378
                            },
                            {
                                "lat": 48.2716955245,
                                "lng": 18.0094268918
                            },
                            {
                                "lat": 48.2716385275,
                                "lng": 18.00935179
                            },
                            {
                                "lat": 48.2715667784,
                                "lng": 18.0092284083
                            },
                            {
                                "lat": 48.2714883238,
                                "lng": 18.0091103911
                            },
                            {
                                "lat": 48.271387741,
                                "lng": 18.0089601874
                            },
                            {
                                "lat": 48.2713166624,
                                "lng": 18.0088475347
                            },
                            {
                                "lat": 48.27125296,
                                "lng": 18.0087456107
                            },
                            {
                                "lat": 48.2711812109,
                                "lng": 18.0086275935
                            },
                            {
                                "lat": 48.2711201906,
                                "lng": 18.0085363984
                            },
                            {
                                "lat": 48.271067217,
                                "lng": 18.0084291101
                            },
                            {
                                "lat": 48.2709813863,
                                "lng": 18.008300364
                            },
                            {
                                "lat": 48.2709029317,
                                "lng": 18.0081769824
                            },
                            {
                                "lat": 48.2708244771,
                                "lng": 18.0080321431
                            },
                            {
                                "lat": 48.2707312703,
                                "lng": 18.0079087615
                            },
                            {
                                "lat": 48.2706561685,
                                "lng": 18.0077961087
                            },
                            {
                                "lat": 48.270566985,
                                "lng": 18.0076244473
                            },
                            {
                                "lat": 48.2704744488,
                                "lng": 18.0074849725
                            },
                            {
                                "lat": 48.2704100758,
                                "lng": 18.0073562264
                            },
                            {
                                "lat": 48.2703383267,
                                "lng": 18.0072435737
                            },
                            {
                                "lat": 48.2702531666,
                                "lng": 18.0071121454
                            },
                            {
                                "lat": 48.2701673359,
                                "lng": 18.0069927871
                            },
                            {
                                "lat": 48.2700634003,
                                "lng": 18.0068090558
                            },
                            {
                                "lat": 48.2699567825,
                                "lng": 18.0066373944
                            },
                            {
                                "lat": 48.269842118,
                                "lng": 18.0064496398
                            },
                            {
                                "lat": 48.2696959376,
                                "lng": 18.0062136054
                            },
                            {
                                "lat": 48.2695390284,
                                "lng": 18.0059614778
                            },
                            {
                                "lat": 48.2694746554,
                                "lng": 18.0058756471
                            },
                            {
                                "lat": 48.2693888247,
                                "lng": 18.0057522655
                            },
                            {
                                "lat": 48.2692889124,
                                "lng": 18.0055966973
                            },
                            {
                                "lat": 48.2691957057,
                                "lng": 18.005425036
                            },
                            {
                                "lat": 48.2690743357,
                                "lng": 18.0052748322
                            },
                            {
                                "lat": 48.2689281553,
                                "lng": 18.0050602555
                            },
                            {
                                "lat": 48.2687980682,
                                "lng": 18.0048765242
                            },
                            {
                                "lat": 48.2686518878,
                                "lng": 18.004655242
                            },
                            {
                                "lat": 48.2685566694,
                                "lng": 18.0044916272
                            },
                            {
                                "lat": 48.2683816552,
                                "lng": 18.0041965842
                            },
                            {
                                "lat": 48.2682710141,
                                "lng": 18.0040302873
                            },
                            {
                                "lat": 48.2681818306,
                                "lng": 18.0039337277
                            },
                            {
                                "lat": 48.2680892944,
                                "lng": 18.0037888885
                            },
                            {
                                "lat": 48.2680034637,
                                "lng": 18.0036816001
                            },
                            {
                                "lat": 48.2678887993,
                                "lng": 18.0035421252
                            },
                            {
                                "lat": 48.2677674294,
                                "lng": 18.0033329129
                            },
                            {
                                "lat": 48.2676353306,
                                "lng": 18.0031344295
                            },
                            {
                                "lat": 48.2674925029,
                                "lng": 18.0029466748
                            },
                            {
                                "lat": 48.267371133,
                                "lng": 18.0027160048
                            },
                            {
                                "lat": 48.2672142237,
                                "lng": 18.002512157
                            },
                            {
                                "lat": 48.2670995593,
                                "lng": 18.0023404956
                            },
                            {
                                "lat": 48.2669748366,
                                "lng": 18.0021634698
                            },
                            {
                                "lat": 48.2668353617,
                                "lng": 18.0019435287
                            },
                            {
                                "lat": 48.2666784525,
                                "lng": 18.0017128587
                            },
                            {
                                "lat": 48.266581893,
                                "lng": 18.0015948415
                            },
                            {
                                "lat": 48.2664571702,
                                "lng": 18.001396358
                            },
                            {
                                "lat": 48.2663679868,
                                "lng": 18.0012568831
                            },
                            {
                                "lat": 48.2662714273,
                                "lng": 18.0010959506
                            },
                            {
                                "lat": 48.266171515,
                                "lng": 18.0009457469
                            },
                            {
                                "lat": 48.2660749555,
                                "lng": 18.000806272
                            },
                            {
                                "lat": 48.2659750432,
                                "lng": 18.0006238818
                            },
                            {
                                "lat": 48.2658751309,
                                "lng": 18.0004897714
                            },
                            {
                                "lat": 48.2657966763,
                                "lng": 18.0003878474
                            },
                            {
                                "lat": 48.265696764,
                                "lng": 18.0002269149
                            },
                            {
                                "lat": 48.2656176388,
                                "lng": 18.0003610253
                            },
                            {
                                "lat": 48.2654392719,
                                "lng": 18.0006185174
                            },
                            {
                                "lat": 48.2652642578,
                                "lng": 18.0009135604
                            },
                            {
                                "lat": 48.2651395351,
                                "lng": 18.0010905862
                            },
                            {
                                "lat": 48.2650396228,
                                "lng": 18.0012515187
                            },
                            {
                                "lat": 48.2649142295,
                                "lng": 18.0014660954
                            },
                            {
                                "lat": 48.2647573203,
                                "lng": 18.0016967654
                            },
                            {
                                "lat": 48.2646393031,
                                "lng": 18.0018791556
                            },
                            {
                                "lat": 48.2645326853,
                                "lng": 18.002050817
                            },
                            {
                                "lat": 48.2644106448,
                                "lng": 18.0022224784
                            },
                            {
                                "lat": 48.2643181086,
                                "lng": 18.0023673177
                            },
                            {
                                "lat": 48.2642181963,
                                "lng": 18.0025282502
                            },
                            {
                                "lat": 48.2641430944,
                                "lng": 18.0026462674
                            },
                            {
                                "lat": 48.2640291005,
                                "lng": 18.0028179288
                            },
                            {
                                "lat": 48.2639392465,
                                "lng": 18.0029574037
                            },
                            {
                                "lat": 48.2638225704,
                                "lng": 18.0030781031
                            },
                            {
                                "lat": 48.2637327164,
                                "lng": 18.0032014847
                            },
                            {
                                "lat": 48.2636026293,
                                "lng": 18.0033932626
                            },
                            {
                                "lat": 48.2635181397,
                                "lng": 18.003526032
                            },
                            {
                                "lat": 48.2633940876,
                                "lng": 18.0036588013
                            },
                            {
                                "lat": 48.2633022219,
                                "lng": 18.0038224161
                            },
                            {
                                "lat": 48.2632204145,
                                "lng": 18.0039270222
                            },
                            {
                                "lat": 48.2630869746,
                                "lng": 18.0041348934
                            },
                            {
                                "lat": 48.2629428059,
                                "lng": 18.0043400824
                            },
                            {
                                "lat": 48.262815401,
                                "lng": 18.0045439303
                            },
                            {
                                "lat": 48.2627067715,
                                "lng": 18.0047142506
                            },
                            {
                                "lat": 48.2625626028,
                                "lng": 18.0049288273
                            },
                            {
                                "lat": 48.2624278218,
                                "lng": 18.0051286519
                            },
                            {
                                "lat": 48.2622608542,
                                "lng": 18.0054411292
                            },
                            {
                                "lat": 48.2621790469,
                                "lng": 18.0055698752
                            },
                            {
                                "lat": 48.2620576769,
                                "lng": 18.005746901
                            },
                            {
                                "lat": 48.2619644701,
                                "lng": 18.0058595538
                            },
                            {
                                "lat": 48.2619503886,
                                "lng": 18.0058863759
                            },
                            {
                                "lat": 48.2619255781,
                                "lng": 18.0058166385
                            },
                            {
                                "lat": 48.2618317008,
                                "lng": 18.0057120323
                            },
                            {
                                "lat": 48.2616962492,
                                "lng": 18.0055685341
                            },
                            {
                                "lat": 48.2615017891,
                                "lng": 18.0052989721
                            },
                            {
                                "lat": 48.2613227516,
                                "lng": 18.0050052702
                            },
                            {
                                "lat": 48.2611826062,
                                "lng": 18.0047826469
                            },
                            {
                                "lat": 48.261064589,
                                "lng": 18.0045466125
                            },
                            {
                                "lat": 48.2609271258,
                                "lng": 18.0043253303
                            },
                            {
                                "lat": 48.2608030736,
                                "lng": 18.0041697621
                            },
                            {
                                "lat": 48.2606635988,
                                "lng": 18.0039511621
                            },
                            {
                                "lat": 48.2605100423,
                                "lng": 18.0036842823
                            },
                            {
                                "lat": 48.2603618503,
                                "lng": 18.0034817755
                            },
                            {
                                "lat": 48.2602210343,
                                "lng": 18.0032430589
                            },
                            {
                                "lat": 48.2600829005,
                                "lng": 18.0029895902
                            },
                            {
                                "lat": 48.2599340379,
                                "lng": 18.00279513
                            },
                            {
                                "lat": 48.259793222,
                                "lng": 18.0025550723
                            },
                            {
                                "lat": 48.2596537471,
                                "lng": 18.0022975802
                            },
                            {
                                "lat": 48.2594968379,
                                "lng": 18.0020776391
                            },
                            {
                                "lat": 48.259357363,
                                "lng": 18.0018523335
                            },
                            {
                                "lat": 48.2592111826,
                                "lng": 18.0016162992
                            },
                            {
                                "lat": 48.2590542734,
                                "lng": 18.0014124513
                            },
                            {
                                "lat": 48.2589147985,
                                "lng": 18.0011764169
                            },
                            {
                                "lat": 48.2587645948,
                                "lng": 18.0009457469
                            },
                            {
                                "lat": 48.2586184144,
                                "lng": 18.0007150769
                            },
                            {
                                "lat": 48.258472234,
                                "lng": 18.0004897714
                            },
                            {
                                "lat": 48.2583287358,
                                "lng": 18.000253737
                            },
                            {
                                "lat": 48.2581718266,
                                "lng": 18.0000552535
                            },
                            {
                                "lat": 48.2580430806,
                                "lng": 17.9998138547
                            },
                            {
                                "lat": 48.2580001652,
                                "lng": 17.9997012019
                            },
                            {
                                "lat": 48.2579364628,
                                "lng": 17.999561727
                            },
                            {
                                "lat": 48.2578150928,
                                "lng": 17.9994061589
                            },
                            {
                                "lat": 48.2576930523,
                                "lng": 17.9992291331
                            },
                            {
                                "lat": 48.2575468719,
                                "lng": 17.9989930987
                            },
                            {
                                "lat": 48.2574610412,
                                "lng": 17.9988697171
                            },
                            {
                                "lat": 48.2573537529,
                                "lng": 17.9986712337
                            },
                            {
                                "lat": 48.2572149485,
                                "lng": 17.9984566569
                            },
                            {
                                "lat": 48.2570821792,
                                "lng": 17.9982769489
                            },
                            {
                                "lat": 48.2569822669,
                                "lng": 17.9980650544
                            },
                            {
                                "lat": 48.2568930835,
                                "lng": 17.9979684949
                            },
                            {
                                "lat": 48.2568005472,
                                "lng": 17.9978129268
                            },
                            {
                                "lat": 48.2567039877,
                                "lng": 17.9976788163
                            },
                            {
                                "lat": 48.2565933466,
                                "lng": 17.9975286126
                            },
                            {
                                "lat": 48.256489411,
                                "lng": 17.9973837733
                            },
                            {
                                "lat": 48.2563539594,
                                "lng": 17.997238934
                            },
                            {
                                "lat": 48.2562755048,
                                "lng": 17.9971155524
                            },
                            {
                                "lat": 48.2561822981,
                                "lng": 17.9970028996
                            },
                            {
                                "lat": 48.2560609281,
                                "lng": 17.9968687892
                            },
                            {
                                "lat": 48.2559536397,
                                "lng": 17.9967346787
                            },
                            {
                                "lat": 48.2558074594,
                                "lng": 17.9965898395
                            },
                            {
                                "lat": 48.2556894422,
                                "lng": 17.9964664578
                            },
                            {
                                "lat": 48.2555358857,
                                "lng": 17.9963216186
                            },
                            {
                                "lat": 48.2554574311,
                                "lng": 17.9962036014
                            },
                            {
                                "lat": 48.2553219795,
                                "lng": 17.9960748553
                            },
                            {
                                "lat": 48.2552113384,
                                "lng": 17.9959568381
                            },
                            {
                                "lat": 48.2550859451,
                                "lng": 17.99580127
                            },
                            {
                                "lat": 48.2550074905,
                                "lng": 17.9957529902
                            },
                            {
                                "lat": 48.2548787445,
                                "lng": 17.9956188798
                            },
                            {
                                "lat": 48.2547432929,
                                "lng": 17.9954633117
                            },
                            {
                                "lat": 48.2546393573,
                                "lng": 17.9953238368
                            },
                            {
                                "lat": 48.2545179874,
                                "lng": 17.9952165484
                            },
                            {
                                "lat": 48.254371807,
                                "lng": 17.9950931668
                            },
                            {
                                "lat": 48.2542289793,
                                "lng": 17.9949268699
                            },
                            {
                                "lat": 48.2541290671,
                                "lng": 17.9948249459
                            },
                            {
                                "lat": 48.2539969683,
                                "lng": 17.9946961999
                            },
                            {
                                "lat": 48.2538749278,
                                "lng": 17.994594276
                            },
                            {
                                "lat": 48.2537897676,
                                "lng": 17.9944762588
                            },
                            {
                                "lat": 48.2536643744,
                                "lng": 17.9943528771
                            },
                            {
                                "lat": 48.2534719259,
                                "lng": 17.9941597581
                            },
                            {
                                "lat": 48.2532895356,
                                "lng": 17.993966639
                            },
                            {
                                "lat": 48.2531715184,
                                "lng": 17.9938164353
                            },
                            {
                                "lat": 48.2530427724,
                                "lng": 17.9936876893
                            },
                            {
                                "lat": 48.2528932393,
                                "lng": 17.9935267568
                            },
                            {
                                "lat": 48.2527074963,
                                "lng": 17.9933550954
                            },
                            {
                                "lat": 48.2525539398,
                                "lng": 17.9931941628
                            },
                            {
                                "lat": 48.252414465,
                                "lng": 17.9930493236
                            },
                            {
                                "lat": 48.252267614,
                                "lng": 17.992888391
                            },
                            {
                                "lat": 48.2521180809,
                                "lng": 17.9927703738
                            },
                            {
                                "lat": 48.2519645244,
                                "lng": 17.992630899
                            },
                            {
                                "lat": 48.2517821342,
                                "lng": 17.9924592376
                            },
                            {
                                "lat": 48.251664117,
                                "lng": 17.9923412204
                            },
                            {
                                "lat": 48.2515460998,
                                "lng": 17.992233932
                            },
                            {
                                "lat": 48.2513818145,
                                "lng": 17.9920729995
                            },
                            {
                                "lat": 48.2512570918,
                                "lng": 17.9919120669
                            },
                            {
                                "lat": 48.2511068881,
                                "lng": 17.99174577
                            },
                            {
                                "lat": 48.2509714365,
                                "lng": 17.991579473
                            },
                            {
                                "lat": 48.2508889586,
                                "lng": 17.9915204644
                            },
                            {
                                "lat": 48.2507642359,
                                "lng": 17.9913648963
                            },
                            {
                                "lat": 48.2506354898,
                                "lng": 17.9912522435
                            },
                            {
                                "lat": 48.2504926622,
                                "lng": 17.9911234975
                            },
                            {
                                "lat": 48.2503853738,
                                "lng": 17.9909947515
                            },
                            {
                                "lat": 48.2502888143,
                                "lng": 17.9908713698
                            },
                            {
                                "lat": 48.2501714677,
                                "lng": 17.9907694459
                            },
                            {
                                "lat": 48.2500923425,
                                "lng": 17.9906460643
                            },
                            {
                                "lat": 48.2500172406,
                                "lng": 17.9906353354
                            },
                            {
                                "lat": 48.2499173284,
                                "lng": 17.9905763268
                            },
                            {
                                "lat": 48.249835521,
                                "lng": 17.9905226827
                            },
                            {
                                "lat": 48.2497745007,
                                "lng": 17.9903832078
                            },
                            {
                                "lat": 48.24968867,
                                "lng": 17.9902276397
                            },
                            {
                                "lat": 48.2495887578,
                                "lng": 17.9900237918
                            },
                            {
                                "lat": 48.2494459301,
                                "lng": 17.9898253083
                            },
                            {
                                "lat": 48.2493031025,
                                "lng": 17.9896321893
                            },
                            {
                                "lat": 48.2491783798,
                                "lng": 17.9894283414
                            },
                            {
                                "lat": 48.2490496337,
                                "lng": 17.9892298579
                            },
                            {
                                "lat": 48.2489389926,
                                "lng": 17.9890903831
                            },
                            {
                                "lat": 48.2488243282,
                                "lng": 17.9889348149
                            },
                            {
                                "lat": 48.2487277687,
                                "lng": 17.988768518
                            },
                            {
                                "lat": 48.248584941,
                                "lng": 17.9885753989
                            },
                            {
                                "lat": 48.2484602183,
                                "lng": 17.9884037375
                            },
                            {
                                "lat": 48.2483281195,
                                "lng": 17.9882320762
                            },
                            {
                                "lat": 48.2482282072,
                                "lng": 17.9880926013
                            },
                            {
                                "lat": 48.2480954379,
                                "lng": 17.9878780246
                            },
                            {
                                "lat": 48.2480136305,
                                "lng": 17.9877331853
                            },
                            {
                                "lat": 48.2478989661,
                                "lng": 17.9875400662
                            },
                            {
                                "lat": 48.2478030771,
                                "lng": 17.9874166846
                            },
                            {
                                "lat": 48.2476991415,
                                "lng": 17.9872182012
                            },
                            {
                                "lat": 48.2476387918,
                                "lng": 17.9871109128
                            },
                            {
                                "lat": 48.2475777715,
                                "lng": 17.9869821668
                            },
                            {
                                "lat": 48.2475060225,
                                "lng": 17.9868426919
                            },
                            {
                                "lat": 48.2474597543,
                                "lng": 17.9867139459
                            },
                            {
                                "lat": 48.2474242151,
                                "lng": 17.9865905643
                            },
                            {
                                "lat": 48.2473417372,
                                "lng": 17.986445725
                            },
                            {
                                "lat": 48.2472847402,
                                "lng": 17.9863813519
                            },
                            {
                                "lat": 48.2471989095,
                                "lng": 17.9863384366
                            },
                            {
                                "lat": 48.247127831,
                                "lng": 17.9862901568
                            },
                            {
                                "lat": 48.2470560819,
                                "lng": 17.9861345887
                            },
                            {
                                "lat": 48.24698098,
                                "lng": 17.9860004783
                            },
                            {
                                "lat": 48.2469132543,
                                "lng": 17.9858717322
                            },
                            {
                                "lat": 48.2468314469,
                                "lng": 17.9857376218
                            },
                            {
                                "lat": 48.2467241585,
                                "lng": 17.9855337739
                            },
                            {
                                "lat": 48.2466061413,
                                "lng": 17.9853031039
                            },
                            {
                                "lat": 48.2465169579,
                                "lng": 17.9851850867
                            },
                            {
                                "lat": 48.246441856,
                                "lng": 17.9850295186
                            },
                            {
                                "lat": 48.2463486493,
                                "lng": 17.9849007726
                            },
                            {
                                "lat": 48.2462735474,
                                "lng": 17.9847666621
                            },
                            {
                                "lat": 48.2461991161,
                                "lng": 17.9846379161
                            },
                            {
                                "lat": 48.2461059093,
                                "lng": 17.984482348
                            },
                            {
                                "lat": 48.2460200787,
                                "lng": 17.9843375087
                            },
                            {
                                "lat": 48.245959729,
                                "lng": 17.9842087626
                            },
                            {
                                "lat": 48.2458913326,
                                "lng": 17.9840907454
                            },
                            {
                                "lat": 48.2457773387,
                                "lng": 17.9839190841
                            },
                            {
                                "lat": 48.2456915081,
                                "lng": 17.9838171601
                            },
                            {
                                "lat": 48.2456097007,
                                "lng": 17.9836347699
                            },
                            {
                                "lat": 48.2455091178,
                                "lng": 17.983495295
                            },
                            {
                                "lat": 48.2454025,
                                "lng": 17.9833504558
                            },
                            {
                                "lat": 48.2452985644,
                                "lng": 17.9832056165
                            },
                            {
                                "lat": 48.2451738417,
                                "lng": 17.9830929637
                            },
                            {
                                "lat": 48.2450377196,
                                "lng": 17.9829695821
                            },
                            {
                                "lat": 48.2449880987,
                                "lng": 17.9828837514
                            },
                            {
                                "lat": 48.2449411601,
                                "lng": 17.9829695821
                            },
                            {
                                "lat": 48.2448908687,
                                "lng": 17.9825431108
                            },
                            {
                                "lat": 48.244580403,
                                "lng": 17.9820160568
                            },
                            {
                                "lat": 48.2442920655,
                                "lng": 17.9816097021
                            },
                            {
                                "lat": 48.2440104336,
                                "lng": 17.9811604321
                            },
                            {
                                "lat": 48.243734166,
                                "lng": 17.980670929
                            },
                            {
                                "lat": 48.2435142249,
                                "lng": 17.9802002013
                            },
                            {
                                "lat": 48.2431823015,
                                "lng": 17.9798233509
                            },
                            {
                                "lat": 48.2429368794,
                                "lng": 17.9794237018
                            },
                            {
                                "lat": 48.2426914573,
                                "lng": 17.978977114
                            },
                            {
                                "lat": 48.2425633818,
                                "lng": 17.97865659
                            },
                            {
                                "lat": 48.2421999425,
                                "lng": 17.9782837629
                            },
                            {
                                "lat": 48.2420115173,
                                "lng": 17.978053093
                            },
                            {
                                "lat": 48.2418914884,
                                "lng": 17.9778318107
                            },
                            {
                                "lat": 48.2417660952,
                                "lng": 17.9774817824
                            },
                            {
                                "lat": 48.2414938509,
                                "lng": 17.9776480794
                            },
                            {
                                "lat": 48.2413054258,
                                "lng": 17.9778143764
                            },
                            {
                                "lat": 48.2411102951,
                                "lng": 17.9779364169
                            },
                            {
                                "lat": 48.2409218699,
                                "lng": 17.978066504
                            },
                            {
                                "lat": 48.2407461852,
                                "lng": 17.9781925678
                            },
                            {
                                "lat": 48.2405523956,
                                "lng": 17.9783213139
                            },
                            {
                                "lat": 48.2403793931,
                                "lng": 17.9784420133
                            },
                            {
                                "lat": 48.2402647287,
                                "lng": 17.9785385728
                            },
                            {
                                "lat": 48.2401648164,
                                "lng": 17.9786136746
                            },
                            {
                                "lat": 48.2400561869,
                                "lng": 17.9786860943
                            },
                            {
                                "lat": 48.2399596274,
                                "lng": 17.9787585139
                            },
                            {
                                "lat": 48.2398382574,
                                "lng": 17.9788309336
                            },
                            {
                                "lat": 48.2397074997,
                                "lng": 17.9789301753
                            },
                            {
                                "lat": 48.2395626605,
                                "lng": 17.9790320992
                            },
                            {
                                "lat": 48.2394218445,
                                "lng": 17.9791367054
                            },
                            {
                                "lat": 48.23930718,
                                "lng": 17.9792171717
                            },
                            {
                                "lat": 48.2391858101,
                                "lng": 17.9792895913
                            },
                            {
                                "lat": 48.2390805334,
                                "lng": 17.979362011
                            },
                            {
                                "lat": 48.2389551401,
                                "lng": 17.979439795
                            },
                            {
                                "lat": 48.2388753444,
                                "lng": 17.9795122147
                            },
                            {
                                "lat": 48.2387626916,
                                "lng": 17.9795846343
                            },
                            {
                                "lat": 48.2386788726,
                                "lng": 17.9796409607
                            },
                            {
                                "lat": 48.2385803014,
                                "lng": 17.9797026515
                            },
                            {
                                "lat": 48.2384944707,
                                "lng": 17.9797589779
                            },
                            {
                                "lat": 48.2383965701,
                                "lng": 17.9798045754
                            },
                            {
                                "lat": 48.2383067161,
                                "lng": 17.9798313975
                            },
                            {
                                "lat": 48.2382356375,
                                "lng": 17.9798313975
                            },
                            {
                                "lat": 48.2381692529,
                                "lng": 17.9798045754
                            },
                            {
                                "lat": 48.2380928099,
                                "lng": 17.9797455668
                            },
                            {
                                "lat": 48.2380083203,
                                "lng": 17.9796409607
                            },
                            {
                                "lat": 48.2379513234,
                                "lng": 17.9795363545
                            },
                            {
                                "lat": 48.2379137725,
                                "lng": 17.9793915153
                            },
                            {
                                "lat": 48.2378835976,
                                "lng": 17.9792010784
                            },
                            {
                                "lat": 48.2378601283,
                                "lng": 17.9790052772
                            },
                            {
                                "lat": 48.2378353179,
                                "lng": 17.9788202047
                            },
                            {
                                "lat": 48.2378158718,
                                "lng": 17.9786592722
                            },
                            {
                                "lat": 48.2377997786,
                                "lng": 17.9784876108
                            },
                            {
                                "lat": 48.2377622277,
                                "lng": 17.9783186316
                            },
                            {
                                "lat": 48.2377421111,
                                "lng": 17.9781657457
                            },
                            {
                                "lat": 48.2377193123,
                                "lng": 17.9780611396
                            },
                            {
                                "lat": 48.2376945019,
                                "lng": 17.9779216647
                            },
                            {
                                "lat": 48.2376690209,
                                "lng": 17.9777929187
                            },
                            {
                                "lat": 48.2376301289,
                                "lng": 17.9776400328
                            },
                            {
                                "lat": 48.2375885546,
                                "lng": 17.9774442315
                            },
                            {
                                "lat": 48.237541616,
                                "lng": 17.9772953689
                            },
                            {
                                "lat": 48.2375228405,
                                "lng": 17.9771116376
                            },
                            {
                                "lat": 48.2374926656,
                                "lng": 17.9769346118
                            },
                            {
                                "lat": 48.2374618202,
                                "lng": 17.976744175
                            },
                            {
                                "lat": 48.2374423742,
                                "lng": 17.9766047001
                            },
                            {
                                "lat": 48.2374282926,
                                "lng": 17.9764008522
                            },
                            {
                                "lat": 48.2374336571,
                                "lng": 17.9762560129
                            },
                            {
                                "lat": 48.2374101877,
                                "lng": 17.9761353135
                            },
                            {
                                "lat": 48.2373780012,
                                "lng": 17.9759556055
                            },
                            {
                                "lat": 48.2373531908,
                                "lng": 17.9758188128
                            },
                            {
                                "lat": 48.2372975349,
                                "lng": 17.9756337404
                            },
                            {
                                "lat": 48.237259984,
                                "lng": 17.97549963
                            },
                            {
                                "lat": 48.237195611,
                                "lng": 17.9753252864
                            },
                            {
                                "lat": 48.2371406257,
                                "lng": 17.975140214
                            },
                            {
                                "lat": 48.2370977104,
                                "lng": 17.9749765992
                            },
                            {
                                "lat": 48.2370507717,
                                "lng": 17.9747647047
                            },
                            {
                                "lat": 48.2369884104,
                                "lng": 17.9745420814
                            },
                            {
                                "lat": 48.2369562238,
                                "lng": 17.9743516445
                            },
                            {
                                "lat": 48.2369226962,
                                "lng": 17.974190712
                            },
                            {
                                "lat": 48.2368670404,
                                "lng": 17.9739788175
                            },
                            {
                                "lat": 48.2368133962,
                                "lng": 17.9737561941
                            },
                            {
                                "lat": 48.2367778569,
                                "lng": 17.973614037
                            },
                            {
                                "lat": 48.2367134839,
                                "lng": 17.9734262824
                            },
                            {
                                "lat": 48.2366578281,
                                "lng": 17.9732599854
                            },
                            {
                                "lat": 48.2366041839,
                                "lng": 17.9730668664
                            },
                            {
                                "lat": 48.2365632802,
                                "lng": 17.9728683829
                            },
                            {
                                "lat": 48.2364814728,
                                "lng": 17.9726296663
                            },
                            {
                                "lat": 48.2364311814,
                                "lng": 17.9724526405
                            },
                            {
                                "lat": 48.2363580912,
                                "lng": 17.9722461104
                            },
                            {
                                "lat": 48.236316517,
                                "lng": 17.9721039534
                            },
                            {
                                "lat": 48.2362809777,
                                "lng": 17.9719671607
                            },
                            {
                                "lat": 48.236232698,
                                "lng": 17.9718062282
                            },
                            {
                                "lat": 48.2361736894,
                                "lng": 17.971586287
                            },
                            {
                                "lat": 48.2361327857,
                                "lng": 17.9713609815
                            },
                            {
                                "lat": 48.2361026108,
                                "lng": 17.9711732268
                            },
                            {
                                "lat": 48.236066401,
                                "lng": 17.9709774256
                            },
                            {
                                "lat": 48.2360167801,
                                "lng": 17.9707333446
                            },
                            {
                                "lat": 48.2359879464,
                                "lng": 17.9705429077
                            },
                            {
                                "lat": 48.2359544188,
                                "lng": 17.9703766108
                            },
                            {
                                "lat": 48.2359168679,
                                "lng": 17.9701647162
                            },
                            {
                                "lat": 48.2358739525,
                                "lng": 17.9699796438
                            },
                            {
                                "lat": 48.2358149439,
                                "lng": 17.9697704315
                            },
                            {
                                "lat": 48.2357646525,
                                "lng": 17.969507575
                            },
                            {
                                "lat": 48.2357217371,
                                "lng": 17.9693359137
                            },
                            {
                                "lat": 48.2356774807,
                                "lng": 17.9691508412
                            },
                            {
                                "lat": 48.2356325537,
                                "lng": 17.9689764977
                            },
                            {
                                "lat": 48.2355970144,
                                "lng": 17.9688504338
                            },
                            {
                                "lat": 48.2355554402,
                                "lng": 17.9686868191
                            },
                            {
                                "lat": 48.2354863733,
                                "lng": 17.9684427381
                            },
                            {
                                "lat": 48.2354380935,
                                "lng": 17.9682469368
                            },
                            {
                                "lat": 48.2353790849,
                                "lng": 17.9680484533
                            },
                            {
                                "lat": 48.2353106886,
                                "lng": 17.9678204656
                            },
                            {
                                "lat": 48.2352684438,
                                "lng": 17.96759516
                            },
                            {
                                "lat": 48.2351799309,
                                "lng": 17.9673604667
                            },
                            {
                                "lat": 48.2351323217,
                                "lng": 17.9670211673
                            },
                            {
                                "lat": 48.235084042,
                                "lng": 17.9668039083
                            },
                            {
                                "lat": 48.2350022346,
                                "lng": 17.9665356874
                            },
                            {
                                "lat": 48.2348895818,
                                "lng": 17.9662272334
                            },
                            {
                                "lat": 48.2348104566,
                                "lng": 17.9660207033
                            },
                            {
                                "lat": 48.2347393781,
                                "lng": 17.9658275843
                            },
                            {
                                "lat": 48.2346501946,
                                "lng": 17.9656451941
                            },
                            {
                                "lat": 48.2345301658,
                                "lng": 17.9653608799
                            },
                            {
                                "lat": 48.2344657928,
                                "lng": 17.9652133584
                            },
                            {
                                "lat": 48.2343585044,
                                "lng": 17.964963913
                            },
                            {
                                "lat": 48.2342478633,
                                "lng": 17.9646554589
                            },
                            {
                                "lat": 48.234192878,
                                "lng": 17.9644221067
                            },
                            {
                                "lat": 48.234192878,
                                "lng": 17.9642155766
                            },
                            {
                                "lat": 48.2342230529,
                                "lng": 17.9640063643
                            },
                            {
                                "lat": 48.2342854142,
                                "lng": 17.9638132453
                            },
                            {
                                "lat": 48.2344644517,
                                "lng": 17.9634913802
                            },
                            {
                                "lat": 48.2345750928,
                                "lng": 17.9633384943
                            },
                            {
                                "lat": 48.2346642762,
                                "lng": 17.9632017016
                            },
                            {
                                "lat": 48.2347534597,
                                "lng": 17.9630085826
                            },
                            {
                                "lat": 48.2348050922,
                                "lng": 17.9628798366
                            },
                            {
                                "lat": 48.2348285615,
                                "lng": 17.9627403617
                            },
                            {
                                "lat": 48.2348124683,
                                "lng": 17.9625955224
                            },
                            {
                                "lat": 48.2347588241,
                                "lng": 17.9624935985
                            },
                            {
                                "lat": 48.2346515357,
                                "lng": 17.9623112082
                            },
                            {
                                "lat": 48.2345804572,
                                "lng": 17.9621931911
                            },
                            {
                                "lat": 48.2344859093,
                                "lng": 17.9620483518
                            },
                            {
                                "lat": 48.2344000787,
                                "lng": 17.9619061947
                            },
                            {
                                "lat": 48.2343048602,
                                "lng": 17.9617506266
                            },
                            {
                                "lat": 48.2342049479,
                                "lng": 17.9615977407
                            },
                            {
                                "lat": 48.2341211289,
                                "lng": 17.9614636302
                            },
                            {
                                "lat": 48.2340245694,
                                "lng": 17.9612919688
                            },
                            {
                                "lat": 48.2339300215,
                                "lng": 17.9611417651
                            },
                            {
                                "lat": 48.2338569313,
                                "lng": 17.960999608
                            },
                            {
                                "lat": 48.2337959111,
                                "lng": 17.9609003663
                            },
                            {
                                "lat": 48.2336872816,
                                "lng": 17.9607394338
                            },
                            {
                                "lat": 48.2335585356,
                                "lng": 17.9605194926
                            },
                            {
                                "lat": 48.2334438711,
                                "lng": 17.9603210092
                            },
                            {
                                "lat": 48.2333365828,
                                "lng": 17.9601413012
                            },
                            {
                                "lat": 48.2332225889,
                                "lng": 17.9600045085
                            },
                            {
                                "lat": 48.2331173122,
                                "lng": 17.9598328471
                            },
                            {
                                "lat": 48.2330220938,
                                "lng": 17.95969069
                            },
                            {
                                "lat": 48.2329221815,
                                "lng": 17.9595217109
                            },
                            {
                                "lat": 48.2328028232,
                                "lng": 17.9593420029
                            },
                            {
                                "lat": 48.2327008992,
                                "lng": 17.9591622949
                            },
                            {
                                "lat": 48.2326130569,
                                "lng": 17.9590067267
                            },
                            {
                                "lat": 48.2324896753,
                                "lng": 17.95879215
                            },
                            {
                                "lat": 48.2323951274,
                                "lng": 17.9586017132
                            },
                            {
                                "lat": 48.2323522121,
                                "lng": 17.9584756494
                            },
                            {
                                "lat": 48.2323971391,
                                "lng": 17.9583898187
                            },
                            {
                                "lat": 48.2325024158,
                                "lng": 17.9582825303
                            },
                            {
                                "lat": 48.2326452434,
                                "lng": 17.9581323266
                            },
                            {
                                "lat": 48.2327666134,
                                "lng": 17.9579767585
                            },
                            {
                                "lat": 48.2328725606,
                                "lng": 17.9578453302
                            },
                            {
                                "lat": 48.2329557091,
                                "lng": 17.957727313
                            },
                            {
                                "lat": 48.2330670208,
                                "lng": 17.9575690627
                            },
                            {
                                "lat": 48.2331816852,
                                "lng": 17.9573759437
                            },
                            {
                                "lat": 48.233313784,
                                "lng": 17.9572016001
                            },
                            {
                                "lat": 48.2334318012,
                                "lng": 17.9570969939
                            },
                            {
                                "lat": 48.2335478067,
                                "lng": 17.95699507
                            },
                            {
                                "lat": 48.2337033749,
                                "lng": 17.9568073153
                            },
                            {
                                "lat": 48.2339353859,
                                "lng": 17.9564961791
                            },
                            {
                                "lat": 48.234064132,
                                "lng": 17.9562708735
                            },
                            {
                                "lat": 48.2342210412,
                                "lng": 17.9559919238
                            },
                            {
                                "lat": 48.2343866676,
                                "lng": 17.955686152
                            },
                            {
                                "lat": 48.2345858216,
                                "lng": 17.9553481936
                            },
                            {
                                "lat": 48.2347393781,
                                "lng": 17.9550088942
                            },
                            {
                                "lat": 48.2348956168,
                                "lng": 17.9547339678
                            },
                            {
                                "lat": 48.2350793481,
                                "lng": 17.9543785751
                            },
                            {
                                "lat": 48.2352684438,
                                "lng": 17.9541358352
                            },
                            {
                                "lat": 48.2353824377,
                                "lng": 17.953915894
                            },
                            {
                                "lat": 48.2353683561,
                                "lng": 17.9538086057
                            },
                            {
                                "lat": 48.2353683561,
                                "lng": 17.9536423087
                            },
                            {
                                "lat": 48.2353898138,
                                "lng": 17.9533472657
                            },
                            {
                                "lat": 48.2354253531,
                                "lng": 17.9530522227
                            },
                            {
                                "lat": 48.2354072481,
                                "lng": 17.9528322816
                            },
                            {
                                "lat": 48.2354005426,
                                "lng": 17.9526606202
                            },
                            {
                                "lat": 48.2353965193,
                                "lng": 17.9523548484
                            },
                            {
                                "lat": 48.2354608923,
                                "lng": 17.9521563649
                            },
                            {
                                "lat": 48.235507831,
                                "lng": 17.9518452287
                            },
                            {
                                "lat": 48.2355822623,
                                "lng": 17.9515126348
                            },
                            {
                                "lat": 48.2356325537,
                                "lng": 17.9513141513
                            },
                            {
                                "lat": 48.235675469,
                                "lng": 17.9511210322
                            },
                            {
                                "lat": 48.2357076555,
                                "lng": 17.9508689046
                            },
                            {
                                "lat": 48.2357505709,
                                "lng": 17.9506382346
                            },
                            {
                                "lat": 48.2357720286,
                                "lng": 17.9503914714
                            },
                            {
                                "lat": 48.2357505709,
                                "lng": 17.9501768947
                            },
                            {
                                "lat": 48.2356506586,
                                "lng": 17.9499086738
                            },
                            {
                                "lat": 48.2355400175,
                                "lng": 17.949694097
                            },
                            {
                                "lat": 48.2354608923,
                                "lng": 17.9494580626
                            },
                            {
                                "lat": 48.2353824377,
                                "lng": 17.9492542148
                            },
                            {
                                "lat": 48.2352858782,
                                "lng": 17.9489323497
                            },
                            {
                                "lat": 48.2351611555,
                                "lng": 17.9486212134
                            },
                            {
                                "lat": 48.2350478321,
                                "lng": 17.9484213889
                            },
                            {
                                "lat": 48.2350216806,
                                "lng": 17.9481866956
                            },
                            {
                                "lat": 48.2350002229,
                                "lng": 17.9477950931
                            },
                            {
                                "lat": 48.2349968702,
                                "lng": 17.9476073384
                            },
                            {
                                "lat": 48.2349539548,
                                "lng": 17.9473605752
                            },
                            {
                                "lat": 48.2349003106,
                                "lng": 17.9471889138
                            },
                            {
                                "lat": 48.2348392904,
                                "lng": 17.9468938708
                            },
                            {
                                "lat": 48.2347682118,
                                "lng": 17.946523726
                            },
                            {
                                "lat": 48.2347105443,
                                "lng": 17.9462018609
                            },
                            {
                                "lat": 48.2346716523,
                                "lng": 17.9459497333
                            },
                            {
                                "lat": 48.2346535474,
                                "lng": 17.9457995296
                            },
                            {
                                "lat": 48.2346394658,
                                "lng": 17.9455366731
                            },
                            {
                                "lat": 48.2346213609,
                                "lng": 17.9453167319
                            },
                            {
                                "lat": 48.234603256,
                                "lng": 17.9450914264
                            },
                            {
                                "lat": 48.2345858216,
                                "lng": 17.944855392
                            },
                            {
                                "lat": 48.2346106321,
                                "lng": 17.9446569085
                            },
                            {
                                "lat": 48.2345603406,
                                "lng": 17.944265306
                            },
                            {
                                "lat": 48.2345321774,
                                "lng": 17.9440453649
                            },
                            {
                                "lat": 48.2344751805,
                                "lng": 17.9437342286
                            },
                            {
                                "lat": 48.2344463468,
                                "lng": 17.9435732961
                            },
                            {
                                "lat": 48.2344108075,
                                "lng": 17.9433318973
                            },
                            {
                                "lat": 48.2343464345,
                                "lng": 17.9429939389
                            },
                            {
                                "lat": 48.2342713326,
                                "lng": 17.9426988959
                            },
                            {
                                "lat": 48.2342069596,
                                "lng": 17.9425272346
                            },
                            {
                                "lat": 48.234192878,
                                "lng": 17.9423877597
                            },
                            {
                                "lat": 48.2341392338,
                                "lng": 17.9420283437
                            },
                            {
                                "lat": 48.2340279222,
                                "lng": 17.941583097
                            },
                            {
                                "lat": 48.2339856774,
                                "lng": 17.9412558675
                            },
                            {
                                "lat": 48.2339353859,
                                "lng": 17.9408803582
                            },
                            {
                                "lat": 48.2338710129,
                                "lng": 17.9406389594
                            },
                            {
                                "lat": 48.233814016,
                                "lng": 17.940338552
                            },
                            {
                                "lat": 48.2337711006,
                                "lng": 17.9400756955
                            },
                            {
                                "lat": 48.2337100804,
                                "lng": 17.9397538304
                            },
                            {
                                "lat": 48.2336711884,
                                "lng": 17.939453423
                            },
                            {
                                "lat": 48.2336101681,
                                "lng": 17.9392549396
                            },
                            {
                                "lat": 48.2335746288,
                                "lng": 17.9389330745
                            },
                            {
                                "lat": 48.233499527,
                                "lng": 17.9386487603
                            },
                            {
                                "lat": 48.2334599644,
                                "lng": 17.9383483529
                            },
                            {
                                "lat": 48.2333996147,
                                "lng": 17.9380908608
                            },
                            {
                                "lat": 48.2333459705,
                                "lng": 17.9378065467
                            },
                            {
                                "lat": 48.233288303,
                                "lng": 17.9374632239
                            },
                            {
                                "lat": 48.2332313061,
                                "lng": 17.9370072484
                            },
                            {
                                "lat": 48.2331528515,
                                "lng": 17.936706841
                            },
                            {
                                "lat": 48.2331099361,
                                "lng": 17.9363796115
                            },
                            {
                                "lat": 48.233063668,
                                "lng": 17.9361113906
                            },
                            {
                                "lat": 48.2330060005,
                                "lng": 17.9358914495
                            },
                            {
                                "lat": 48.232999295,
                                "lng": 17.935692966
                            },
                            {
                                "lat": 48.2329402864,
                                "lng": 17.9354126751
                            },
                            {
                                "lat": 48.2328987122,
                                "lng": 17.9352369905
                            },
                            {
                                "lat": 48.2328490913,
                                "lng": 17.9348936677
                            },
                            {
                                "lat": 48.2328061759,
                                "lng": 17.9345986247
                            },
                            {
                                "lat": 48.2327666134,
                                "lng": 17.9343464971
                            },
                            {
                                "lat": 48.2327203453,
                                "lng": 17.9341319203
                            },
                            {
                                "lat": 48.2326740772,
                                "lng": 17.9338315129
                            },
                            {
                                "lat": 48.2326023281,
                                "lng": 17.933563292
                            },
                            {
                                "lat": 48.232563436,
                                "lng": 17.9333326221
                            },
                            {
                                "lat": 48.2325164974,
                                "lng": 17.9332467914
                            },
                            {
                                "lat": 48.2324206084,
                                "lng": 17.9331341386
                            },
                            {
                                "lat": 48.2323347777,
                                "lng": 17.9330214858
                            },
                            {
                                "lat": 48.2322127372,
                                "lng": 17.9328766465
                            },
                            {
                                "lat": 48.2321094722,
                                "lng": 17.9327639937
                            },
                            {
                                "lat": 48.231991455,
                                "lng": 17.9325816035
                            },
                            {
                                "lat": 48.2318412513,
                                "lng": 17.9323831201
                            },
                            {
                                "lat": 48.2317735255,
                                "lng": 17.9322972894
                            },
                            {
                                "lat": 48.2319022715,
                                "lng": 17.9321470857
                            }
                        ],
                        position: {lat: 0, lng: 0},
                    },


                ],
                animateMarkerId: null,
                selected_map: null,
            }
        },
        computed: {
            showFilteredItems() {
                return this.items.filter(item => (item.type === 'road' && this.filter.road || item.type === 'point' && this.filter.point) && (this.search.toLowerCase() === '' || item.title.toLowerCase().includes(this.search.toLowerCase())))
                // return this.items.filter(item => (item.type === 'road' && this.filter.road || item.type === 'point' && this.filter.point) && (this.search.toLowerCase() === '' || item.title.includes(this.search.toLowerCase()) || item.title === this.search.toLowerCase() || item.tags.includes(this.search.toLowerCase())))
            },
            displayFilteredItems() {
                return this.showFilteredItems.filter(item => this.selected_map !== null ? item.id === this.selected_map : true)
            }
        },
        methods: {
            rp() {
                this.search = ''
                this.filter = {
                    road: true,
                    point: true
                }
                this.selected_map = null
            },
            fullScreenImage(image) {
                this.image_info = image
            },
            selectMap(id) {
                this.selected_map = this.selected_map === id ? null : id
                this.menu_collapsed = false
            },
            collapseFilterItem(item) {

                if (!this.filter[item]) {
                    this.filter.road = true
                    this.filter.point = true
                    this.selected_map = null
                    return
                }

                if (item === 'road') {

                    if (this.filter.point) {
                        this.filter.point = false
                    }

                    if (!this.filter.road) {
                        this.filter.road = true
                    }

                }

                if (item === 'point') {

                    if (this.filter.road) {
                        this.filter.road = false
                    }

                    if (!this.filter.point) {
                        this.filter.point = true
                    }

                }

            }
        }

    }
</script>